
      var $parcel$global = globalThis;
    /* document-load.ts|js file - the code snippet is the same for both the languages */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $26b92d9057f09375$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $edd92bd5ed3d12cd$export$a4ad2735b021c132 = '1.9.0';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $aeeabfecb8c43ff4$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $aeeabfecb8c43ff4$export$a5733a4d26a1ec61(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match($aeeabfecb8c43ff4$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match($aeeabfecb8c43ff4$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var $aeeabfecb8c43ff4$export$7fc0d8c3ab188c4c = $aeeabfecb8c43ff4$export$a5733a4d26a1ec61((0, $edd92bd5ed3d12cd$export$a4ad2735b021c132));


var $b2d9d13e726c481d$var$major = (0, $edd92bd5ed3d12cd$export$a4ad2735b021c132).split('.')[0];
var $b2d9d13e726c481d$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + $b2d9d13e726c481d$var$major);
var $b2d9d13e726c481d$var$_global = (0, $26b92d9057f09375$export$5c524ddf7208c00c);
function $b2d9d13e726c481d$export$d586ae880b433238(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = $b2d9d13e726c481d$var$_global[$b2d9d13e726c481d$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $b2d9d13e726c481d$var$_global[$b2d9d13e726c481d$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $edd92bd5ed3d12cd$export$a4ad2735b021c132)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $edd92bd5ed3d12cd$export$a4ad2735b021c132)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, $edd92bd5ed3d12cd$export$a4ad2735b021c132));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, $edd92bd5ed3d12cd$export$a4ad2735b021c132) + ".");
    return true;
}
function $b2d9d13e726c481d$export$a4e55266d2135a7f(type) {
    var _a, _b;
    var globalVersion = (_a = $b2d9d13e726c481d$var$_global[$b2d9d13e726c481d$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $aeeabfecb8c43ff4$export$7fc0d8c3ab188c4c)(globalVersion)) return;
    return (_b = $b2d9d13e726c481d$var$_global[$b2d9d13e726c481d$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $b2d9d13e726c481d$export$d42ac835f38d1fb2(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, $edd92bd5ed3d12cd$export$a4ad2735b021c132) + ".");
    var api = $b2d9d13e726c481d$var$_global[$b2d9d13e726c481d$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}


var $0d7e1bd3a658b161$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $0d7e1bd3a658b161$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var $0d7e1bd3a658b161$export$b4bccc12f5b13129 = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $0d7e1bd3a658b161$var$logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $0d7e1bd3a658b161$var$logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $0d7e1bd3a658b161$var$logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $0d7e1bd3a658b161$var$logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $0d7e1bd3a658b161$var$logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}();
function $0d7e1bd3a658b161$var$logProxy(funcName, namespace, args) {
    var logger = (0, $b2d9d13e726c481d$export$a4e55266d2135a7f)('diag');
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, $0d7e1bd3a658b161$var$__spreadArray([], $0d7e1bd3a658b161$var$__read(args), false));
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $042c1418c9626221$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($042c1418c9626221$export$b7d7b4c0f3c95263 || ($042c1418c9626221$export$b7d7b4c0f3c95263 = {}));


function $c8159f058a092f2c$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $042c1418c9626221$export$b7d7b4c0f3c95263).NONE) maxLevel = (0, $042c1418c9626221$export$b7d7b4c0f3c95263).NONE;
    else if (maxLevel > (0, $042c1418c9626221$export$b7d7b4c0f3c95263).ALL) maxLevel = (0, $042c1418c9626221$export$b7d7b4c0f3c95263).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $042c1418c9626221$export$b7d7b4c0f3c95263).ERROR),
        warn: _filterFunc('warn', (0, $042c1418c9626221$export$b7d7b4c0f3c95263).WARN),
        info: _filterFunc('info', (0, $042c1418c9626221$export$b7d7b4c0f3c95263).INFO),
        debug: _filterFunc('debug', (0, $042c1418c9626221$export$b7d7b4c0f3c95263).DEBUG),
        verbose: _filterFunc('verbose', (0, $042c1418c9626221$export$b7d7b4c0f3c95263).VERBOSE)
    };
}




var $515ee5c32a70b2b2$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $515ee5c32a70b2b2$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $515ee5c32a70b2b2$var$API_NAME = 'diag';
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var $515ee5c32a70b2b2$export$5c8937ffc688cfd3 = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, $b2d9d13e726c481d$export$a4e55266d2135a7f)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, $515ee5c32a70b2b2$var$__spreadArray([], $515ee5c32a70b2b2$var$__read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, $042c1418c9626221$export$b7d7b4c0f3c95263).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, $b2d9d13e726c481d$export$a4e55266d2135a7f)('diag');
            var newLogger = (0, $c8159f058a092f2c$export$9a9cc475abb19689)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $042c1418c9626221$export$b7d7b4c0f3c95263).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, $b2d9d13e726c481d$export$d586ae880b433238)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, $b2d9d13e726c481d$export$d42ac835f38d1fb2)($515ee5c32a70b2b2$var$API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, $0d7e1bd3a658b161$export$b4bccc12f5b13129)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $8458c3575773417c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $8458c3575773417c$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $8458c3575773417c$export$b8c511fa1a5f4987 = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = $8458c3575773417c$var$__read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = $8458c3575773417c$var$__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var $47a64c29f401437a$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');


var $36ecce552d4bbf35$var$diag = (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance();
function $36ecce552d4bbf35$export$1034a425c7384452(entries) {
    if (entries === void 0) entries = {};
    return new (0, $8458c3575773417c$export$b8c511fa1a5f4987)(new Map(Object.entries(entries)));
}
function $36ecce552d4bbf35$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $36ecce552d4bbf35$var$diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = '';
    }
    return {
        __TYPE__: (0, $47a64c29f401437a$export$92dd2fe8ddb5cb7),
        toString: function() {
            return str;
        }
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ function $411320e1da10ff3d$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var $411320e1da10ff3d$var$BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var $411320e1da10ff3d$export$78df28f9b2f9a7dc = new $411320e1da10ff3d$var$BaseContext();









/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @deprecated use the one declared in @opentelemetry/sdk-trace-base instead.
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */ var $0cc84bf49b6d9783$export$94df7a7a96a92f7b;
(function(SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */ SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */ SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */ SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})($0cc84bf49b6d9783$export$94df7a7a96a92f7b || ($0cc84bf49b6d9783$export$94df7a7a96a92f7b = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $566044c3d0fbdc36$export$4da4ea8145910e8b;
(function(SpanKind) {
    /** Default value. Indicates that the span is used internally. */ SpanKind[SpanKind["INTERNAL"] = 0] = "INTERNAL";
    /**
     * Indicates that the span covers server-side handling of an RPC or other
     * remote request.
     */ SpanKind[SpanKind["SERVER"] = 1] = "SERVER";
    /**
     * Indicates that the span covers the client-side wrapper around an RPC or
     * other remote request.
     */ SpanKind[SpanKind["CLIENT"] = 2] = "CLIENT";
    /**
     * Indicates that the span describes producer sending a message to a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */ SpanKind[SpanKind["PRODUCER"] = 3] = "PRODUCER";
    /**
     * Indicates that the span describes consumer receiving a message from a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */ SpanKind[SpanKind["CONSUMER"] = 4] = "CONSUMER";
})($566044c3d0fbdc36$export$4da4ea8145910e8b || ($566044c3d0fbdc36$export$4da4ea8145910e8b = {}));


/**
 * An enumeration of status codes.
 */ var $ed982b21ea27c702$export$1e28dd9b5d01db83;
(function(SpanStatusCode) {
    /**
     * The default status.
     */ SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
    /**
     * The operation has been validated by an Application developer or
     * Operator to have completed successfully.
     */ SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
    /**
     * The operation contains an error.
     */ SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
})($ed982b21ea27c702$export$1e28dd9b5d01db83 || ($ed982b21ea27c702$export$1e28dd9b5d01db83 = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $5dcc187a863bca89$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($5dcc187a863bca89$export$bf9049ad2b0883ff || ($5dcc187a863bca89$export$bf9049ad2b0883ff = {}));



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $c0773e3017d46dd4$export$55cc39fb0d4bb4c0 = '0000000000000000';
var $c0773e3017d46dd4$export$22be96e88d95e128 = '00000000000000000000000000000000';
var $c0773e3017d46dd4$export$8591e4c852b66703 = {
    traceId: $c0773e3017d46dd4$export$22be96e88d95e128,
    spanId: $c0773e3017d46dd4$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $5dcc187a863bca89$export$bf9049ad2b0883ff).NONE
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var $751bfb7d16d79d70$export$972d28f7c6a8c6c7 = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, $c0773e3017d46dd4$export$8591e4c852b66703);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function(_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();


var $99a3da0b8477e363$var$VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var $99a3da0b8477e363$var$VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function $99a3da0b8477e363$export$29dd34cf1269f6da(traceId) {
    return $99a3da0b8477e363$var$VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, $c0773e3017d46dd4$export$22be96e88d95e128);
}
function $99a3da0b8477e363$export$8e51c6d8f0586aff(spanId) {
    return $99a3da0b8477e363$var$VALID_SPANID_REGEX.test(spanId) && spanId !== (0, $c0773e3017d46dd4$export$55cc39fb0d4bb4c0);
}
function $99a3da0b8477e363$export$e4373b9a2c09216c(spanContext) {
    return $99a3da0b8477e363$export$29dd34cf1269f6da(spanContext.traceId) && $99a3da0b8477e363$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $99a3da0b8477e363$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $751bfb7d16d79d70$export$972d28f7c6a8c6c7)(spanContext);
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $67daccb289228955$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $67daccb289228955$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $67daccb289228955$export$a27e5df35d1539a6 = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, $411320e1da10ff3d$export$78df28f9b2f9a7dc;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, $67daccb289228955$var$__spreadArray([
            thisArg
        ], $67daccb289228955$var$__read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();




var $8d5128149d5cfd94$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $8d5128149d5cfd94$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $8d5128149d5cfd94$var$API_NAME = 'context';
var $8d5128149d5cfd94$var$NOOP_CONTEXT_MANAGER = new (0, $67daccb289228955$export$a27e5df35d1539a6)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var $8d5128149d5cfd94$export$4148866f0a453927 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, $b2d9d13e726c481d$export$d586ae880b433238)($8d5128149d5cfd94$var$API_NAME, contextManager, (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, $8d5128149d5cfd94$var$__spreadArray([
            context,
            fn,
            thisArg
        ], $8d5128149d5cfd94$var$__read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, $b2d9d13e726c481d$export$a4e55266d2135a7f)($8d5128149d5cfd94$var$API_NAME) || $8d5128149d5cfd94$var$NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, $b2d9d13e726c481d$export$d42ac835f38d1fb2)($8d5128149d5cfd94$var$API_NAME, (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance());
    };
    return ContextAPI;
}();


var $0c57d9262090934c$export$a078c61943f9dbbe = (0, $8d5128149d5cfd94$export$4148866f0a453927).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $0006a4b399ea8ee4$export$c042e7c2f59bc046 = (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $58d90c77e6429fbf$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var $58d90c77e6429fbf$export$c23c6f85dd4fc1e9 = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createGauge}
     */ NoopMeter.prototype.createGauge = function(_name, _options) {
        return $58d90c77e6429fbf$export$dd01300aacbcec1c;
    };
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return $58d90c77e6429fbf$export$689c32a6a552e1a6;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return $58d90c77e6429fbf$export$e6d19fe5233efc54;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return $58d90c77e6429fbf$export$2f189cd99d2b7429;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return $58d90c77e6429fbf$export$ea67e3c6ff624776;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return $58d90c77e6429fbf$export$163422b94c3edbcb;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return $58d90c77e6429fbf$export$5b8be9ab17b673b3;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var $58d90c77e6429fbf$export$834a616d1cf278b = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var $58d90c77e6429fbf$export$b556ba0f560c45b = /** @class */ function(_super) {
    $58d90c77e6429fbf$var$__extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}($58d90c77e6429fbf$export$834a616d1cf278b);
var $58d90c77e6429fbf$export$df09a35db160df98 = /** @class */ function(_super) {
    $58d90c77e6429fbf$var$__extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}($58d90c77e6429fbf$export$834a616d1cf278b);
var $58d90c77e6429fbf$export$b7f4a3c7ea16c24 = /** @class */ function(_super) {
    $58d90c77e6429fbf$var$__extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric;
}($58d90c77e6429fbf$export$834a616d1cf278b);
var $58d90c77e6429fbf$export$ef064c3e0426c607 = /** @class */ function(_super) {
    $58d90c77e6429fbf$var$__extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}($58d90c77e6429fbf$export$834a616d1cf278b);
var $58d90c77e6429fbf$export$a5a3e7829c289482 = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var $58d90c77e6429fbf$export$7a7e4b169d5c93a8 = /** @class */ function(_super) {
    $58d90c77e6429fbf$var$__extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}($58d90c77e6429fbf$export$a5a3e7829c289482);
var $58d90c77e6429fbf$export$6990a2f90809ffc1 = /** @class */ function(_super) {
    $58d90c77e6429fbf$var$__extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}($58d90c77e6429fbf$export$a5a3e7829c289482);
var $58d90c77e6429fbf$export$3ec3555bc6f693a4 = /** @class */ function(_super) {
    $58d90c77e6429fbf$var$__extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}($58d90c77e6429fbf$export$a5a3e7829c289482);
var $58d90c77e6429fbf$export$65e277d35235a01f = new $58d90c77e6429fbf$export$c23c6f85dd4fc1e9();
var $58d90c77e6429fbf$export$e6d19fe5233efc54 = new $58d90c77e6429fbf$export$b556ba0f560c45b();
var $58d90c77e6429fbf$export$dd01300aacbcec1c = new $58d90c77e6429fbf$export$b7f4a3c7ea16c24();
var $58d90c77e6429fbf$export$689c32a6a552e1a6 = new $58d90c77e6429fbf$export$ef064c3e0426c607();
var $58d90c77e6429fbf$export$2f189cd99d2b7429 = new $58d90c77e6429fbf$export$df09a35db160df98();
var $58d90c77e6429fbf$export$163422b94c3edbcb = new $58d90c77e6429fbf$export$7a7e4b169d5c93a8();
var $58d90c77e6429fbf$export$ea67e3c6ff624776 = new $58d90c77e6429fbf$export$6990a2f90809ffc1();
var $58d90c77e6429fbf$export$5b8be9ab17b673b3 = new $58d90c77e6429fbf$export$3ec3555bc6f693a4();
function $58d90c77e6429fbf$export$bc3a498ccbb5c2b5() {
    return $58d90c77e6429fbf$export$65e277d35235a01f;
}


/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var $eb5099a020c5ab24$export$51c513ea08316108 = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, $58d90c77e6429fbf$export$65e277d35235a01f;
    };
    return NoopMeterProvider;
}();
var $eb5099a020c5ab24$export$d21fe83355c56e18 = new $eb5099a020c5ab24$export$51c513ea08316108();




var $e9dac7b9b480fa25$var$API_NAME = 'metrics';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var $e9dac7b9b480fa25$export$1339f6eb6111c638 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, $b2d9d13e726c481d$export$d586ae880b433238)($e9dac7b9b480fa25$var$API_NAME, provider, (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, $b2d9d13e726c481d$export$a4e55266d2135a7f)($e9dac7b9b480fa25$var$API_NAME) || (0, $eb5099a020c5ab24$export$d21fe83355c56e18);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, $b2d9d13e726c481d$export$d42ac835f38d1fb2)($e9dac7b9b480fa25$var$API_NAME, (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance());
    };
    return MetricsAPI;
}();


var $b8db6f384fae8886$export$b0c5c2fac8144e54 = (0, $e9dac7b9b480fa25$export$1339f6eb6111c638).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var $f1e8bb5930fe5111$export$8356c7eb3af7963b = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $53c5756a2197b4fb$export$a0f575f55f38720a = {
    get: function(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var $53c5756a2197b4fb$export$f70f1d111fccf1c1 = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/**
 * Baggage key
 */ var $20f935f8b2b2bb5d$var$BAGGAGE_KEY = (0, $411320e1da10ff3d$export$b8c322c5a7cfce78)('OpenTelemetry Baggage Key');
function $20f935f8b2b2bb5d$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($20f935f8b2b2bb5d$var$BAGGAGE_KEY) || undefined;
}
function $20f935f8b2b2bb5d$export$120a1756099436ee() {
    return $20f935f8b2b2bb5d$export$f3bffa0b5dd10d1e((0, $8d5128149d5cfd94$export$4148866f0a453927).getInstance().active());
}
function $20f935f8b2b2bb5d$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($20f935f8b2b2bb5d$var$BAGGAGE_KEY, baggage);
}
function $20f935f8b2b2bb5d$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($20f935f8b2b2bb5d$var$BAGGAGE_KEY);
}




var $ae331592dad650ec$var$API_NAME = 'propagation';
var $ae331592dad650ec$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $f1e8bb5930fe5111$export$8356c7eb3af7963b)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var $ae331592dad650ec$export$471eda0a6213cac9 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, $36ecce552d4bbf35$export$1034a425c7384452);
        this.getBaggage = (0, $20f935f8b2b2bb5d$export$f3bffa0b5dd10d1e);
        this.getActiveBaggage = (0, $20f935f8b2b2bb5d$export$120a1756099436ee);
        this.setBaggage = (0, $20f935f8b2b2bb5d$export$adc9ca19eab3f500);
        this.deleteBaggage = (0, $20f935f8b2b2bb5d$export$4ca3a8a743c9f633);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, $b2d9d13e726c481d$export$d586ae880b433238)($ae331592dad650ec$var$API_NAME, propagator, (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, $53c5756a2197b4fb$export$f70f1d111fccf1c1);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, $53c5756a2197b4fb$export$a0f575f55f38720a);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, $b2d9d13e726c481d$export$d42ac835f38d1fb2)($ae331592dad650ec$var$API_NAME, (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, $b2d9d13e726c481d$export$a4e55266d2135a7f)($ae331592dad650ec$var$API_NAME) || $ae331592dad650ec$var$NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();


var $77955577000c938d$export$3e49040daa9dba20 = (0, $ae331592dad650ec$export$471eda0a6213cac9).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 


/**
 * span key
 */ var $ead6237849042dac$var$SPAN_KEY = (0, $411320e1da10ff3d$export$b8c322c5a7cfce78)('OpenTelemetry Context Key SPAN');
function $ead6237849042dac$export$246e04ba06066af1(context) {
    return context.getValue($ead6237849042dac$var$SPAN_KEY) || undefined;
}
function $ead6237849042dac$export$1be426a8e585c83e() {
    return $ead6237849042dac$export$246e04ba06066af1((0, $8d5128149d5cfd94$export$4148866f0a453927).getInstance().active());
}
function $ead6237849042dac$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($ead6237849042dac$var$SPAN_KEY, span);
}
function $ead6237849042dac$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($ead6237849042dac$var$SPAN_KEY);
}
function $ead6237849042dac$export$c90bf5428c14cdb1(context, spanContext) {
    return $ead6237849042dac$export$8ab2f2e6ee8ed0a8(context, new (0, $751bfb7d16d79d70$export$972d28f7c6a8c6c7)(spanContext));
}
function $ead6237849042dac$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $ead6237849042dac$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}




var $0391c1963efeb814$var$contextApi = (0, $8d5128149d5cfd94$export$4148866f0a453927).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var $0391c1963efeb814$export$714c1036cabcd223 = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = $0391c1963efeb814$var$contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $751bfb7d16d79d70$export$972d28f7c6a8c6c7)();
        var parentFromContext = context && (0, $ead6237849042dac$export$1a635f8f0b912781)(context);
        if ($0391c1963efeb814$var$isSpanContext(parentFromContext) && (0, $99a3da0b8477e363$export$e4373b9a2c09216c)(parentFromContext)) return new (0, $751bfb7d16d79d70$export$972d28f7c6a8c6c7)(parentFromContext);
        else return new (0, $751bfb7d16d79d70$export$972d28f7c6a8c6c7)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $0391c1963efeb814$var$contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, $ead6237849042dac$export$8ab2f2e6ee8ed0a8)(parentContext, span);
        return $0391c1963efeb814$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function $0391c1963efeb814$var$isSpanContext(spanContext) {
    return typeof spanContext === 'object' && typeof spanContext['spanId'] === 'string' && typeof spanContext['traceId'] === 'string' && typeof spanContext['traceFlags'] === 'number';
}


var $652ff47926e88b55$var$NOOP_TRACER = new (0, $0391c1963efeb814$export$714c1036cabcd223)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var $652ff47926e88b55$export$df2c38268c6bb6b3 = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $652ff47926e88b55$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var $df5db4b932dc665b$export$87d8e93756f9e86e = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, $0391c1963efeb814$export$714c1036cabcd223)();
    };
    return NoopTracerProvider;
}();


var $78f56c784e7c1cff$var$NOOP_TRACER_PROVIDER = new (0, $df5db4b932dc665b$export$87d8e93756f9e86e)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var $78f56c784e7c1cff$export$4137aabcb4254962 = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $652ff47926e88b55$export$df2c38268c6bb6b3)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $78f56c784e7c1cff$var$NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();





var $ae20af81b47909fe$var$API_NAME = 'trace';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var $ae20af81b47909fe$export$2cccde6fcc7b568a = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, $78f56c784e7c1cff$export$4137aabcb4254962)();
        this.wrapSpanContext = (0, $99a3da0b8477e363$export$c19cc0f1911bdb85);
        this.isSpanContextValid = (0, $99a3da0b8477e363$export$e4373b9a2c09216c);
        this.deleteSpan = (0, $ead6237849042dac$export$a6bbfe9a17f7941c);
        this.getSpan = (0, $ead6237849042dac$export$246e04ba06066af1);
        this.getActiveSpan = (0, $ead6237849042dac$export$1be426a8e585c83e);
        this.getSpanContext = (0, $ead6237849042dac$export$1a635f8f0b912781);
        this.setSpan = (0, $ead6237849042dac$export$8ab2f2e6ee8ed0a8);
        this.setSpanContext = (0, $ead6237849042dac$export$c90bf5428c14cdb1);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, $b2d9d13e726c481d$export$d586ae880b433238)($ae20af81b47909fe$var$API_NAME, this._proxyTracerProvider, (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, $b2d9d13e726c481d$export$a4e55266d2135a7f)($ae20af81b47909fe$var$API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, $b2d9d13e726c481d$export$d42ac835f38d1fb2)($ae20af81b47909fe$var$API_NAME, (0, $515ee5c32a70b2b2$export$5c8937ffc688cfd3).instance());
        this._proxyTracerProvider = new (0, $78f56c784e7c1cff$export$4137aabcb4254962)();
    };
    return TraceAPI;
}();


var $496851d2cf78caa4$export$357889f174732d38 = (0, $ae20af81b47909fe$export$2cccde6fcc7b568a).getInstance();


var // Default export.
$6b26b0d919da0068$export$2e2bcd8739ae039 = {
    context: (0, $0c57d9262090934c$export$a078c61943f9dbbe),
    diag: (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046),
    metrics: (0, $b8db6f384fae8886$export$b0c5c2fac8144e54),
    propagation: (0, $77955577000c938d$export$3e49040daa9dba20),
    trace: (0, $496851d2cf78caa4$export$357889f174732d38)
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $56fc24ae98cc6f86$export$85f6557964517f1a {
    _promise;
    _resolve;
    _reject;
    constructor(){
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    get promise() {
        return this._promise;
    }
    resolve(val) {
        this._resolve(val);
    }
    reject(err) {
        this._reject(err);
    }
}


class $db7650949c267d86$export$c1f52ab4952184cd {
    _isCalled = false;
    _deferred = new (0, $56fc24ae98cc6f86$export$85f6557964517f1a)();
    _callback;
    _that;
    constructor(callback, that){
        this._callback = callback;
        this._that = that;
    }
    get isCalled() {
        return this._isCalled;
    }
    get promise() {
        return this._deferred.promise;
    }
    call(...args) {
        if (!this._isCalled) {
            this._isCalled = true;
            try {
                Promise.resolve(this._callback.call(this._that, ...args)).then((val)=>this._deferred.resolve(val), (err)=>this._deferred.reject(err));
            } catch (err) {
                this._deferred.reject(err);
            }
        }
        return this._deferred.promise;
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1;
(function(ExportResultCode) {
    ExportResultCode[ExportResultCode["SUCCESS"] = 0] = "SUCCESS";
    ExportResultCode[ExportResultCode["FAILED"] = 1] = "FAILED";
})($f3cb0785acfa889d$export$ee0fe4df4ef0f3a1 || ($f3cb0785acfa889d$export$ee0fe4df4ef0f3a1 = {}));

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $2904c97a66abe41f$export$c1cd528968868329(_) {
    return undefined;
}
function $2904c97a66abe41f$export$9d8f36a7ac8db58c(_) {
    return undefined;
}
function $2904c97a66abe41f$export$9d6c13e44580559c(_) {
    return undefined;
}
function $2904c97a66abe41f$export$a18720db12f89f06(_) {
    return undefined;
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $cb0221cc65996bf5$export$cd67a16f6d11e5bd() {
    return (ex)=>{
        (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).error($cb0221cc65996bf5$var$stringifyException(ex));
    };
}
/**
 * Converts an exception into a string representation
 * @param {Exception} ex
 */ function $cb0221cc65996bf5$var$stringifyException(ex) {
    if (typeof ex === 'string') return ex;
    else return JSON.stringify($cb0221cc65996bf5$var$flattenException(ex));
}
/**
 * Flattens an exception into key-value pairs by traversing the prototype chain
 * and coercing values to strings. Duplicate properties will not be overwritten;
 * the first insert wins.
 */ function $cb0221cc65996bf5$var$flattenException(ex) {
    const result = {};
    let current = ex;
    while(current !== null){
        Object.getOwnPropertyNames(current).forEach((propertyName)=>{
            if (result[propertyName]) return;
            const value = current[propertyName];
            if (value) result[propertyName] = String(value);
        });
        current = Object.getPrototypeOf(current);
    }
    return result;
}


/** The global error handler delegate */ let $c70d952740b6ceea$var$delegateHandler = (0, $cb0221cc65996bf5$export$cd67a16f6d11e5bd)();
function $c70d952740b6ceea$export$bdff946829732435(handler) {
    $c70d952740b6ceea$var$delegateHandler = handler;
}
function $c70d952740b6ceea$export$54c6946fc34b7cc2(ex) {
    try {
        $c70d952740b6ceea$var$delegateHandler(ex);
    } catch  {} // eslint-disable-line no-empty
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
const $a2728a0463bf3b1f$var$SUPPRESS_TRACING_KEY = (0, $411320e1da10ff3d$export$b8c322c5a7cfce78)('OpenTelemetry SDK Context Key SUPPRESS_TRACING');
function $a2728a0463bf3b1f$export$869298f9835abc68(context) {
    return context.setValue($a2728a0463bf3b1f$var$SUPPRESS_TRACING_KEY, true);
}
function $a2728a0463bf3b1f$export$a8cb26cef1019d30(context) {
    return context.deleteValue($a2728a0463bf3b1f$var$SUPPRESS_TRACING_KEY);
}
function $a2728a0463bf3b1f$export$7d5f2376f7cf513(context) {
    return context.getValue($a2728a0463bf3b1f$var$SUPPRESS_TRACING_KEY) === true;
}


class $31540fc2074db7cc$export$54ea939f5d39e8a2 {
    _maxExportBatchSize;
    _maxQueueSize;
    _scheduledDelayMillis;
    _exportTimeoutMillis;
    _exporter;
    _isExporting = false;
    _finishedSpans = [];
    _timer;
    _shutdownOnce;
    _droppedSpansCount = 0;
    constructor(exporter, config){
        this._exporter = exporter;
        this._maxExportBatchSize = typeof config?.maxExportBatchSize === 'number' ? config.maxExportBatchSize : (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_BSP_MAX_EXPORT_BATCH_SIZE') ?? 512;
        this._maxQueueSize = typeof config?.maxQueueSize === 'number' ? config.maxQueueSize : (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_BSP_MAX_QUEUE_SIZE') ?? 2048;
        this._scheduledDelayMillis = typeof config?.scheduledDelayMillis === 'number' ? config.scheduledDelayMillis : (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_BSP_SCHEDULE_DELAY') ?? 5000;
        this._exportTimeoutMillis = typeof config?.exportTimeoutMillis === 'number' ? config.exportTimeoutMillis : (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_BSP_EXPORT_TIMEOUT') ?? 30000;
        this._shutdownOnce = new (0, $db7650949c267d86$export$c1f52ab4952184cd)(this._shutdown, this);
        if (this._maxExportBatchSize > this._maxQueueSize) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn('BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize');
            this._maxExportBatchSize = this._maxQueueSize;
        }
    }
    forceFlush() {
        if (this._shutdownOnce.isCalled) return this._shutdownOnce.promise;
        return this._flushAll();
    }
    // does nothing.
    onStart(_span, _parentContext) {}
    onEnd(span) {
        if (this._shutdownOnce.isCalled) return;
        if ((span.spanContext().traceFlags & (0, $5dcc187a863bca89$export$bf9049ad2b0883ff).SAMPLED) === 0) return;
        this._addToBuffer(span);
    }
    shutdown() {
        return this._shutdownOnce.call();
    }
    _shutdown() {
        return Promise.resolve().then(()=>{
            return this.onShutdown();
        }).then(()=>{
            return this._flushAll();
        }).then(()=>{
            return this._exporter.shutdown();
        });
    }
    /** Add a span in the buffer. */ _addToBuffer(span) {
        if (this._finishedSpans.length >= this._maxQueueSize) {
            // limit reached, drop span
            if (this._droppedSpansCount === 0) (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).debug('maxQueueSize reached, dropping spans');
            this._droppedSpansCount++;
            return;
        }
        if (this._droppedSpansCount > 0) {
            // some spans were dropped, log once with count of spans dropped
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Dropped ${this._droppedSpansCount} spans because maxQueueSize reached`);
            this._droppedSpansCount = 0;
        }
        this._finishedSpans.push(span);
        this._maybeStartTimer();
    }
    /**
     * Send all spans to the exporter respecting the batch size limit
     * This function is used only on forceFlush or shutdown,
     * for all other cases _flush should be used
     * */ _flushAll() {
        return new Promise((resolve, reject)=>{
            const promises = [];
            // calculate number of batches
            const count = Math.ceil(this._finishedSpans.length / this._maxExportBatchSize);
            for(let i = 0, j = count; i < j; i++)promises.push(this._flushOneBatch());
            Promise.all(promises).then(()=>{
                resolve();
            }).catch(reject);
        });
    }
    _flushOneBatch() {
        this._clearTimer();
        if (this._finishedSpans.length === 0) return Promise.resolve();
        return new Promise((resolve, reject)=>{
            const timer = setTimeout(()=>{
                // don't wait anymore for export, this way the next batch can start
                reject(new Error('Timeout'));
            }, this._exportTimeoutMillis);
            // prevent downstream exporter calls from generating spans
            (0, $0c57d9262090934c$export$a078c61943f9dbbe).with((0, $a2728a0463bf3b1f$export$869298f9835abc68)((0, $0c57d9262090934c$export$a078c61943f9dbbe).active()), ()=>{
                // Reset the finished spans buffer here because the next invocations of the _flush method
                // could pass the same finished spans to the exporter if the buffer is cleared
                // outside the execution of this callback.
                let spans;
                if (this._finishedSpans.length <= this._maxExportBatchSize) {
                    spans = this._finishedSpans;
                    this._finishedSpans = [];
                } else spans = this._finishedSpans.splice(0, this._maxExportBatchSize);
                const doExport = ()=>this._exporter.export(spans, (result)=>{
                        clearTimeout(timer);
                        if (result.code === (0, $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1).SUCCESS) resolve();
                        else reject(result.error ?? new Error('BatchSpanProcessor: span export failed'));
                    });
                let pendingResources = null;
                for(let i = 0, len = spans.length; i < len; i++){
                    const span = spans[i];
                    if (span.resource.asyncAttributesPending && span.resource.waitForAsyncAttributes) {
                        pendingResources ??= [];
                        pendingResources.push(span.resource.waitForAsyncAttributes());
                    }
                }
                // Avoid scheduling a promise to make the behavior more predictable and easier to test
                if (pendingResources === null) doExport();
                else Promise.all(pendingResources).then(doExport, (err)=>{
                    (0, $c70d952740b6ceea$export$54c6946fc34b7cc2)(err);
                    reject(err);
                });
            });
        });
    }
    _maybeStartTimer() {
        if (this._isExporting) return;
        const flush = ()=>{
            this._isExporting = true;
            this._flushOneBatch().finally(()=>{
                this._isExporting = false;
                if (this._finishedSpans.length > 0) {
                    this._clearTimer();
                    this._maybeStartTimer();
                }
            }).catch((e)=>{
                this._isExporting = false;
                (0, $c70d952740b6ceea$export$54c6946fc34b7cc2)(e);
            });
        };
        // we only wait if the queue doesn't have enough elements yet
        if (this._finishedSpans.length >= this._maxExportBatchSize) return flush();
        if (this._timer !== undefined) return;
        this._timer = setTimeout(()=>flush(), this._scheduledDelayMillis);
        // depending on runtime, this may be a 'number' or NodeJS.Timeout
        if (typeof this._timer !== 'number') this._timer.unref();
    }
    _clearTimer() {
        if (this._timer !== undefined) {
            clearTimeout(this._timer);
            this._timer = undefined;
        }
    }
}



class $6387aa3fe0aa015a$export$237547059fd543f9 extends (0, $31540fc2074db7cc$export$54ea939f5d39e8a2) {
    _visibilityChangeListener;
    _pageHideListener;
    constructor(_exporter, config){
        super(_exporter, config);
        this.onInit(config);
    }
    onInit(config) {
        if (config?.disableAutoFlushOnDocumentHide !== true && typeof document !== 'undefined') {
            this._visibilityChangeListener = ()=>{
                if (document.visibilityState === 'hidden') this.forceFlush().catch((error)=>{
                    (0, $c70d952740b6ceea$export$54c6946fc34b7cc2)(error);
                });
            };
            this._pageHideListener = ()=>{
                this.forceFlush().catch((error)=>{
                    (0, $c70d952740b6ceea$export$54c6946fc34b7cc2)(error);
                });
            };
            document.addEventListener('visibilitychange', this._visibilityChangeListener);
            // use 'pagehide' event as a fallback for Safari; see https://bugs.webkit.org/show_bug.cgi?id=116769
            document.addEventListener('pagehide', this._pageHideListener);
        }
    }
    onShutdown() {
        if (typeof document !== 'undefined') {
            if (this._visibilityChangeListener) document.removeEventListener('visibilitychange', this._visibilityChangeListener);
            if (this._pageHideListener) document.removeEventListener('pagehide', this._pageHideListener);
        }
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * based on lodash in order to support esm builds without esModuleInterop.
 * lodash is using MIT License.
 **/ const $e6c7889dba68b6a8$var$objectTag = '[object Object]';
const $e6c7889dba68b6a8$var$nullTag = '[object Null]';
const $e6c7889dba68b6a8$var$undefinedTag = '[object Undefined]';
const $e6c7889dba68b6a8$var$funcProto = Function.prototype;
const $e6c7889dba68b6a8$var$funcToString = $e6c7889dba68b6a8$var$funcProto.toString;
const $e6c7889dba68b6a8$var$objectCtorString = $e6c7889dba68b6a8$var$funcToString.call(Object);
const $e6c7889dba68b6a8$var$getPrototypeOf = Object.getPrototypeOf;
const $e6c7889dba68b6a8$var$objectProto = Object.prototype;
const $e6c7889dba68b6a8$var$hasOwnProperty = $e6c7889dba68b6a8$var$objectProto.hasOwnProperty;
const $e6c7889dba68b6a8$var$symToStringTag = Symbol ? Symbol.toStringTag : undefined;
const $e6c7889dba68b6a8$var$nativeObjectToString = $e6c7889dba68b6a8$var$objectProto.toString;
function $e6c7889dba68b6a8$export$53b83ca8eaab0383(value) {
    if (!$e6c7889dba68b6a8$var$isObjectLike(value) || $e6c7889dba68b6a8$var$baseGetTag(value) !== $e6c7889dba68b6a8$var$objectTag) return false;
    const proto = $e6c7889dba68b6a8$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = $e6c7889dba68b6a8$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $e6c7889dba68b6a8$var$funcToString.call(Ctor) === $e6c7889dba68b6a8$var$objectCtorString;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $e6c7889dba68b6a8$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $e6c7889dba68b6a8$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $e6c7889dba68b6a8$var$undefinedTag : $e6c7889dba68b6a8$var$nullTag;
    return $e6c7889dba68b6a8$var$symToStringTag && $e6c7889dba68b6a8$var$symToStringTag in Object(value) ? $e6c7889dba68b6a8$var$getRawTag(value) : $e6c7889dba68b6a8$var$objectToString(value);
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $e6c7889dba68b6a8$var$getRawTag(value) {
    const isOwn = $e6c7889dba68b6a8$var$hasOwnProperty.call(value, $e6c7889dba68b6a8$var$symToStringTag), tag = value[$e6c7889dba68b6a8$var$symToStringTag];
    let unmasked = false;
    try {
        value[$e6c7889dba68b6a8$var$symToStringTag] = undefined;
        unmasked = true;
    } catch  {
    // silence
    }
    const result = $e6c7889dba68b6a8$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$e6c7889dba68b6a8$var$symToStringTag] = tag;
        else delete value[$e6c7889dba68b6a8$var$symToStringTag];
    }
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $e6c7889dba68b6a8$var$objectToString(value) {
    return $e6c7889dba68b6a8$var$nativeObjectToString.call(value);
}


const $a99eaf6108fc00d6$var$MAX_LEVEL = 20;
function $a99eaf6108fc00d6$export$4950aa0f605343fb(...args) {
    let result = args.shift();
    const objects = new WeakMap();
    while(args.length > 0)result = $a99eaf6108fc00d6$var$mergeTwoObjects(result, args.shift(), 0, objects);
    return result;
}
function $a99eaf6108fc00d6$var$takeValue(value) {
    if ($a99eaf6108fc00d6$var$isArray(value)) return value.slice();
    return value;
}
/**
 * Merges two objects
 * @param one - first object
 * @param two - second object
 * @param level - current deep level
 * @param objects - objects holder that has been already referenced - to prevent
 * cyclic dependency
 */ function $a99eaf6108fc00d6$var$mergeTwoObjects(one, two, level = 0, objects) {
    let result;
    if (level > $a99eaf6108fc00d6$var$MAX_LEVEL) return undefined;
    level++;
    if ($a99eaf6108fc00d6$var$isPrimitive(one) || $a99eaf6108fc00d6$var$isPrimitive(two) || $a99eaf6108fc00d6$var$isFunction(two)) result = $a99eaf6108fc00d6$var$takeValue(two);
    else if ($a99eaf6108fc00d6$var$isArray(one)) {
        result = one.slice();
        if ($a99eaf6108fc00d6$var$isArray(two)) for(let i = 0, j = two.length; i < j; i++)result.push($a99eaf6108fc00d6$var$takeValue(two[i]));
        else if ($a99eaf6108fc00d6$var$isObject(two)) {
            const keys = Object.keys(two);
            for(let i = 0, j = keys.length; i < j; i++){
                const key = keys[i];
                result[key] = $a99eaf6108fc00d6$var$takeValue(two[key]);
            }
        }
    } else if ($a99eaf6108fc00d6$var$isObject(one)) {
        if ($a99eaf6108fc00d6$var$isObject(two)) {
            if (!$a99eaf6108fc00d6$var$shouldMerge(one, two)) return two;
            result = Object.assign({}, one);
            const keys = Object.keys(two);
            for(let i = 0, j = keys.length; i < j; i++){
                const key = keys[i];
                const twoValue = two[key];
                if ($a99eaf6108fc00d6$var$isPrimitive(twoValue)) {
                    if (typeof twoValue === 'undefined') delete result[key];
                    else // result[key] = takeValue(twoValue);
                    result[key] = twoValue;
                } else {
                    const obj1 = result[key];
                    const obj2 = twoValue;
                    if ($a99eaf6108fc00d6$var$wasObjectReferenced(one, key, objects) || $a99eaf6108fc00d6$var$wasObjectReferenced(two, key, objects)) delete result[key];
                    else {
                        if ($a99eaf6108fc00d6$var$isObject(obj1) && $a99eaf6108fc00d6$var$isObject(obj2)) {
                            const arr1 = objects.get(obj1) || [];
                            const arr2 = objects.get(obj2) || [];
                            arr1.push({
                                obj: one,
                                key: key
                            });
                            arr2.push({
                                obj: two,
                                key: key
                            });
                            objects.set(obj1, arr1);
                            objects.set(obj2, arr2);
                        }
                        result[key] = $a99eaf6108fc00d6$var$mergeTwoObjects(result[key], twoValue, level, objects);
                    }
                }
            }
        } else result = two;
    }
    return result;
}
/**
 * Function to check if object has been already reference
 * @param obj
 * @param key
 * @param objects
 */ function $a99eaf6108fc00d6$var$wasObjectReferenced(obj, key, objects) {
    const arr = objects.get(obj[key]) || [];
    for(let i = 0, j = arr.length; i < j; i++){
        const info = arr[i];
        if (info.key === key && info.obj === obj) return true;
    }
    return false;
}
function $a99eaf6108fc00d6$var$isArray(value) {
    return Array.isArray(value);
}
function $a99eaf6108fc00d6$var$isFunction(value) {
    return typeof value === 'function';
}
function $a99eaf6108fc00d6$var$isObject(value) {
    return !$a99eaf6108fc00d6$var$isPrimitive(value) && !$a99eaf6108fc00d6$var$isArray(value) && !$a99eaf6108fc00d6$var$isFunction(value) && typeof value === 'object';
}
function $a99eaf6108fc00d6$var$isPrimitive(value) {
    return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || typeof value === 'undefined' || value instanceof Date || value instanceof RegExp || value === null;
}
function $a99eaf6108fc00d6$var$shouldMerge(one, two) {
    if (!(0, $e6c7889dba68b6a8$export$53b83ca8eaab0383)(one) || !(0, $e6c7889dba68b6a8$export$53b83ca8eaab0383)(two)) return false;
    return true;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
const $0ce0ff0f84d92ad6$export$a4ad2735b021c132 = '2.5.0';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ //----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates/registry/stable/attributes.ts.j2
//----------------------------------------------------------------------------------------------------------
/**
 * ASP.NET Core exception middleware handling result.
 *
 * @example handled
 * @example unhandled
 */ const $3fcd7ea0f1087866$export$f82340eb6f7ee4fc = 'aspnetcore.diagnostics.exception.result';
const $3fcd7ea0f1087866$export$cda1f266e1fc5b3f = "aborted";
const $3fcd7ea0f1087866$export$f59ec205fdfe6400 = "handled";
const $3fcd7ea0f1087866$export$b427e935fd6651ab = "skipped";
const $3fcd7ea0f1087866$export$7a0c380cad26f867 = "unhandled";
const $3fcd7ea0f1087866$export$e15ee6ced4b4d793 = 'aspnetcore.diagnostics.handler.type';
const $3fcd7ea0f1087866$export$d6be6e9a073ccba5 = 'aspnetcore.rate_limiting.policy';
const $3fcd7ea0f1087866$export$df376702a339c094 = 'aspnetcore.rate_limiting.result';
const $3fcd7ea0f1087866$export$e160ee3fb23dd21e = "acquired";
const $3fcd7ea0f1087866$export$336cf096763833a3 = "endpoint_limiter";
const $3fcd7ea0f1087866$export$ee99d6c8d66ba053 = "global_limiter";
const $3fcd7ea0f1087866$export$d4525b0bcb1802a6 = "request_canceled";
const $3fcd7ea0f1087866$export$746fc3f900d45c45 = 'aspnetcore.request.is_unhandled';
const $3fcd7ea0f1087866$export$bcd5f0f8484c3bc0 = 'aspnetcore.routing.is_fallback';
const $3fcd7ea0f1087866$export$d181153b8bdfa0b6 = 'aspnetcore.routing.match_status';
const $3fcd7ea0f1087866$export$ca7f093befa342d4 = "failure";
const $3fcd7ea0f1087866$export$ae1a39d3a4050746 = "success";
const $3fcd7ea0f1087866$export$f25890d1e3848156 = 'aspnetcore.user.is_authenticated';
const $3fcd7ea0f1087866$export$d68d146ff79c04a8 = 'client.address';
const $3fcd7ea0f1087866$export$98967a53baad5eec = 'client.port';
const $3fcd7ea0f1087866$export$5285ee03db771e5b = 'code.column.number';
const $3fcd7ea0f1087866$export$ac9d6c9a41211595 = 'code.file.path';
const $3fcd7ea0f1087866$export$fd34f7e1f0c418fc = 'code.function.name';
const $3fcd7ea0f1087866$export$ccc16b040f2d3c68 = 'code.line.number';
const $3fcd7ea0f1087866$export$84cf154ace206984 = 'code.stacktrace';
const $3fcd7ea0f1087866$export$f3ebe872053c9886 = 'db.collection.name';
const $3fcd7ea0f1087866$export$354f27025f67a12d = 'db.namespace';
const $3fcd7ea0f1087866$export$899baaeb75956560 = 'db.operation.batch.size';
const $3fcd7ea0f1087866$export$32ff3b5ea8eeed5d = 'db.operation.name';
const $3fcd7ea0f1087866$export$ebef2908cb0508b2 = 'db.query.summary';
const $3fcd7ea0f1087866$export$dc45382793fd9c73 = 'db.query.text';
const $3fcd7ea0f1087866$export$5f1e82edb68082a5 = 'db.response.status_code';
const $3fcd7ea0f1087866$export$59730bfffb801deb = 'db.stored_procedure.name';
const $3fcd7ea0f1087866$export$e092ac179da1bacb = 'db.system.name';
const $3fcd7ea0f1087866$export$33a9d0e8e2693338 = "mariadb";
const $3fcd7ea0f1087866$export$e0e77e85ab698795 = "microsoft.sql_server";
const $3fcd7ea0f1087866$export$6b580327d217ab17 = "mysql";
const $3fcd7ea0f1087866$export$de5fcd2a0648ea59 = "postgresql";
const $3fcd7ea0f1087866$export$50d2ae8f0fe53654 = 'dotnet.gc.heap.generation';
const $3fcd7ea0f1087866$export$53c7cec226bbc008 = "gen0";
const $3fcd7ea0f1087866$export$16eba2d1cd3c6aae = "gen1";
const $3fcd7ea0f1087866$export$53cbcd4ebe9fed52 = "gen2";
const $3fcd7ea0f1087866$export$73025750a790bd80 = "loh";
const $3fcd7ea0f1087866$export$92f06dbb8b8e4efb = "poh";
const $3fcd7ea0f1087866$export$27bc5d0fa190eb39 = 'error.type';
const $3fcd7ea0f1087866$export$c00e2e224ae81dcc = "_OTHER";
const $3fcd7ea0f1087866$export$5afa65f3c67a6da5 = 'exception.escaped';
const $3fcd7ea0f1087866$export$ab4513c1b55519b5 = 'exception.message';
const $3fcd7ea0f1087866$export$9b74e4928364b671 = 'exception.stacktrace';
const $3fcd7ea0f1087866$export$85da07cb5d867763 = 'exception.type';
const $3fcd7ea0f1087866$export$6dc05c1a4ea7d452 = (key)=>`http.request.header.${key}`;
const $3fcd7ea0f1087866$export$c950c48d651d36f6 = 'http.request.method';
const $3fcd7ea0f1087866$export$475d0b6904c72522 = "_OTHER";
const $3fcd7ea0f1087866$export$1d0475e0429ecc7a = "CONNECT";
const $3fcd7ea0f1087866$export$f5009fc3b2e116f6 = "DELETE";
const $3fcd7ea0f1087866$export$b37eb57f1c0ae17e = "GET";
const $3fcd7ea0f1087866$export$cfad2d23aef0a595 = "HEAD";
const $3fcd7ea0f1087866$export$ffb5e83a22c8414 = "OPTIONS";
const $3fcd7ea0f1087866$export$c4e10ea4e2b3375 = "PATCH";
const $3fcd7ea0f1087866$export$ca259afc8ad50e83 = "POST";
const $3fcd7ea0f1087866$export$a8e9778ce76ecdaa = "PUT";
const $3fcd7ea0f1087866$export$81cc82dc1804c06e = "TRACE";
const $3fcd7ea0f1087866$export$b4706f4398125cd2 = 'http.request.method_original';
const $3fcd7ea0f1087866$export$44a2b6455db2b082 = 'http.request.resend_count';
const $3fcd7ea0f1087866$export$a3227fcde36256b7 = (key)=>`http.response.header.${key}`;
const $3fcd7ea0f1087866$export$4f9cc9c1e7b4e832 = 'http.response.status_code';
const $3fcd7ea0f1087866$export$ee724a749950397e = 'http.route';
const $3fcd7ea0f1087866$export$9633601338584456 = 'jvm.gc.action';
const $3fcd7ea0f1087866$export$81a9f72367df0211 = 'jvm.gc.name';
const $3fcd7ea0f1087866$export$27fb7cfe62c0cad7 = 'jvm.memory.pool.name';
const $3fcd7ea0f1087866$export$c9dfa04abbde6209 = 'jvm.memory.type';
const $3fcd7ea0f1087866$export$5eceb6c6d9c4a2b1 = "heap";
const $3fcd7ea0f1087866$export$fb42d239cc164326 = "non_heap";
const $3fcd7ea0f1087866$export$b9f4735680b4c618 = 'jvm.thread.daemon';
const $3fcd7ea0f1087866$export$49cfe86a143a90f4 = 'jvm.thread.state';
const $3fcd7ea0f1087866$export$4d1c8eb785b37946 = "blocked";
const $3fcd7ea0f1087866$export$438d3b92d604d3c1 = "new";
const $3fcd7ea0f1087866$export$efbf4822176b787e = "runnable";
const $3fcd7ea0f1087866$export$10d62496862243a3 = "terminated";
const $3fcd7ea0f1087866$export$54c3957659069067 = "timed_waiting";
const $3fcd7ea0f1087866$export$97de93f28bd98f0c = "waiting";
const $3fcd7ea0f1087866$export$122a3f3d92b58f2d = 'network.local.address';
const $3fcd7ea0f1087866$export$dd3d00f8681df0ce = 'network.local.port';
const $3fcd7ea0f1087866$export$28b7676252843fab = 'network.peer.address';
const $3fcd7ea0f1087866$export$9fb532b0fee2b1f1 = 'network.peer.port';
const $3fcd7ea0f1087866$export$dee59b686a2846ec = 'network.protocol.name';
const $3fcd7ea0f1087866$export$d98f8d975600c0d0 = 'network.protocol.version';
const $3fcd7ea0f1087866$export$7616c996937a34bc = 'network.transport';
const $3fcd7ea0f1087866$export$f4431576993bcf7a = "pipe";
const $3fcd7ea0f1087866$export$169e124b418d088f = "quic";
const $3fcd7ea0f1087866$export$26ef76391bdfab1b = "tcp";
const $3fcd7ea0f1087866$export$a1d89d523a38f571 = "udp";
const $3fcd7ea0f1087866$export$19b3a90274118dec = "unix";
const $3fcd7ea0f1087866$export$9ce893eda94da085 = 'network.type';
const $3fcd7ea0f1087866$export$1c0032dd042c0036 = "ipv4";
const $3fcd7ea0f1087866$export$2e20616f92e0c61 = "ipv6";
const $3fcd7ea0f1087866$export$c0272561abab91e2 = 'otel.scope.name';
const $3fcd7ea0f1087866$export$f34b883f266e7940 = 'otel.scope.version';
const $3fcd7ea0f1087866$export$1ce3678560a98f66 = 'otel.status_code';
const $3fcd7ea0f1087866$export$91e9746558fdb3eb = "ERROR";
const $3fcd7ea0f1087866$export$88d70046bd134963 = "OK";
const $3fcd7ea0f1087866$export$bb722bc34dbbae55 = 'otel.status_description';
const $3fcd7ea0f1087866$export$a5acaa0dbc823e02 = 'server.address';
const $3fcd7ea0f1087866$export$b7822882ad829476 = 'server.port';
const $3fcd7ea0f1087866$export$84187ab40ae4fa9c = 'service.name';
const $3fcd7ea0f1087866$export$262ef07bab967f36 = 'service.version';
const $3fcd7ea0f1087866$export$d52213f71e0d6fe9 = 'signalr.connection.status';
const $3fcd7ea0f1087866$export$1941a43dd05c1796 = "app_shutdown";
const $3fcd7ea0f1087866$export$339985f783caddd3 = "normal_closure";
const $3fcd7ea0f1087866$export$5dbce0c170853f5d = "timeout";
const $3fcd7ea0f1087866$export$344eec4d4360b8c9 = 'signalr.transport';
const $3fcd7ea0f1087866$export$c9ad321a279e5110 = "long_polling";
const $3fcd7ea0f1087866$export$ade38f22da951337 = "server_sent_events";
const $3fcd7ea0f1087866$export$cb9a023ecee30642 = "web_sockets";
const $3fcd7ea0f1087866$export$f0cc9f40fa472996 = 'telemetry.sdk.language';
const $3fcd7ea0f1087866$export$76253579e9fea8e3 = "cpp";
const $3fcd7ea0f1087866$export$4163d8f19c62acfe = "dotnet";
const $3fcd7ea0f1087866$export$d735f65160d35019 = "erlang";
const $3fcd7ea0f1087866$export$1dde175b7d1c8a44 = "go";
const $3fcd7ea0f1087866$export$73150af2f1f383fa = "java";
const $3fcd7ea0f1087866$export$1b3cb919ea0daa1c = "nodejs";
const $3fcd7ea0f1087866$export$1a3ac4d13e9292be = "php";
const $3fcd7ea0f1087866$export$5734868f06d7b5c8 = "python";
const $3fcd7ea0f1087866$export$b7bb3f8171ef2aa3 = "ruby";
const $3fcd7ea0f1087866$export$713f4fffa2875054 = "rust";
const $3fcd7ea0f1087866$export$8d08f2cb0d9fd722 = "swift";
const $3fcd7ea0f1087866$export$2f063992689fdf64 = "webjs";
const $3fcd7ea0f1087866$export$8f719441032e7a01 = 'telemetry.sdk.name';
const $3fcd7ea0f1087866$export$5fe5e8dd061ec635 = 'telemetry.sdk.version';
const $3fcd7ea0f1087866$export$f00e0b7bc579cfe4 = 'url.fragment';
const $3fcd7ea0f1087866$export$ef7da4fb774e8a84 = 'url.full';
const $3fcd7ea0f1087866$export$36f670b9709ab2f8 = 'url.path';
const $3fcd7ea0f1087866$export$55ce97b387061dd1 = 'url.query';
const $3fcd7ea0f1087866$export$d1d5ca1ca02801e6 = 'url.scheme';
const $3fcd7ea0f1087866$export$11d4f8ef7be26b3d = 'user_agent.original';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * This file contains a copy of unstable semantic convention definitions
 * used by this package.
 * @see https://github.com/open-telemetry/opentelemetry-js/tree/main/semantic-conventions#unstable-semconv
 */ /**
 * The name of the runtime of this process.
 *
 * @example OpenJDK Runtime Environment
 *
 * @experimental This attribute is experimental and is subject to breaking changes in minor releases of `@opentelemetry/semantic-conventions`.
 */ const $0d91014795ea706f$export$ad06ab84cf3d9d79 = 'process.runtime.name';


const $1c5e0c7f8c3f5fd5$export$3c44663382dce232 = {
    [(0, $3fcd7ea0f1087866$export$8f719441032e7a01)]: 'opentelemetry',
    [(0, $0d91014795ea706f$export$ad06ab84cf3d9d79)]: 'browser',
    [(0, $3fcd7ea0f1087866$export$f0cc9f40fa472996)]: (0, $3fcd7ea0f1087866$export$2f063992689fdf64),
    [(0, $3fcd7ea0f1087866$export$5fe5e8dd061ec635)]: (0, $0ce0ff0f84d92ad6$export$a4ad2735b021c132)
};



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $f211d145a92f9dcc$var$serviceName;
function $f211d145a92f9dcc$export$b8c2abd2a6cf7c10() {
    if ($f211d145a92f9dcc$var$serviceName === undefined) try {
        const argv0 = globalThis.process.argv0;
        $f211d145a92f9dcc$var$serviceName = argv0 ? `unknown_service:${argv0}` : 'unknown_service';
    } catch  {
        $f211d145a92f9dcc$var$serviceName = 'unknown_service';
    }
    return $f211d145a92f9dcc$var$serviceName;
}
function $f211d145a92f9dcc$export$806b6b8db57a3723() {
    $f211d145a92f9dcc$var$serviceName = undefined;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7c4fbd050fa7f541$export$ae936b9d47e5870e = (val)=>{
    return val !== null && typeof val === 'object' && typeof val.then === 'function';
};


class $34b7feab81bdb448$var$ResourceImpl {
    _rawAttributes;
    _asyncAttributesPending = false;
    _schemaUrl;
    _memoizedAttributes;
    static FromAttributeList(attributes, options) {
        const res = new $34b7feab81bdb448$var$ResourceImpl({}, options);
        res._rawAttributes = $34b7feab81bdb448$var$guardedRawAttributes(attributes);
        res._asyncAttributesPending = attributes.filter(([_, val])=>(0, $7c4fbd050fa7f541$export$ae936b9d47e5870e)(val)).length > 0;
        return res;
    }
    constructor(/**
     * A dictionary of attributes with string keys and values that provide
     * information about the entity as numbers, strings or booleans
     * TODO: Consider to add check/validation on attributes.
     */ resource, options){
        const attributes = resource.attributes ?? {};
        this._rawAttributes = Object.entries(attributes).map(([k, v])=>{
            if ((0, $7c4fbd050fa7f541$export$ae936b9d47e5870e)(v)) // side-effect
            this._asyncAttributesPending = true;
            return [
                k,
                v
            ];
        });
        this._rawAttributes = $34b7feab81bdb448$var$guardedRawAttributes(this._rawAttributes);
        this._schemaUrl = $34b7feab81bdb448$var$validateSchemaUrl(options?.schemaUrl);
    }
    get asyncAttributesPending() {
        return this._asyncAttributesPending;
    }
    async waitForAsyncAttributes() {
        if (!this.asyncAttributesPending) return;
        for(let i = 0; i < this._rawAttributes.length; i++){
            const [k, v] = this._rawAttributes[i];
            this._rawAttributes[i] = [
                k,
                (0, $7c4fbd050fa7f541$export$ae936b9d47e5870e)(v) ? await v : v
            ];
        }
        this._asyncAttributesPending = false;
    }
    get attributes() {
        if (this.asyncAttributesPending) (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).error('Accessing resource attributes before async attributes settled');
        if (this._memoizedAttributes) return this._memoizedAttributes;
        const attrs = {};
        for (const [k, v] of this._rawAttributes){
            if ((0, $7c4fbd050fa7f541$export$ae936b9d47e5870e)(v)) {
                (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).debug(`Unsettled resource attribute ${k} skipped`);
                continue;
            }
            if (v != null) attrs[k] ??= v;
        }
        // only memoize output if all attributes are settled
        if (!this._asyncAttributesPending) this._memoizedAttributes = attrs;
        return attrs;
    }
    getRawAttributes() {
        return this._rawAttributes;
    }
    get schemaUrl() {
        return this._schemaUrl;
    }
    merge(resource) {
        if (resource == null) return this;
        // Order is important
        // Spec states incoming attributes override existing attributes
        const mergedSchemaUrl = $34b7feab81bdb448$var$mergeSchemaUrl(this, resource);
        const mergedOptions = mergedSchemaUrl ? {
            schemaUrl: mergedSchemaUrl
        } : undefined;
        return $34b7feab81bdb448$var$ResourceImpl.FromAttributeList([
            ...resource.getRawAttributes(),
            ...this.getRawAttributes()
        ], mergedOptions);
    }
}
function $34b7feab81bdb448$export$bb0fe4e7060febbf(attributes, options) {
    return $34b7feab81bdb448$var$ResourceImpl.FromAttributeList(Object.entries(attributes), options);
}
function $34b7feab81bdb448$export$4d462f2e58ee368a(detectedResource, options) {
    return new $34b7feab81bdb448$var$ResourceImpl(detectedResource, options);
}
function $34b7feab81bdb448$export$6ed870441802d126() {
    return $34b7feab81bdb448$export$bb0fe4e7060febbf({});
}
function $34b7feab81bdb448$export$522a862cad1b0abc() {
    return $34b7feab81bdb448$export$bb0fe4e7060febbf({
        [(0, $3fcd7ea0f1087866$export$84187ab40ae4fa9c)]: (0, $f211d145a92f9dcc$export$b8c2abd2a6cf7c10)(),
        [(0, $3fcd7ea0f1087866$export$f0cc9f40fa472996)]: (0, $1c5e0c7f8c3f5fd5$export$3c44663382dce232)[0, $3fcd7ea0f1087866$export$f0cc9f40fa472996],
        [(0, $3fcd7ea0f1087866$export$8f719441032e7a01)]: (0, $1c5e0c7f8c3f5fd5$export$3c44663382dce232)[0, $3fcd7ea0f1087866$export$8f719441032e7a01],
        [(0, $3fcd7ea0f1087866$export$5fe5e8dd061ec635)]: (0, $1c5e0c7f8c3f5fd5$export$3c44663382dce232)[0, $3fcd7ea0f1087866$export$5fe5e8dd061ec635]
    });
}
function $34b7feab81bdb448$var$guardedRawAttributes(attributes) {
    return attributes.map(([k, v])=>{
        if ((0, $7c4fbd050fa7f541$export$ae936b9d47e5870e)(v)) return [
            k,
            v.catch((err)=>{
                (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).debug('promise rejection for resource attribute: %s - %s', k, err);
                return undefined;
            })
        ];
        return [
            k,
            v
        ];
    });
}
function $34b7feab81bdb448$var$validateSchemaUrl(schemaUrl) {
    if (typeof schemaUrl === 'string' || schemaUrl === undefined) return schemaUrl;
    (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn('Schema URL must be string or undefined, got %s. Schema URL will be ignored.', schemaUrl);
    return undefined;
}
function $34b7feab81bdb448$var$mergeSchemaUrl(old, updating) {
    const oldSchemaUrl = old?.schemaUrl;
    const updatingSchemaUrl = updating?.schemaUrl;
    const isOldEmpty = oldSchemaUrl === undefined || oldSchemaUrl === '';
    const isUpdatingEmpty = updatingSchemaUrl === undefined || updatingSchemaUrl === '';
    if (isOldEmpty) return updatingSchemaUrl;
    if (isUpdatingEmpty) return oldSchemaUrl;
    if (oldSchemaUrl === updatingSchemaUrl) return oldSchemaUrl;
    (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn('Schema URL merge conflict: old resource has "%s", updating resource has "%s". Resulting resource will have undefined Schema URL.', oldSchemaUrl, updatingSchemaUrl);
    return undefined;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $ce0d74c13ee0c534$export$b0663eba150d60c9(attributes) {
    const out = {};
    if (typeof attributes !== 'object' || attributes == null) return out;
    for(const key in attributes){
        if (!Object.prototype.hasOwnProperty.call(attributes, key)) continue;
        if (!$ce0d74c13ee0c534$export$d3dd8ead6a0318c3(key)) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Invalid attribute key: ${key}`);
            continue;
        }
        const val = attributes[key];
        if (!$ce0d74c13ee0c534$export$1daad3d2aacf48c5(val)) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Invalid attribute value set for key: ${key}`);
            continue;
        }
        if (Array.isArray(val)) out[key] = val.slice();
        else out[key] = val;
    }
    return out;
}
function $ce0d74c13ee0c534$export$d3dd8ead6a0318c3(key) {
    return typeof key === 'string' && key !== '';
}
function $ce0d74c13ee0c534$export$1daad3d2aacf48c5(val) {
    if (val == null) return true;
    if (Array.isArray(val)) return $ce0d74c13ee0c534$var$isHomogeneousAttributeValueArray(val);
    return $ce0d74c13ee0c534$var$isValidPrimitiveAttributeValueType(typeof val);
}
function $ce0d74c13ee0c534$var$isHomogeneousAttributeValueArray(arr) {
    let type;
    for (const element of arr){
        // null/undefined elements are allowed
        if (element == null) continue;
        const elementType = typeof element;
        if (elementType === type) continue;
        if (!type) {
            if ($ce0d74c13ee0c534$var$isValidPrimitiveAttributeValueType(elementType)) {
                type = elementType;
                continue;
            }
            // encountered an invalid primitive
            return false;
        }
        return false;
    }
    return true;
}
function $ce0d74c13ee0c534$var$isValidPrimitiveAttributeValueType(valType) {
    switch(valType){
        case 'number':
        case 'boolean':
        case 'string':
            return true;
    }
    return false;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 


const $6521ec88e8266cdd$export$b22daef4119238cd = performance;


const $02ed3a94ae5b2eb2$var$NANOSECOND_DIGITS = 9;
const $02ed3a94ae5b2eb2$var$NANOSECOND_DIGITS_IN_MILLIS = 6;
const $02ed3a94ae5b2eb2$var$MILLISECONDS_TO_NANOSECONDS = Math.pow(10, $02ed3a94ae5b2eb2$var$NANOSECOND_DIGITS_IN_MILLIS);
const $02ed3a94ae5b2eb2$var$SECOND_TO_NANOSECONDS = Math.pow(10, $02ed3a94ae5b2eb2$var$NANOSECOND_DIGITS);
function $02ed3a94ae5b2eb2$export$e7ec5c82995537b1(epochMillis) {
    const epochSeconds = epochMillis / 1000;
    // Decimals only.
    const seconds = Math.trunc(epochSeconds);
    // Round sub-nanosecond accuracy to nanosecond.
    const nanos = Math.round(epochMillis % 1000 * $02ed3a94ae5b2eb2$var$MILLISECONDS_TO_NANOSECONDS);
    return [
        seconds,
        nanos
    ];
}
function $02ed3a94ae5b2eb2$export$e752b05e58096a2f() {
    return (0, $6521ec88e8266cdd$export$b22daef4119238cd).timeOrigin;
}
function $02ed3a94ae5b2eb2$export$24b3f7dcd2848fa8(performanceNow) {
    const timeOrigin = $02ed3a94ae5b2eb2$export$e7ec5c82995537b1((0, $6521ec88e8266cdd$export$b22daef4119238cd).timeOrigin);
    const now = $02ed3a94ae5b2eb2$export$e7ec5c82995537b1(typeof performanceNow === 'number' ? performanceNow : (0, $6521ec88e8266cdd$export$b22daef4119238cd).now());
    return $02ed3a94ae5b2eb2$export$f07bb1dbc72184c3(timeOrigin, now);
}
function $02ed3a94ae5b2eb2$export$5f4c8a8ba0e36226(time) {
    // process.hrtime
    if ($02ed3a94ae5b2eb2$export$390c59432f173a9f(time)) return time;
    else if (typeof time === 'number') {
        // Must be a performance.now() if it's smaller than process start time.
        if (time < (0, $6521ec88e8266cdd$export$b22daef4119238cd).timeOrigin) return $02ed3a94ae5b2eb2$export$24b3f7dcd2848fa8(time);
        else // epoch milliseconds or performance.timeOrigin
        return $02ed3a94ae5b2eb2$export$e7ec5c82995537b1(time);
    } else if (time instanceof Date) return $02ed3a94ae5b2eb2$export$e7ec5c82995537b1(time.getTime());
    else throw TypeError('Invalid input type');
}
function $02ed3a94ae5b2eb2$export$b783ad6617389e3e(startTime, endTime) {
    let seconds = endTime[0] - startTime[0];
    let nanos = endTime[1] - startTime[1];
    // overflow
    if (nanos < 0) {
        seconds -= 1;
        // negate
        nanos += $02ed3a94ae5b2eb2$var$SECOND_TO_NANOSECONDS;
    }
    return [
        seconds,
        nanos
    ];
}
function $02ed3a94ae5b2eb2$export$973c1c4fad6103e(time) {
    const precision = $02ed3a94ae5b2eb2$var$NANOSECOND_DIGITS;
    const tmp = `${'0'.repeat(precision)}${time[1]}Z`;
    const nanoString = tmp.substring(tmp.length - precision - 1);
    const date = new Date(time[0] * 1000).toISOString();
    return date.replace('000Z', nanoString);
}
function $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc(time) {
    return time[0] * $02ed3a94ae5b2eb2$var$SECOND_TO_NANOSECONDS + time[1];
}
function $02ed3a94ae5b2eb2$export$30b3706e4e35edf0(time) {
    return time[0] * 1e3 + time[1] / 1e6;
}
function $02ed3a94ae5b2eb2$export$95601fd64fa689b7(time) {
    return time[0] * 1e6 + time[1] / 1e3;
}
function $02ed3a94ae5b2eb2$export$390c59432f173a9f(value) {
    return Array.isArray(value) && value.length === 2 && typeof value[0] === 'number' && typeof value[1] === 'number';
}
function $02ed3a94ae5b2eb2$export$a5e58227c317ebb9(value) {
    return $02ed3a94ae5b2eb2$export$390c59432f173a9f(value) || typeof value === 'number' || value instanceof Date;
}
function $02ed3a94ae5b2eb2$export$f07bb1dbc72184c3(time1, time2) {
    const out = [
        time1[0] + time2[0],
        time1[1] + time2[1]
    ];
    // Nanoseconds
    if (out[1] >= $02ed3a94ae5b2eb2$var$SECOND_TO_NANOSECONDS) {
        out[1] -= $02ed3a94ae5b2eb2$var$SECOND_TO_NANOSECONDS;
        out[0] += 1;
    }
    return out;
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Event name definitions
const $c2e0162c8d3ecc5b$export$a0fff09a5370d06f = 'exception';


class $dd2bc1ab4de8b1df$export$7b15d0c2dba75760 {
    // Below properties are included to implement ReadableSpan for export
    // purposes but are not intended to be written-to directly.
    _spanContext;
    kind;
    parentSpanContext;
    attributes = {};
    links = [];
    events = [];
    startTime;
    resource;
    instrumentationScope;
    _droppedAttributesCount = 0;
    _droppedEventsCount = 0;
    _droppedLinksCount = 0;
    name;
    status = {
        code: (0, $ed982b21ea27c702$export$1e28dd9b5d01db83).UNSET
    };
    endTime = [
        0,
        0
    ];
    _ended = false;
    _duration = [
        -1,
        -1
    ];
    _spanProcessor;
    _spanLimits;
    _attributeValueLengthLimit;
    _performanceStartTime;
    _performanceOffset;
    _startTimeProvided;
    /**
     * Constructs a new SpanImpl instance.
     */ constructor(opts){
        const now = Date.now();
        this._spanContext = opts.spanContext;
        this._performanceStartTime = (0, $6521ec88e8266cdd$export$b22daef4119238cd).now();
        this._performanceOffset = now - (this._performanceStartTime + (0, $6521ec88e8266cdd$export$b22daef4119238cd).timeOrigin);
        this._startTimeProvided = opts.startTime != null;
        this._spanLimits = opts.spanLimits;
        this._attributeValueLengthLimit = this._spanLimits.attributeValueLengthLimit || 0;
        this._spanProcessor = opts.spanProcessor;
        this.name = opts.name;
        this.parentSpanContext = opts.parentSpanContext;
        this.kind = opts.kind;
        this.links = opts.links || [];
        this.startTime = this._getTime(opts.startTime ?? now);
        this.resource = opts.resource;
        this.instrumentationScope = opts.scope;
        if (opts.attributes != null) this.setAttributes(opts.attributes);
        this._spanProcessor.onStart(this, opts.context);
    }
    spanContext() {
        return this._spanContext;
    }
    setAttribute(key, value) {
        if (value == null || this._isSpanEnded()) return this;
        if (key.length === 0) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Invalid attribute key: ${key}`);
            return this;
        }
        if (!(0, $ce0d74c13ee0c534$export$1daad3d2aacf48c5)(value)) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Invalid attribute value set for key: ${key}`);
            return this;
        }
        const { attributeCountLimit: attributeCountLimit } = this._spanLimits;
        if (attributeCountLimit !== undefined && Object.keys(this.attributes).length >= attributeCountLimit && !Object.prototype.hasOwnProperty.call(this.attributes, key)) {
            this._droppedAttributesCount++;
            return this;
        }
        this.attributes[key] = this._truncateToSize(value);
        return this;
    }
    setAttributes(attributes) {
        for (const [k, v] of Object.entries(attributes))this.setAttribute(k, v);
        return this;
    }
    /**
     *
     * @param name Span Name
     * @param [attributesOrStartTime] Span attributes or start time
     *     if type is {@type TimeInput} and 3rd param is undefined
     * @param [timeStamp] Specified time stamp for the event
     */ addEvent(name, attributesOrStartTime, timeStamp) {
        if (this._isSpanEnded()) return this;
        const { eventCountLimit: eventCountLimit } = this._spanLimits;
        if (eventCountLimit === 0) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn('No events allowed.');
            this._droppedEventsCount++;
            return this;
        }
        if (eventCountLimit !== undefined && this.events.length >= eventCountLimit) {
            if (this._droppedEventsCount === 0) (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).debug('Dropping extra events.');
            this.events.shift();
            this._droppedEventsCount++;
        }
        if ((0, $02ed3a94ae5b2eb2$export$a5e58227c317ebb9)(attributesOrStartTime)) {
            if (!(0, $02ed3a94ae5b2eb2$export$a5e58227c317ebb9)(timeStamp)) timeStamp = attributesOrStartTime;
            attributesOrStartTime = undefined;
        }
        const attributes = (0, $ce0d74c13ee0c534$export$b0663eba150d60c9)(attributesOrStartTime);
        this.events.push({
            name: name,
            attributes: attributes,
            time: this._getTime(timeStamp),
            droppedAttributesCount: 0
        });
        return this;
    }
    addLink(link) {
        this.links.push(link);
        return this;
    }
    addLinks(links) {
        this.links.push(...links);
        return this;
    }
    setStatus(status) {
        if (this._isSpanEnded()) return this;
        this.status = {
            ...status
        };
        // When using try-catch, the caught "error" is of type `any`. When then assigning `any` to `status.message`,
        // TypeScript will not error. While this can happen during use of any API, it is more common on Span#setStatus()
        // as it's likely used in a catch-block. Therefore, we validate if `status.message` is actually a string, null, or
        // undefined to avoid an incorrect type causing issues downstream.
        if (this.status.message != null && typeof status.message !== 'string') {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Dropping invalid status.message of type '${typeof status.message}', expected 'string'`);
            delete this.status.message;
        }
        return this;
    }
    updateName(name) {
        if (this._isSpanEnded()) return this;
        this.name = name;
        return this;
    }
    end(endTime) {
        if (this._isSpanEnded()) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).error(`${this.name} ${this._spanContext.traceId}-${this._spanContext.spanId} - You can only call end() on a span once.`);
            return;
        }
        this.endTime = this._getTime(endTime);
        this._duration = (0, $02ed3a94ae5b2eb2$export$b783ad6617389e3e)(this.startTime, this.endTime);
        if (this._duration[0] < 0) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn('Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.', this.startTime, this.endTime);
            this.endTime = this.startTime.slice();
            this._duration = [
                0,
                0
            ];
        }
        if (this._droppedEventsCount > 0) (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Dropped ${this._droppedEventsCount} events because eventCountLimit reached`);
        if (this._spanProcessor.onEnding) this._spanProcessor.onEnding(this);
        this._ended = true;
        this._spanProcessor.onEnd(this);
    }
    _getTime(inp) {
        if (typeof inp === 'number' && inp <= (0, $6521ec88e8266cdd$export$b22daef4119238cd).now()) // must be a performance timestamp
        // apply correction and convert to hrtime
        return (0, $02ed3a94ae5b2eb2$export$24b3f7dcd2848fa8)(inp + this._performanceOffset);
        if (typeof inp === 'number') return (0, $02ed3a94ae5b2eb2$export$e7ec5c82995537b1)(inp);
        if (inp instanceof Date) return (0, $02ed3a94ae5b2eb2$export$e7ec5c82995537b1)(inp.getTime());
        if ((0, $02ed3a94ae5b2eb2$export$390c59432f173a9f)(inp)) return inp;
        if (this._startTimeProvided) // if user provided a time for the start manually
        // we can't use duration to calculate event/end times
        return (0, $02ed3a94ae5b2eb2$export$e7ec5c82995537b1)(Date.now());
        const msDuration = (0, $6521ec88e8266cdd$export$b22daef4119238cd).now() - this._performanceStartTime;
        return (0, $02ed3a94ae5b2eb2$export$f07bb1dbc72184c3)(this.startTime, (0, $02ed3a94ae5b2eb2$export$e7ec5c82995537b1)(msDuration));
    }
    isRecording() {
        return this._ended === false;
    }
    recordException(exception, time) {
        const attributes = {};
        if (typeof exception === 'string') attributes[0, $3fcd7ea0f1087866$export$ab4513c1b55519b5] = exception;
        else if (exception) {
            if (exception.code) attributes[0, $3fcd7ea0f1087866$export$85da07cb5d867763] = exception.code.toString();
            else if (exception.name) attributes[0, $3fcd7ea0f1087866$export$85da07cb5d867763] = exception.name;
            if (exception.message) attributes[0, $3fcd7ea0f1087866$export$ab4513c1b55519b5] = exception.message;
            if (exception.stack) attributes[0, $3fcd7ea0f1087866$export$9b74e4928364b671] = exception.stack;
        }
        // these are minimum requirements from spec
        if (attributes[0, $3fcd7ea0f1087866$export$85da07cb5d867763] || attributes[0, $3fcd7ea0f1087866$export$ab4513c1b55519b5]) this.addEvent((0, $c2e0162c8d3ecc5b$export$a0fff09a5370d06f), attributes, time);
        else (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Failed to record an exception ${exception}`);
    }
    get duration() {
        return this._duration;
    }
    get ended() {
        return this._ended;
    }
    get droppedAttributesCount() {
        return this._droppedAttributesCount;
    }
    get droppedEventsCount() {
        return this._droppedEventsCount;
    }
    get droppedLinksCount() {
        return this._droppedLinksCount;
    }
    _isSpanEnded() {
        if (this._ended) {
            const error = new Error(`Operation attempted on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`);
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Cannot execute the operation on ended Span {traceId: ${this._spanContext.traceId}, spanId: ${this._spanContext.spanId}}`, error);
        }
        return this._ended;
    }
    // Utility function to truncate given value within size
    // for value type of string, will truncate to given limit
    // for type of non-string, will return same value
    _truncateToLimitUtil(value, limit) {
        if (value.length <= limit) return value;
        return value.substring(0, limit);
    }
    /**
     * If the given attribute value is of type string and has more characters than given {@code attributeValueLengthLimit} then
     * return string with truncated to {@code attributeValueLengthLimit} characters
     *
     * If the given attribute value is array of strings then
     * return new array of strings with each element truncated to {@code attributeValueLengthLimit} characters
     *
     * Otherwise return same Attribute {@code value}
     *
     * @param value Attribute value
     * @returns truncated attribute value if required, otherwise same value
     */ _truncateToSize(value) {
        const limit = this._attributeValueLengthLimit;
        // Check limit
        if (limit <= 0) {
            // Negative values are invalid, so do not truncate
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Attribute value limit must be positive, got ${limit}`);
            return value;
        }
        // String
        if (typeof value === 'string') return this._truncateToLimitUtil(value, limit);
        // Array of strings
        if (Array.isArray(value)) return value.map((val)=>typeof val === 'string' ? this._truncateToLimitUtil(val, limit) : val);
        // Other types, no need to apply value length limit
        return value;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */ var $25c79665d2cd8aeb$export$94df7a7a96a92f7b;
(function(SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */ SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */ SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */ SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})($25c79665d2cd8aeb$export$94df7a7a96a92f7b || ($25c79665d2cd8aeb$export$94df7a7a96a92f7b = {}));


class $60169ab10f3cead0$export$abc5f11618c4d6a3 {
    shouldSample() {
        return {
            decision: (0, $25c79665d2cd8aeb$export$94df7a7a96a92f7b).NOT_RECORD
        };
    }
    toString() {
        return 'AlwaysOffSampler';
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $68a767112c26cd40$export$653f832afb4ffa27 {
    shouldSample() {
        return {
            decision: (0, $25c79665d2cd8aeb$export$94df7a7a96a92f7b).RECORD_AND_SAMPLED
        };
    }
    toString() {
        return 'AlwaysOnSampler';
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 



class $b054fb6a94c417b0$export$2bc0b1b09c2e3b47 {
    _root;
    _remoteParentSampled;
    _remoteParentNotSampled;
    _localParentSampled;
    _localParentNotSampled;
    constructor(config){
        this._root = config.root;
        if (!this._root) {
            (0, $c70d952740b6ceea$export$54c6946fc34b7cc2)(new Error('ParentBasedSampler must have a root sampler configured'));
            this._root = new (0, $68a767112c26cd40$export$653f832afb4ffa27)();
        }
        this._remoteParentSampled = config.remoteParentSampled ?? new (0, $68a767112c26cd40$export$653f832afb4ffa27)();
        this._remoteParentNotSampled = config.remoteParentNotSampled ?? new (0, $60169ab10f3cead0$export$abc5f11618c4d6a3)();
        this._localParentSampled = config.localParentSampled ?? new (0, $68a767112c26cd40$export$653f832afb4ffa27)();
        this._localParentNotSampled = config.localParentNotSampled ?? new (0, $60169ab10f3cead0$export$abc5f11618c4d6a3)();
    }
    shouldSample(context, traceId, spanName, spanKind, attributes, links) {
        const parentContext = (0, $496851d2cf78caa4$export$357889f174732d38).getSpanContext(context);
        if (!parentContext || !(0, $99a3da0b8477e363$export$e4373b9a2c09216c)(parentContext)) return this._root.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        if (parentContext.isRemote) {
            if (parentContext.traceFlags & (0, $5dcc187a863bca89$export$bf9049ad2b0883ff).SAMPLED) return this._remoteParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
            return this._remoteParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        if (parentContext.traceFlags & (0, $5dcc187a863bca89$export$bf9049ad2b0883ff).SAMPLED) return this._localParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        return this._localParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
    }
    toString() {
        return `ParentBased{root=${this._root.toString()}, remoteParentSampled=${this._remoteParentSampled.toString()}, remoteParentNotSampled=${this._remoteParentNotSampled.toString()}, localParentSampled=${this._localParentSampled.toString()}, localParentNotSampled=${this._localParentNotSampled.toString()}}`;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

class $faaa926fe3c38efa$export$f1624f887f708bbf {
    _ratio;
    _upperBound;
    constructor(ratio = 0){
        this._ratio = this._normalize(ratio);
        this._upperBound = Math.floor(this._ratio * 0xffffffff);
    }
    shouldSample(context, traceId) {
        return {
            decision: (0, $99a3da0b8477e363$export$29dd34cf1269f6da)(traceId) && this._accumulate(traceId) < this._upperBound ? (0, $25c79665d2cd8aeb$export$94df7a7a96a92f7b).RECORD_AND_SAMPLED : (0, $25c79665d2cd8aeb$export$94df7a7a96a92f7b).NOT_RECORD
        };
    }
    toString() {
        return `TraceIdRatioBased{${this._ratio}}`;
    }
    _normalize(ratio) {
        if (typeof ratio !== 'number' || isNaN(ratio)) return 0;
        return ratio >= 1 ? 1 : ratio <= 0 ? 0 : ratio;
    }
    _accumulate(traceId) {
        let accumulation = 0;
        for(let i = 0; i < traceId.length / 8; i++){
            const pos = i * 8;
            const part = parseInt(traceId.slice(pos, pos + 8), 16);
            accumulation = (accumulation ^ part) >>> 0;
        }
        return accumulation;
    }
}


var $591d7c39ce34927b$var$TracesSamplerValues;
(function(TracesSamplerValues) {
    TracesSamplerValues["AlwaysOff"] = "always_off";
    TracesSamplerValues["AlwaysOn"] = "always_on";
    TracesSamplerValues["ParentBasedAlwaysOff"] = "parentbased_always_off";
    TracesSamplerValues["ParentBasedAlwaysOn"] = "parentbased_always_on";
    TracesSamplerValues["ParentBasedTraceIdRatio"] = "parentbased_traceidratio";
    TracesSamplerValues["TraceIdRatio"] = "traceidratio";
})($591d7c39ce34927b$var$TracesSamplerValues || ($591d7c39ce34927b$var$TracesSamplerValues = {}));
const $591d7c39ce34927b$var$DEFAULT_RATIO = 1;
function $591d7c39ce34927b$export$d25a2c2f78a5e968() {
    return {
        sampler: $591d7c39ce34927b$export$534308d7e73f0e71(),
        forceFlushTimeoutMillis: 30000,
        generalLimits: {
            attributeValueLengthLimit: (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? Infinity,
            attributeCountLimit: (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_COUNT_LIMIT') ?? 128
        },
        spanLimits: {
            attributeValueLengthLimit: (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? Infinity,
            attributeCountLimit: (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT') ?? 128,
            linkCountLimit: (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_SPAN_LINK_COUNT_LIMIT') ?? 128,
            eventCountLimit: (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_SPAN_EVENT_COUNT_LIMIT') ?? 128,
            attributePerEventCountLimit: (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT') ?? 128,
            attributePerLinkCountLimit: (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT') ?? 128
        }
    };
}
function $591d7c39ce34927b$export$534308d7e73f0e71() {
    const sampler = (0, $2904c97a66abe41f$export$c1cd528968868329)('OTEL_TRACES_SAMPLER') ?? $591d7c39ce34927b$var$TracesSamplerValues.ParentBasedAlwaysOn;
    switch(sampler){
        case $591d7c39ce34927b$var$TracesSamplerValues.AlwaysOn:
            return new (0, $68a767112c26cd40$export$653f832afb4ffa27)();
        case $591d7c39ce34927b$var$TracesSamplerValues.AlwaysOff:
            return new (0, $60169ab10f3cead0$export$abc5f11618c4d6a3)();
        case $591d7c39ce34927b$var$TracesSamplerValues.ParentBasedAlwaysOn:
            return new (0, $b054fb6a94c417b0$export$2bc0b1b09c2e3b47)({
                root: new (0, $68a767112c26cd40$export$653f832afb4ffa27)()
            });
        case $591d7c39ce34927b$var$TracesSamplerValues.ParentBasedAlwaysOff:
            return new (0, $b054fb6a94c417b0$export$2bc0b1b09c2e3b47)({
                root: new (0, $60169ab10f3cead0$export$abc5f11618c4d6a3)()
            });
        case $591d7c39ce34927b$var$TracesSamplerValues.TraceIdRatio:
            return new (0, $faaa926fe3c38efa$export$f1624f887f708bbf)($591d7c39ce34927b$var$getSamplerProbabilityFromEnv());
        case $591d7c39ce34927b$var$TracesSamplerValues.ParentBasedTraceIdRatio:
            return new (0, $b054fb6a94c417b0$export$2bc0b1b09c2e3b47)({
                root: new (0, $faaa926fe3c38efa$export$f1624f887f708bbf)($591d7c39ce34927b$var$getSamplerProbabilityFromEnv())
            });
        default:
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).error(`OTEL_TRACES_SAMPLER value "${sampler}" invalid, defaulting to "${$591d7c39ce34927b$var$TracesSamplerValues.ParentBasedAlwaysOn}".`);
            return new (0, $b054fb6a94c417b0$export$2bc0b1b09c2e3b47)({
                root: new (0, $68a767112c26cd40$export$653f832afb4ffa27)()
            });
    }
}
function $591d7c39ce34927b$var$getSamplerProbabilityFromEnv() {
    const probability = (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_TRACES_SAMPLER_ARG');
    if (probability == null) {
        (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).error(`OTEL_TRACES_SAMPLER_ARG is blank, defaulting to ${$591d7c39ce34927b$var$DEFAULT_RATIO}.`);
        return $591d7c39ce34927b$var$DEFAULT_RATIO;
    }
    if (probability < 0 || probability > 1) {
        (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).error(`OTEL_TRACES_SAMPLER_ARG=${probability} was given, but it is out of range ([0..1]), defaulting to ${$591d7c39ce34927b$var$DEFAULT_RATIO}.`);
        return $591d7c39ce34927b$var$DEFAULT_RATIO;
    }
    return probability;
}



const $42239b7258725033$export$6ad612be99f9ed48 = 128;
const $42239b7258725033$export$d9446f3c1c12def1 = Infinity;
function $42239b7258725033$export$7ec1ebcfa9d8bd6a(userConfig) {
    const perInstanceDefaults = {
        sampler: (0, $591d7c39ce34927b$export$534308d7e73f0e71)()
    };
    const DEFAULT_CONFIG = (0, $591d7c39ce34927b$export$d25a2c2f78a5e968)();
    const target = Object.assign({}, DEFAULT_CONFIG, perInstanceDefaults, userConfig);
    target.generalLimits = Object.assign({}, DEFAULT_CONFIG.generalLimits, userConfig.generalLimits || {});
    target.spanLimits = Object.assign({}, DEFAULT_CONFIG.spanLimits, userConfig.spanLimits || {});
    return target;
}
function $42239b7258725033$export$9f9fb435f8494555(userConfig) {
    const spanLimits = Object.assign({}, userConfig.spanLimits);
    /**
     * Reassign span attribute count limit to use first non null value defined by user or use default value
     */ spanLimits.attributeCountLimit = userConfig.spanLimits?.attributeCountLimit ?? userConfig.generalLimits?.attributeCountLimit ?? (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT') ?? (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_COUNT_LIMIT') ?? $42239b7258725033$export$6ad612be99f9ed48;
    /**
     * Reassign span attribute value length limit to use first non null value defined by user or use default value
     */ spanLimits.attributeValueLengthLimit = userConfig.spanLimits?.attributeValueLengthLimit ?? userConfig.generalLimits?.attributeValueLengthLimit ?? (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? (0, $2904c97a66abe41f$export$9d6c13e44580559c)('OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT') ?? $42239b7258725033$export$d9446f3c1c12def1;
    return Object.assign({}, userConfig, {
        spanLimits: spanLimits
    });
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c9cac266b6afb7c8$var$SPAN_ID_BYTES = 8;
const $c9cac266b6afb7c8$var$TRACE_ID_BYTES = 16;
class $c9cac266b6afb7c8$export$97307207ef48da75 {
    /**
     * Returns a random 16-byte trace ID formatted/encoded as a 32 lowercase hex
     * characters corresponding to 128 bits.
     */ generateTraceId = $c9cac266b6afb7c8$var$getIdGenerator($c9cac266b6afb7c8$var$TRACE_ID_BYTES);
    /**
     * Returns a random 8-byte span ID formatted/encoded as a 16 lowercase hex
     * characters corresponding to 64 bits.
     */ generateSpanId = $c9cac266b6afb7c8$var$getIdGenerator($c9cac266b6afb7c8$var$SPAN_ID_BYTES);
}
const $c9cac266b6afb7c8$var$SHARED_CHAR_CODES_ARRAY = Array(32);
function $c9cac266b6afb7c8$var$getIdGenerator(bytes) {
    return function generateId() {
        for(let i = 0; i < bytes * 2; i++){
            $c9cac266b6afb7c8$var$SHARED_CHAR_CODES_ARRAY[i] = Math.floor(Math.random() * 16) + 48;
            // valid hex characters in the range 48-57 and 97-102
            if ($c9cac266b6afb7c8$var$SHARED_CHAR_CODES_ARRAY[i] >= 58) $c9cac266b6afb7c8$var$SHARED_CHAR_CODES_ARRAY[i] += 39;
        }
        return String.fromCharCode.apply(null, $c9cac266b6afb7c8$var$SHARED_CHAR_CODES_ARRAY.slice(0, bytes * 2));
    };
}


class $69210e1664695281$export$c4b9363e2fc65361 {
    _sampler;
    _generalLimits;
    _spanLimits;
    _idGenerator;
    instrumentationScope;
    _resource;
    _spanProcessor;
    /**
     * Constructs a new Tracer instance.
     */ constructor(instrumentationScope, config, resource, spanProcessor){
        const localConfig = (0, $42239b7258725033$export$7ec1ebcfa9d8bd6a)(config);
        this._sampler = localConfig.sampler;
        this._generalLimits = localConfig.generalLimits;
        this._spanLimits = localConfig.spanLimits;
        this._idGenerator = config.idGenerator || new (0, $c9cac266b6afb7c8$export$97307207ef48da75)();
        this._resource = resource;
        this._spanProcessor = spanProcessor;
        this.instrumentationScope = instrumentationScope;
    }
    /**
     * Starts a new Span or returns the default NoopSpan based on the sampling
     * decision.
     */ startSpan(name, options = {}, context = $0c57d9262090934c$export$a078c61943f9dbbe.active()) {
        // remove span from context in case a root span is requested via options
        if (options.root) context = $496851d2cf78caa4$export$357889f174732d38.deleteSpan(context);
        const parentSpan = $496851d2cf78caa4$export$357889f174732d38.getSpan(context);
        if ((0, $a2728a0463bf3b1f$export$7d5f2376f7cf513)(context)) {
            $0006a4b399ea8ee4$export$c042e7c2f59bc046.debug('Instrumentation suppressed, returning Noop Span');
            const nonRecordingSpan = $496851d2cf78caa4$export$357889f174732d38.wrapSpanContext($c0773e3017d46dd4$export$8591e4c852b66703);
            return nonRecordingSpan;
        }
        const parentSpanContext = parentSpan?.spanContext();
        const spanId = this._idGenerator.generateSpanId();
        let validParentSpanContext;
        let traceId;
        let traceState;
        if (!parentSpanContext || !$496851d2cf78caa4$export$357889f174732d38.isSpanContextValid(parentSpanContext)) // New root span.
        traceId = this._idGenerator.generateTraceId();
        else {
            // New child span.
            traceId = parentSpanContext.traceId;
            traceState = parentSpanContext.traceState;
            validParentSpanContext = parentSpanContext;
        }
        const spanKind = options.kind ?? $566044c3d0fbdc36$export$4da4ea8145910e8b.INTERNAL;
        const links = (options.links ?? []).map((link)=>{
            return {
                context: link.context,
                attributes: (0, $ce0d74c13ee0c534$export$b0663eba150d60c9)(link.attributes)
            };
        });
        const attributes = (0, $ce0d74c13ee0c534$export$b0663eba150d60c9)(options.attributes);
        // make sampling decision
        const samplingResult = this._sampler.shouldSample(context, traceId, name, spanKind, attributes, links);
        traceState = samplingResult.traceState ?? traceState;
        const traceFlags = samplingResult.decision === $0cc84bf49b6d9783$export$94df7a7a96a92f7b.RECORD_AND_SAMPLED ? $5dcc187a863bca89$export$bf9049ad2b0883ff.SAMPLED : $5dcc187a863bca89$export$bf9049ad2b0883ff.NONE;
        const spanContext = {
            traceId: traceId,
            spanId: spanId,
            traceFlags: traceFlags,
            traceState: traceState
        };
        if (samplingResult.decision === $0cc84bf49b6d9783$export$94df7a7a96a92f7b.NOT_RECORD) {
            $0006a4b399ea8ee4$export$c042e7c2f59bc046.debug('Recording is off, propagating context in a non-recording span');
            const nonRecordingSpan = $496851d2cf78caa4$export$357889f174732d38.wrapSpanContext(spanContext);
            return nonRecordingSpan;
        }
        // Set initial span attributes. The attributes object may have been mutated
        // by the sampler, so we sanitize the merged attributes before setting them.
        const initAttributes = (0, $ce0d74c13ee0c534$export$b0663eba150d60c9)(Object.assign(attributes, samplingResult.attributes));
        const span = new (0, $dd2bc1ab4de8b1df$export$7b15d0c2dba75760)({
            resource: this._resource,
            scope: this.instrumentationScope,
            context: context,
            spanContext: spanContext,
            name: name,
            kind: spanKind,
            links: links,
            parentSpanContext: validParentSpanContext,
            attributes: initAttributes,
            startTime: options.startTime,
            spanProcessor: this._spanProcessor,
            spanLimits: this._spanLimits
        });
        return span;
    }
    startActiveSpan(name, arg2, arg3, arg4) {
        let opts;
        let ctx;
        let fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        const parentContext = ctx ?? $0c57d9262090934c$export$a078c61943f9dbbe.active();
        const span = this.startSpan(name, opts, parentContext);
        const contextWithSpanSet = $496851d2cf78caa4$export$357889f174732d38.setSpan(parentContext, span);
        return $0c57d9262090934c$export$a078c61943f9dbbe.with(contextWithSpanSet, fn, undefined, span);
    }
    /** Returns the active {@link GeneralLimits}. */ getGeneralLimits() {
        return this._generalLimits;
    }
    /** Returns the active {@link SpanLimits}. */ getSpanLimits() {
        return this._spanLimits;
    }
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $532398cbdb6e6938$export$3012fe5a49154394 {
    _spanProcessors;
    constructor(spanProcessors){
        this._spanProcessors = spanProcessors;
    }
    forceFlush() {
        const promises = [];
        for (const spanProcessor of this._spanProcessors)promises.push(spanProcessor.forceFlush());
        return new Promise((resolve)=>{
            Promise.all(promises).then(()=>{
                resolve();
            }).catch((error)=>{
                (0, $c70d952740b6ceea$export$54c6946fc34b7cc2)(error || new Error('MultiSpanProcessor: forceFlush failed'));
                resolve();
            });
        });
    }
    onStart(span, context) {
        for (const spanProcessor of this._spanProcessors)spanProcessor.onStart(span, context);
    }
    onEnding(span) {
        for (const spanProcessor of this._spanProcessors)if (spanProcessor.onEnding) spanProcessor.onEnding(span);
    }
    onEnd(span) {
        for (const spanProcessor of this._spanProcessors)spanProcessor.onEnd(span);
    }
    shutdown() {
        const promises = [];
        for (const spanProcessor of this._spanProcessors)promises.push(spanProcessor.shutdown());
        return new Promise((resolve, reject)=>{
            Promise.all(promises).then(()=>{
                resolve();
            }, reject);
        });
    }
}



var $09b0f540efe38fab$export$11a85395fcf5a7f0;
(function(ForceFlushState) {
    ForceFlushState[ForceFlushState["resolved"] = 0] = "resolved";
    ForceFlushState[ForceFlushState["timeout"] = 1] = "timeout";
    ForceFlushState[ForceFlushState["error"] = 2] = "error";
    ForceFlushState[ForceFlushState["unresolved"] = 3] = "unresolved";
})($09b0f540efe38fab$export$11a85395fcf5a7f0 || ($09b0f540efe38fab$export$11a85395fcf5a7f0 = {}));
class $09b0f540efe38fab$export$1f2f0f67f5ecff3b {
    _config;
    _tracers = new Map();
    _resource;
    _activeSpanProcessor;
    constructor(config = {}){
        const mergedConfig = (0, $a99eaf6108fc00d6$export$4950aa0f605343fb)({}, (0, $591d7c39ce34927b$export$d25a2c2f78a5e968)(), (0, $42239b7258725033$export$9f9fb435f8494555)(config));
        this._resource = mergedConfig.resource ?? (0, $34b7feab81bdb448$export$522a862cad1b0abc)();
        this._config = Object.assign({}, mergedConfig, {
            resource: this._resource
        });
        const spanProcessors = [];
        if (config.spanProcessors?.length) spanProcessors.push(...config.spanProcessors);
        this._activeSpanProcessor = new (0, $532398cbdb6e6938$export$3012fe5a49154394)(spanProcessors);
    }
    getTracer(name, version, options) {
        const key = `${name}@${version || ''}:${options?.schemaUrl || ''}`;
        if (!this._tracers.has(key)) this._tracers.set(key, new (0, $69210e1664695281$export$c4b9363e2fc65361)({
            name: name,
            version: version,
            schemaUrl: options?.schemaUrl
        }, this._config, this._resource, this._activeSpanProcessor));
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this._tracers.get(key);
    }
    forceFlush() {
        const timeout = this._config.forceFlushTimeoutMillis;
        const promises = this._activeSpanProcessor['_spanProcessors'].map((spanProcessor)=>{
            return new Promise((resolve)=>{
                let state;
                const timeoutInterval = setTimeout(()=>{
                    resolve(new Error(`Span processor did not completed within timeout period of ${timeout} ms`));
                    state = $09b0f540efe38fab$export$11a85395fcf5a7f0.timeout;
                }, timeout);
                spanProcessor.forceFlush().then(()=>{
                    clearTimeout(timeoutInterval);
                    if (state !== $09b0f540efe38fab$export$11a85395fcf5a7f0.timeout) {
                        state = $09b0f540efe38fab$export$11a85395fcf5a7f0.resolved;
                        resolve(state);
                    }
                }).catch((error)=>{
                    clearTimeout(timeoutInterval);
                    state = $09b0f540efe38fab$export$11a85395fcf5a7f0.error;
                    resolve(error);
                });
            });
        });
        return new Promise((resolve, reject)=>{
            Promise.all(promises).then((results)=>{
                const errors = results.filter((result)=>result !== $09b0f540efe38fab$export$11a85395fcf5a7f0.resolved);
                if (errors.length > 0) reject(errors);
                else resolve();
            }).catch((error)=>reject([
                    error
                ]));
        });
    }
    shutdown() {
        return this._activeSpanProcessor.shutdown();
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $a8d66854eb53d217$export$3dfe62dd209faf13 {
    /**
     * whether the context manager is enabled or not
     */ _enabled = false;
    /**
     * Keeps the reference to current context
     */ _currentContext = (0, $411320e1da10ff3d$export$78df28f9b2f9a7dc);
    /**
     *
     * @param context
     * @param target Function to be executed within the context
     */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context = (0, $411320e1da10ff3d$export$78df28f9b2f9a7dc), target) {
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
     * Returns the active context
     */ active() {
        return this._currentContext;
    }
    /**
     * Binds a the certain context or the active one to the target function and then returns the target
     * @param context A context (span) to be bind to target
     * @param target a function or event emitter. When target or one of its callbacks is called,
     *  the provided context will be used as the active context for the duration of the call.
     */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        return target;
    }
    /**
     * Disable the context manager (clears the current context)
     */ disable() {
        this._currentContext = (0, $411320e1da10ff3d$export$78df28f9b2f9a7dc);
        this._enabled = false;
        return this;
    }
    /**
     * Enables the context manager and creates a default(root) context
     */ enable() {
        if (this._enabled) return this;
        this._enabled = true;
        this._currentContext = (0, $411320e1da10ff3d$export$78df28f9b2f9a7dc);
        return this;
    }
    /**
     * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
     * The context will be set as active
     * @param context
     * @param fn Callback function
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ with(context, fn, thisArg, ...args) {
        const previousContext = this._currentContext;
        this._currentContext = context || (0, $411320e1da10ff3d$export$78df28f9b2f9a7dc);
        try {
            return fn.call(thisArg, ...args);
        } finally{
            this._currentContext = previousContext;
        }
    }
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $ff40152fd01f45b5$export$4beb26f46770357f {
    _propagators;
    _fields;
    /**
     * Construct a composite propagator from a list of propagators.
     *
     * @param [config] Configuration object for composite propagator
     */ constructor(config = {}){
        this._propagators = config.propagators ?? [];
        this._fields = Array.from(new Set(this._propagators// older propagators may not have fields function, null check to be sure
        .map((p)=>typeof p.fields === 'function' ? p.fields() : []).reduce((x, y)=>x.concat(y), [])));
    }
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same carrier key, the propagator later in the list
     * will "win".
     *
     * @param context Context to inject
     * @param carrier Carrier into which context will be injected
     */ inject(context, carrier, setter) {
        for (const propagator of this._propagators)try {
            propagator.inject(context, carrier, setter);
        } catch (err) {
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Failed to inject with ${propagator.constructor.name}. Err: ${err.message}`);
        }
    }
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same context key, the propagator later in the list
     * will "win".
     *
     * @param context Context to add values to
     * @param carrier Carrier from which to extract context
     */ extract(context, carrier, getter) {
        return this._propagators.reduce((ctx, propagator)=>{
            try {
                return propagator.extract(ctx, carrier, getter);
            } catch (err) {
                (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Failed to extract with ${propagator.constructor.name}. Err: ${err.message}`);
            }
            return ctx;
        }, context);
    }
    fields() {
        // return a new array so our fields cannot be modified
        return this._fields.slice();
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f115375854688b9c$export$3043215ef908d54f = '=';
const $f115375854688b9c$export$393a3f9e6e76438 = ';';
const $f115375854688b9c$export$1ab471785c2cf557 = ',';
const $f115375854688b9c$export$a6199dd4fe419e69 = 'baggage';
const $f115375854688b9c$export$9a50757016085e99 = 180;
const $f115375854688b9c$export$c7d9e39bb295c1f = 4096;
const $f115375854688b9c$export$dd0527bee1f518e7 = 8192;


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

function $34e1b15c9a64a7b4$export$790fc82b2ff5bf87(keyPairs) {
    return keyPairs.reduce((hValue, current)=>{
        const value = `${hValue}${hValue !== '' ? (0, $f115375854688b9c$export$1ab471785c2cf557) : ''}${current}`;
        return value.length > (0, $f115375854688b9c$export$dd0527bee1f518e7) ? hValue : value;
    }, '');
}
function $34e1b15c9a64a7b4$export$ed4c06f0919b1951(baggage) {
    return baggage.getAllEntries().map(([key, value])=>{
        let entry = `${encodeURIComponent(key)}=${encodeURIComponent(value.value)}`;
        // include opaque metadata if provided
        // NOTE: we intentionally don't URI-encode the metadata - that responsibility falls on the metadata implementation
        if (value.metadata !== undefined) entry += (0, $f115375854688b9c$export$393a3f9e6e76438) + value.metadata.toString();
        return entry;
    });
}
function $34e1b15c9a64a7b4$export$62659c450b08e504(entry) {
    if (!entry) return;
    const metadataSeparatorIndex = entry.indexOf((0, $f115375854688b9c$export$393a3f9e6e76438));
    const keyPairPart = metadataSeparatorIndex === -1 ? entry : entry.substring(0, metadataSeparatorIndex);
    const separatorIndex = keyPairPart.indexOf((0, $f115375854688b9c$export$3043215ef908d54f));
    if (separatorIndex <= 0) return;
    const rawKey = keyPairPart.substring(0, separatorIndex).trim();
    const rawValue = keyPairPart.substring(separatorIndex + 1).trim();
    if (!rawKey || !rawValue) return;
    let key;
    let value;
    try {
        key = decodeURIComponent(rawKey);
        value = decodeURIComponent(rawValue);
    } catch  {
        return;
    }
    let metadata;
    if (metadataSeparatorIndex !== -1 && metadataSeparatorIndex < entry.length - 1) {
        const metadataString = entry.substring(metadataSeparatorIndex + 1);
        metadata = (0, $36ecce552d4bbf35$export$c491cedc1b2b6e9e)(metadataString);
    }
    return {
        key: key,
        value: value,
        metadata: metadata
    };
}
function $34e1b15c9a64a7b4$export$1259660ed6830e21(value) {
    const result = {};
    if (typeof value === 'string' && value.length > 0) value.split((0, $f115375854688b9c$export$1ab471785c2cf557)).forEach((entry)=>{
        const keyPair = $34e1b15c9a64a7b4$export$62659c450b08e504(entry);
        if (keyPair !== undefined && keyPair.value.length > 0) result[keyPair.key] = keyPair.value;
    });
    return result;
}


class $12d7120b6dd6df4f$export$604bcc7f2bff6bb {
    inject(context, carrier, setter) {
        const baggage = (0, $77955577000c938d$export$3e49040daa9dba20).getBaggage(context);
        if (!baggage || (0, $a2728a0463bf3b1f$export$7d5f2376f7cf513)(context)) return;
        const keyPairs = (0, $34e1b15c9a64a7b4$export$ed4c06f0919b1951)(baggage).filter((pair)=>{
            return pair.length <= (0, $f115375854688b9c$export$c7d9e39bb295c1f);
        }).slice(0, (0, $f115375854688b9c$export$9a50757016085e99));
        const headerValue = (0, $34e1b15c9a64a7b4$export$790fc82b2ff5bf87)(keyPairs);
        if (headerValue.length > 0) setter.set(carrier, (0, $f115375854688b9c$export$a6199dd4fe419e69), headerValue);
    }
    extract(context, carrier, getter) {
        const headerValue = getter.get(carrier, (0, $f115375854688b9c$export$a6199dd4fe419e69));
        const baggageString = Array.isArray(headerValue) ? headerValue.join((0, $f115375854688b9c$export$1ab471785c2cf557)) : headerValue;
        if (!baggageString) return context;
        const baggage = {};
        if (baggageString.length === 0) return context;
        const pairs = baggageString.split((0, $f115375854688b9c$export$1ab471785c2cf557));
        pairs.forEach((entry)=>{
            const keyPair = (0, $34e1b15c9a64a7b4$export$62659c450b08e504)(entry);
            if (keyPair) {
                const baggageEntry = {
                    value: keyPair.value
                };
                if (keyPair.metadata) baggageEntry.metadata = keyPair.metadata;
                baggage[keyPair.key] = baggageEntry;
            }
        });
        if (Object.entries(baggage).length === 0) return context;
        return (0, $77955577000c938d$export$3e49040daa9dba20).setBaggage(context, (0, $77955577000c938d$export$3e49040daa9dba20).createBaggage(baggage));
    }
    fields() {
        return [
            (0, $f115375854688b9c$export$a6199dd4fe419e69)
        ];
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $d42c44c5a713d81c$var$VALID_KEY_CHAR_RANGE = '[_0-9a-z-*/]';
const $d42c44c5a713d81c$var$VALID_KEY = `[a-z]${$d42c44c5a713d81c$var$VALID_KEY_CHAR_RANGE}{0,255}`;
const $d42c44c5a713d81c$var$VALID_VENDOR_KEY = `[a-z0-9]${$d42c44c5a713d81c$var$VALID_KEY_CHAR_RANGE}{0,240}@[a-z]${$d42c44c5a713d81c$var$VALID_KEY_CHAR_RANGE}{0,13}`;
const $d42c44c5a713d81c$var$VALID_KEY_REGEX = new RegExp(`^(?:${$d42c44c5a713d81c$var$VALID_KEY}|${$d42c44c5a713d81c$var$VALID_VENDOR_KEY})$`);
const $d42c44c5a713d81c$var$VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
const $d42c44c5a713d81c$var$INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
function $d42c44c5a713d81c$export$469cc9c479301ba6(key) {
    return $d42c44c5a713d81c$var$VALID_KEY_REGEX.test(key);
}
function $d42c44c5a713d81c$export$b76e9316566cc26e(value) {
    return $d42c44c5a713d81c$var$VALID_VALUE_BASE_REGEX.test(value) && !$d42c44c5a713d81c$var$INVALID_VALUE_COMMA_EQUAL_REGEX.test(value);
}


const $da45a91e3c0e04ee$var$MAX_TRACE_STATE_ITEMS = 32;
const $da45a91e3c0e04ee$var$MAX_TRACE_STATE_LEN = 512;
const $da45a91e3c0e04ee$var$LIST_MEMBERS_SEPARATOR = ',';
const $da45a91e3c0e04ee$var$LIST_MEMBER_KEY_VALUE_SPLITTER = '=';
class $da45a91e3c0e04ee$export$b0addedc390b67c2 {
    _internalState = new Map();
    constructor(rawTraceState){
        if (rawTraceState) this._parse(rawTraceState);
    }
    set(key, value) {
        // TODO: Benchmark the different approaches(map vs list) and
        // use the faster one.
        const traceState = this._clone();
        if (traceState._internalState.has(key)) traceState._internalState.delete(key);
        traceState._internalState.set(key, value);
        return traceState;
    }
    unset(key) {
        const traceState = this._clone();
        traceState._internalState.delete(key);
        return traceState;
    }
    get(key) {
        return this._internalState.get(key);
    }
    serialize() {
        return this._keys().reduce((agg, key)=>{
            agg.push(key + $da45a91e3c0e04ee$var$LIST_MEMBER_KEY_VALUE_SPLITTER + this.get(key));
            return agg;
        }, []).join($da45a91e3c0e04ee$var$LIST_MEMBERS_SEPARATOR);
    }
    _parse(rawTraceState) {
        if (rawTraceState.length > $da45a91e3c0e04ee$var$MAX_TRACE_STATE_LEN) return;
        this._internalState = rawTraceState.split($da45a91e3c0e04ee$var$LIST_MEMBERS_SEPARATOR).reverse() // Store in reverse so new keys (.set(...)) will be placed at the beginning
        .reduce((agg, part)=>{
            const listMember = part.trim(); // Optional Whitespace (OWS) handling
            const i = listMember.indexOf($da45a91e3c0e04ee$var$LIST_MEMBER_KEY_VALUE_SPLITTER);
            if (i !== -1) {
                const key = listMember.slice(0, i);
                const value = listMember.slice(i + 1, part.length);
                if ((0, $d42c44c5a713d81c$export$469cc9c479301ba6)(key) && (0, $d42c44c5a713d81c$export$b76e9316566cc26e)(value)) agg.set(key, value);
            }
            return agg;
        }, new Map());
        // Because of the reverse() requirement, trunc must be done after map is created
        if (this._internalState.size > $da45a91e3c0e04ee$var$MAX_TRACE_STATE_ITEMS) this._internalState = new Map(Array.from(this._internalState.entries()).reverse() // Use reverse same as original tracestate parse chain
        .slice(0, $da45a91e3c0e04ee$var$MAX_TRACE_STATE_ITEMS));
    }
    _keys() {
        return Array.from(this._internalState.keys()).reverse();
    }
    _clone() {
        const traceState = new $da45a91e3c0e04ee$export$b0addedc390b67c2();
        traceState._internalState = new Map(this._internalState);
        return traceState;
    }
}


const $972b3cdb4eaa2e74$export$830e05fa2746348 = 'traceparent';
const $972b3cdb4eaa2e74$export$2b12ed38dcfae2ae = 'tracestate';
const $972b3cdb4eaa2e74$var$VERSION = '00';
const $972b3cdb4eaa2e74$var$VERSION_PART = '(?!ff)[\\da-f]{2}';
const $972b3cdb4eaa2e74$var$TRACE_ID_PART = '(?![0]{32})[\\da-f]{32}';
const $972b3cdb4eaa2e74$var$PARENT_ID_PART = '(?![0]{16})[\\da-f]{16}';
const $972b3cdb4eaa2e74$var$FLAGS_PART = '[\\da-f]{2}';
const $972b3cdb4eaa2e74$var$TRACE_PARENT_REGEX = new RegExp(`^\\s?(${$972b3cdb4eaa2e74$var$VERSION_PART})-(${$972b3cdb4eaa2e74$var$TRACE_ID_PART})-(${$972b3cdb4eaa2e74$var$PARENT_ID_PART})-(${$972b3cdb4eaa2e74$var$FLAGS_PART})(-.*)?\\s?$`);
function $972b3cdb4eaa2e74$export$f4d87f8901a93f5d(traceParent) {
    const match = $972b3cdb4eaa2e74$var$TRACE_PARENT_REGEX.exec(traceParent);
    if (!match) return null;
    // According to the specification the implementation should be compatible
    // with future versions. If there are more parts, we only reject it if it's using version 00
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    if (match[1] === '00' && match[5]) return null;
    return {
        traceId: match[2],
        spanId: match[3],
        traceFlags: parseInt(match[4], 16)
    };
}
class $972b3cdb4eaa2e74$export$737c747d043a1f7b {
    inject(context, carrier, setter) {
        const spanContext = (0, $496851d2cf78caa4$export$357889f174732d38).getSpanContext(context);
        if (!spanContext || (0, $a2728a0463bf3b1f$export$7d5f2376f7cf513)(context) || !(0, $99a3da0b8477e363$export$e4373b9a2c09216c)(spanContext)) return;
        const traceParent = `${$972b3cdb4eaa2e74$var$VERSION}-${spanContext.traceId}-${spanContext.spanId}-0${Number(spanContext.traceFlags || (0, $5dcc187a863bca89$export$bf9049ad2b0883ff).NONE).toString(16)}`;
        setter.set(carrier, $972b3cdb4eaa2e74$export$830e05fa2746348, traceParent);
        if (spanContext.traceState) setter.set(carrier, $972b3cdb4eaa2e74$export$2b12ed38dcfae2ae, spanContext.traceState.serialize());
    }
    extract(context, carrier, getter) {
        const traceParentHeader = getter.get(carrier, $972b3cdb4eaa2e74$export$830e05fa2746348);
        if (!traceParentHeader) return context;
        const traceParent = Array.isArray(traceParentHeader) ? traceParentHeader[0] : traceParentHeader;
        if (typeof traceParent !== 'string') return context;
        const spanContext = $972b3cdb4eaa2e74$export$f4d87f8901a93f5d(traceParent);
        if (!spanContext) return context;
        spanContext.isRemote = true;
        const traceStateHeader = getter.get(carrier, $972b3cdb4eaa2e74$export$2b12ed38dcfae2ae);
        if (traceStateHeader) {
            // If more than one `tracestate` header is found, we merge them into a
            // single header.
            const state = Array.isArray(traceStateHeader) ? traceStateHeader.join(',') : traceStateHeader;
            spanContext.traceState = new (0, $da45a91e3c0e04ee$export$b0addedc390b67c2)(typeof state === 'string' ? state : undefined);
        }
        return (0, $496851d2cf78caa4$export$357889f174732d38).setSpanContext(context, spanContext);
    }
    fields() {
        return [
            $972b3cdb4eaa2e74$export$830e05fa2746348,
            $972b3cdb4eaa2e74$export$2b12ed38dcfae2ae
        ];
    }
}


function $63a533b9ee75e32f$var$setupContextManager(contextManager) {
    // null means 'do not register'
    if (contextManager === null) return;
    // undefined means 'register default'
    if (contextManager === undefined) {
        const defaultContextManager = new (0, $a8d66854eb53d217$export$3dfe62dd209faf13)();
        defaultContextManager.enable();
        (0, $0c57d9262090934c$export$a078c61943f9dbbe).setGlobalContextManager(defaultContextManager);
        return;
    }
    contextManager.enable();
    (0, $0c57d9262090934c$export$a078c61943f9dbbe).setGlobalContextManager(contextManager);
}
function $63a533b9ee75e32f$var$setupPropagator(propagator) {
    // null means 'do not register'
    if (propagator === null) return;
    // undefined means 'register default'
    if (propagator === undefined) {
        (0, $77955577000c938d$export$3e49040daa9dba20).setGlobalPropagator(new (0, $ff40152fd01f45b5$export$4beb26f46770357f)({
            propagators: [
                new (0, $972b3cdb4eaa2e74$export$737c747d043a1f7b)(),
                new (0, $12d7120b6dd6df4f$export$604bcc7f2bff6bb)()
            ]
        }));
        return;
    }
    (0, $77955577000c938d$export$3e49040daa9dba20).setGlobalPropagator(propagator);
}
class $63a533b9ee75e32f$export$a785009afeee3453 extends (0, $09b0f540efe38fab$export$1f2f0f67f5ecff3b) {
    /**
     * Constructs a new Tracer instance.
     * @param config Web Tracer config
     */ constructor(config = {}){
        super(config);
    }
    /**
     * Register this TracerProvider for use with the OpenTelemetry API.
     * Undefined values may be replaced with defaults, and
     * null values will be skipped.
     *
     * @param config Configuration object for SDK registration
     */ register(config = {}) {
        (0, $496851d2cf78caa4$export$357889f174732d38).setGlobalTracerProvider(this);
        $63a533b9ee75e32f$var$setupPropagator(config.propagator);
        $63a533b9ee75e32f$var$setupContextManager(config.contextManager);
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $3e8831089012b6e0$export$74be52df2d6fd28c;
(function(PerformanceTimingNames) {
    PerformanceTimingNames["CONNECT_END"] = "connectEnd";
    PerformanceTimingNames["CONNECT_START"] = "connectStart";
    PerformanceTimingNames["DECODED_BODY_SIZE"] = "decodedBodySize";
    PerformanceTimingNames["DOM_COMPLETE"] = "domComplete";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_END"] = "domContentLoadedEventEnd";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_START"] = "domContentLoadedEventStart";
    PerformanceTimingNames["DOM_INTERACTIVE"] = "domInteractive";
    PerformanceTimingNames["DOMAIN_LOOKUP_END"] = "domainLookupEnd";
    PerformanceTimingNames["DOMAIN_LOOKUP_START"] = "domainLookupStart";
    PerformanceTimingNames["ENCODED_BODY_SIZE"] = "encodedBodySize";
    PerformanceTimingNames["FETCH_START"] = "fetchStart";
    PerformanceTimingNames["LOAD_EVENT_END"] = "loadEventEnd";
    PerformanceTimingNames["LOAD_EVENT_START"] = "loadEventStart";
    PerformanceTimingNames["NAVIGATION_START"] = "navigationStart";
    PerformanceTimingNames["REDIRECT_END"] = "redirectEnd";
    PerformanceTimingNames["REDIRECT_START"] = "redirectStart";
    PerformanceTimingNames["REQUEST_START"] = "requestStart";
    PerformanceTimingNames["RESPONSE_END"] = "responseEnd";
    PerformanceTimingNames["RESPONSE_START"] = "responseStart";
    PerformanceTimingNames["SECURE_CONNECTION_START"] = "secureConnectionStart";
    PerformanceTimingNames["START_TIME"] = "startTime";
    PerformanceTimingNames["UNLOAD_EVENT_END"] = "unloadEventEnd";
    PerformanceTimingNames["UNLOAD_EVENT_START"] = "unloadEventStart";
})($3e8831089012b6e0$export$74be52df2d6fd28c || ($3e8831089012b6e0$export$74be52df2d6fd28c = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $3b8b64466dc61937$export$c2a944331f80ae92(url, urlToMatch) {
    if (typeof urlToMatch === 'string') return url === urlToMatch;
    else return !!url.match(urlToMatch);
}
function $3b8b64466dc61937$export$172b5a1c42a6f83d(url, ignoredUrls) {
    if (!ignoredUrls) return false;
    for (const ignoreUrl of ignoredUrls){
        if ($3b8b64466dc61937$export$c2a944331f80ae92(url, ignoreUrl)) return true;
    }
    return false;
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * This file contains a copy of unstable semantic convention definitions
 * used by this package.
 * @see https://github.com/open-telemetry/opentelemetry-js/tree/main/semantic-conventions#unstable-semconv
 */ /**
 * Deprecated, use `http.response.header.<key>` instead.
 *
 * @example 3495
 *
 * @experimental This attribute is experimental and is subject to breaking changes in minor releases of `@opentelemetry/semantic-conventions`.
 *
 * @deprecated Replaced by `http.response.header.<key>`.
 */ const $8434e5fc70ff7666$export$237bc893b534cd8c = 'http.response_content_length';
const $8434e5fc70ff7666$export$651dae55eea4b228 = 'http.response_content_length_uncompressed';


// Used to normalize relative URLs
let $0f094f3dcc7447ce$var$urlNormalizingAnchor;
function $0f094f3dcc7447ce$var$getUrlNormalizingAnchor() {
    if (!$0f094f3dcc7447ce$var$urlNormalizingAnchor) $0f094f3dcc7447ce$var$urlNormalizingAnchor = document.createElement('a');
    return $0f094f3dcc7447ce$var$urlNormalizingAnchor;
}
function $0f094f3dcc7447ce$export$94df19ecb868bc1a(obj, key) {
    return key in obj;
}
function $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, performanceName, entries, ignoreZeros = true) {
    if ($0f094f3dcc7447ce$export$94df19ecb868bc1a(entries, performanceName) && typeof entries[performanceName] === 'number' && !(ignoreZeros && entries[performanceName] === 0)) return span.addEvent(performanceName, entries[performanceName]);
    return undefined;
}
function $0f094f3dcc7447ce$export$e2385716cf129455(span, resource, ignoreNetworkEvents = false, ignoreZeros, skipOldSemconvContentLengthAttrs) {
    if (ignoreZeros === undefined) ignoreZeros = resource[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).START_TIME] !== 0;
    if (!ignoreNetworkEvents) {
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START, resource, ignoreZeros);
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).DOMAIN_LOOKUP_START, resource, ignoreZeros);
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).DOMAIN_LOOKUP_END, resource, ignoreZeros);
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).CONNECT_START, resource, ignoreZeros);
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).SECURE_CONNECTION_START, resource, ignoreZeros);
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).CONNECT_END, resource, ignoreZeros);
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).REQUEST_START, resource, ignoreZeros);
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_START, resource, ignoreZeros);
        $0f094f3dcc7447ce$export$7e5e8f17966d37d1(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_END, resource, ignoreZeros);
    }
    if (!skipOldSemconvContentLengthAttrs) {
        // This block adds content-length-related span attributes using the
        // *old* HTTP semconv (v1.7.0).
        const encodedLength = resource[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).ENCODED_BODY_SIZE];
        if (encodedLength !== undefined) span.setAttribute((0, $8434e5fc70ff7666$export$237bc893b534cd8c), encodedLength);
        const decodedLength = resource[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).DECODED_BODY_SIZE];
        // Spec: Not set if transport encoding not used (in which case encoded and decoded sizes match)
        if (decodedLength !== undefined && encodedLength !== decodedLength) span.setAttribute((0, $8434e5fc70ff7666$export$651dae55eea4b228), decodedLength);
    }
}
function $0f094f3dcc7447ce$export$5d17283e524de23c(filteredResources) {
    return filteredResources.slice().sort((a, b)=>{
        const valueA = a[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START];
        const valueB = b[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START];
        if (valueA > valueB) return 1;
        else if (valueA < valueB) return -1;
        return 0;
    });
}
/** Returns the origin if present (if in browser context). */ function $0f094f3dcc7447ce$var$getOrigin() {
    return typeof location !== 'undefined' ? location.origin : undefined;
}
function $0f094f3dcc7447ce$export$cdcba7438a7553e8(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources = new WeakSet(), initiatorType) {
    // de-relativize the URL before usage (does no harm to absolute URLs)
    const parsedSpanUrl = $0f094f3dcc7447ce$export$7a5253c0f62e0150(spanUrl);
    spanUrl = parsedSpanUrl.toString();
    const filteredResources = $0f094f3dcc7447ce$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType);
    if (filteredResources.length === 0) return {
        mainRequest: undefined
    };
    if (filteredResources.length === 1) return {
        mainRequest: filteredResources[0]
    };
    const sorted = $0f094f3dcc7447ce$export$5d17283e524de23c(filteredResources);
    if (parsedSpanUrl.origin !== $0f094f3dcc7447ce$var$getOrigin() && sorted.length > 1) {
        let corsPreFlightRequest = sorted[0];
        let mainRequest = $0f094f3dcc7447ce$var$findMainRequest(sorted, corsPreFlightRequest[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_END], endTimeHR);
        const responseEnd = corsPreFlightRequest[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_END];
        const fetchStart = mainRequest[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START];
        // no corsPreFlightRequest
        if (fetchStart < responseEnd) {
            mainRequest = corsPreFlightRequest;
            corsPreFlightRequest = undefined;
        }
        return {
            corsPreFlightRequest: corsPreFlightRequest,
            mainRequest: mainRequest
        };
    } else return {
        mainRequest: filteredResources[0]
    };
}
/**
 * Will find the main request skipping the cors pre flight requests
 * @param resources
 * @param corsPreFlightRequestEndTime
 * @param spanEndTimeHR
 */ function $0f094f3dcc7447ce$var$findMainRequest(resources, corsPreFlightRequestEndTime, spanEndTimeHR) {
    const spanEndTime = (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc)(spanEndTimeHR);
    const minTime = (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc)((0, $02ed3a94ae5b2eb2$export$5f4c8a8ba0e36226)(corsPreFlightRequestEndTime));
    let mainRequest = resources[1];
    let bestGap;
    const length = resources.length;
    for(let i = 1; i < length; i++){
        const resource = resources[i];
        const resourceStartTime = (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc)((0, $02ed3a94ae5b2eb2$export$5f4c8a8ba0e36226)(resource[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START]));
        const resourceEndTime = (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc)((0, $02ed3a94ae5b2eb2$export$5f4c8a8ba0e36226)(resource[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_END]));
        const currentGap = spanEndTime - resourceEndTime;
        if (resourceStartTime >= minTime && (!bestGap || currentGap < bestGap)) {
            bestGap = currentGap;
            mainRequest = resource;
        }
    }
    return mainRequest;
}
/**
 * Filter all resources that has started and finished according to span start time and end time.
 *     It will return the closest resource to a start time
 * @param spanUrl
 * @param startTimeHR
 * @param endTimeHR
 * @param resources
 * @param ignoredResources
 */ function $0f094f3dcc7447ce$var$filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    const startTime = (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc)(startTimeHR);
    const endTime = (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc)(endTimeHR);
    let filteredResources = resources.filter((resource)=>{
        const resourceStartTime = (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc)((0, $02ed3a94ae5b2eb2$export$5f4c8a8ba0e36226)(resource[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START]));
        const resourceEndTime = (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc)((0, $02ed3a94ae5b2eb2$export$5f4c8a8ba0e36226)(resource[(0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_END]));
        return resource.initiatorType.toLowerCase() === (initiatorType || 'xmlhttprequest') && resource.name === spanUrl && resourceStartTime >= startTime && resourceEndTime <= endTime;
    });
    if (filteredResources.length > 0) filteredResources = filteredResources.filter((resource)=>{
        return !ignoredResources.has(resource);
    });
    return filteredResources;
}
function $0f094f3dcc7447ce$export$7a5253c0f62e0150(url) {
    if (typeof URL === 'function') return new URL(url, typeof document !== 'undefined' ? document.baseURI : typeof location !== 'undefined' // Some JS runtimes (e.g. Deno) don't define this
     ? location.href : undefined);
    const element = $0f094f3dcc7447ce$var$getUrlNormalizingAnchor();
    element.href = url;
    return element;
}
function $0f094f3dcc7447ce$export$6535eb414fa2c8b6(url) {
    const urlLike = $0f094f3dcc7447ce$export$7a5253c0f62e0150(url);
    return urlLike.href;
}
function $0f094f3dcc7447ce$export$fabdebd274ccbd1c(target, optimised) {
    if (target.nodeType === Node.DOCUMENT_NODE) return '/';
    const targetValue = $0f094f3dcc7447ce$var$getNodeValue(target, optimised);
    if (optimised && targetValue.indexOf('@id') > 0) return targetValue;
    let xpath = '';
    if (target.parentNode) xpath += $0f094f3dcc7447ce$export$fabdebd274ccbd1c(target.parentNode, false);
    xpath += targetValue;
    return xpath;
}
/**
 * get node index within the siblings
 * @param target
 */ function $0f094f3dcc7447ce$var$getNodeIndex(target) {
    if (!target.parentNode) return 0;
    const allowedTypes = [
        target.nodeType
    ];
    if (target.nodeType === Node.CDATA_SECTION_NODE) allowedTypes.push(Node.TEXT_NODE);
    let elements = Array.from(target.parentNode.childNodes);
    elements = elements.filter((element)=>{
        const localName = element.localName;
        return allowedTypes.indexOf(element.nodeType) >= 0 && localName === target.localName;
    });
    if (elements.length >= 1) return elements.indexOf(target) + 1; // xpath starts from 1
    // if there are no other similar child xpath doesn't need index
    return 0;
}
/**
 * get node value for xpath
 * @param target
 * @param optimised
 */ function $0f094f3dcc7447ce$var$getNodeValue(target, optimised) {
    const nodeType = target.nodeType;
    const index = $0f094f3dcc7447ce$var$getNodeIndex(target);
    let nodeValue = '';
    if (nodeType === Node.ELEMENT_NODE) {
        const id = target.getAttribute('id');
        if (optimised && id) return `//*[@id="${id}"]`;
        nodeValue = target.localName;
    } else if (nodeType === Node.TEXT_NODE || nodeType === Node.CDATA_SECTION_NODE) nodeValue = 'text()';
    else if (nodeType === Node.COMMENT_NODE) nodeValue = 'comment()';
    else return '';
    // if index is 1 it can be omitted in xpath
    if (nodeValue && index > 1) return `/${nodeValue}[${index}]`;
    return `/${nodeValue}`;
}
function $0f094f3dcc7447ce$export$c6501d7e56a5b40a(spanUrl, propagateTraceHeaderCorsUrls) {
    let propagateTraceHeaderUrls = propagateTraceHeaderCorsUrls || [];
    if (typeof propagateTraceHeaderUrls === 'string' || propagateTraceHeaderUrls instanceof RegExp) propagateTraceHeaderUrls = [
        propagateTraceHeaderUrls
    ];
    const parsedSpanUrl = $0f094f3dcc7447ce$export$7a5253c0f62e0150(spanUrl);
    if (parsedSpanUrl.origin === $0f094f3dcc7447ce$var$getOrigin()) return true;
    else return propagateTraceHeaderUrls.some((propagateTraceHeaderUrl)=>(0, $3b8b64466dc61937$export$c2a944331f80ae92)(spanUrl, propagateTraceHeaderUrl));
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1a01db1422e59375$export$be5e405504011951 = Symbol.for('io.opentelemetry.js.api.logs');
const $1a01db1422e59375$export$fb1208122242c205 = globalThis;
function $1a01db1422e59375$export$bf9e00ce1090794f(requiredVersion, instance, fallback) {
    return (version)=>version === requiredVersion ? instance : fallback;
}
const $1a01db1422e59375$export$41e8763f7160bb4 = 1;


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $703d4468e177722d$export$d16ba98760c74dd5 {
    emit(_logRecord) {}
}
const $703d4468e177722d$export$f5681b99b7ff4eb3 = new $703d4468e177722d$export$d16ba98760c74dd5();


class $7d7f8c3c8e555ce0$export$8d7f6fb42e615208 {
    getLogger(_name, _version, _options) {
        return new (0, $703d4468e177722d$export$d16ba98760c74dd5)();
    }
}
const $7d7f8c3c8e555ce0$export$ade97358fd6ba8df = new $7d7f8c3c8e555ce0$export$8d7f6fb42e615208();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $ca38947d9bfc14c7$export$ed6b4cba4dd55d4b {
    constructor(provider, name, version, options){
        this._provider = provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    /**
     * Emit a log record. This method should only be used by log appenders.
     *
     * @param logRecord
     */ emit(logRecord) {
        this._getLogger().emit(logRecord);
    }
    /**
     * Try to get a logger from the proxy logger provider.
     * If the proxy logger provider has no delegate, return a noop logger.
     */ _getLogger() {
        if (this._delegate) return this._delegate;
        const logger = this._provider._getDelegateLogger(this.name, this.version, this.options);
        if (!logger) return 0, $703d4468e177722d$export$f5681b99b7ff4eb3;
        this._delegate = logger;
        return this._delegate;
    }
}


class $b490e513dbe6b4e6$export$f72276fc3bc2aaa4 {
    getLogger(name, version, options) {
        var _a;
        return (_a = this._getDelegateLogger(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $ca38947d9bfc14c7$export$ed6b4cba4dd55d4b)(this, name, version, options);
    }
    /**
     * Get the delegate logger provider.
     * Used by tests only.
     * @internal
     */ _getDelegate() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : (0, $7d7f8c3c8e555ce0$export$ade97358fd6ba8df);
    }
    /**
     * Set the delegate logger provider
     * @internal
     */ _setDelegate(delegate) {
        this._delegate = delegate;
    }
    /**
     * @internal
     */ _getDelegateLogger(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getLogger(name, version, options);
    }
}


class $dab714d323f16e75$export$f8e63508eb6a0fc1 {
    constructor(){
        this._proxyLoggerProvider = new (0, $b490e513dbe6b4e6$export$f72276fc3bc2aaa4)();
    }
    static getInstance() {
        if (!this._instance) this._instance = new $dab714d323f16e75$export$f8e63508eb6a0fc1();
        return this._instance;
    }
    setGlobalLoggerProvider(provider) {
        if ((0, $1a01db1422e59375$export$fb1208122242c205)[0, $1a01db1422e59375$export$be5e405504011951]) return this.getLoggerProvider();
        (0, $1a01db1422e59375$export$fb1208122242c205)[0, $1a01db1422e59375$export$be5e405504011951] = (0, $1a01db1422e59375$export$bf9e00ce1090794f)((0, $1a01db1422e59375$export$41e8763f7160bb4), provider, (0, $7d7f8c3c8e555ce0$export$ade97358fd6ba8df));
        this._proxyLoggerProvider._setDelegate(provider);
        return provider;
    }
    /**
     * Returns the global logger provider.
     *
     * @returns LoggerProvider
     */ getLoggerProvider() {
        var _a, _b;
        return (_b = (_a = (0, $1a01db1422e59375$export$fb1208122242c205)[0, $1a01db1422e59375$export$be5e405504011951]) === null || _a === void 0 ? void 0 : _a.call((0, $1a01db1422e59375$export$fb1208122242c205), (0, $1a01db1422e59375$export$41e8763f7160bb4))) !== null && _b !== void 0 ? _b : this._proxyLoggerProvider;
    }
    /**
     * Returns a logger from the global logger provider.
     *
     * @returns Logger
     */ getLogger(name, version, options) {
        return this.getLoggerProvider().getLogger(name, version, options);
    }
    /** Remove the global logger provider */ disable() {
        delete (0, $1a01db1422e59375$export$fb1208122242c205)[0, $1a01db1422e59375$export$be5e405504011951];
        this._proxyLoggerProvider = new (0, $b490e513dbe6b4e6$export$f72276fc3bc2aaa4)();
    }
}


const $6d3371a0a865dabe$export$fa0831f497706bad = (0, $dab714d323f16e75$export$f8e63508eb6a0fc1).getInstance();


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Default to complaining loudly when things don't go according to plan.
// eslint-disable-next-line no-console
let $3d9904bc9d2c84f8$var$logger = console.error.bind(console);
// Sets a property on an object, preserving its enumerability.
// This function assumes that the property is already writable.
function $3d9904bc9d2c84f8$var$defineProperty(obj, name, value) {
    const enumerable = !!obj[name] && Object.prototype.propertyIsEnumerable.call(obj, name);
    Object.defineProperty(obj, name, {
        configurable: true,
        enumerable: enumerable,
        writable: true,
        value: value
    });
}
const $3d9904bc9d2c84f8$export$4997ffc0176396a6 = (nodule, name, wrapper)=>{
    if (!nodule || !nodule[name]) {
        $3d9904bc9d2c84f8$var$logger('no original function ' + String(name) + ' to wrap');
        return;
    }
    if (!wrapper) {
        $3d9904bc9d2c84f8$var$logger('no wrapper function');
        $3d9904bc9d2c84f8$var$logger(new Error().stack);
        return;
    }
    const original = nodule[name];
    if (typeof original !== 'function' || typeof wrapper !== 'function') {
        $3d9904bc9d2c84f8$var$logger('original object and wrapper must be functions');
        return;
    }
    const wrapped = wrapper(original, name);
    $3d9904bc9d2c84f8$var$defineProperty(wrapped, '__original', original);
    $3d9904bc9d2c84f8$var$defineProperty(wrapped, '__unwrap', ()=>{
        if (nodule[name] === wrapped) $3d9904bc9d2c84f8$var$defineProperty(nodule, name, original);
    });
    $3d9904bc9d2c84f8$var$defineProperty(wrapped, '__wrapped', true);
    $3d9904bc9d2c84f8$var$defineProperty(nodule, name, wrapped);
    return wrapped;
};
const $3d9904bc9d2c84f8$export$358d869541567f31 = (nodules, names, wrapper)=>{
    if (!nodules) {
        $3d9904bc9d2c84f8$var$logger('must provide one or more modules to patch');
        $3d9904bc9d2c84f8$var$logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        $3d9904bc9d2c84f8$var$logger('must provide one or more functions to wrap on modules');
        return;
    }
    nodules.forEach((nodule)=>{
        names.forEach((name)=>{
            $3d9904bc9d2c84f8$export$4997ffc0176396a6(nodule, name, wrapper);
        });
    });
};
const $3d9904bc9d2c84f8$export$debb760848ca95a = (nodule, name)=>{
    if (!nodule || !nodule[name]) {
        $3d9904bc9d2c84f8$var$logger('no function to unwrap.');
        $3d9904bc9d2c84f8$var$logger(new Error().stack);
        return;
    }
    const wrapped = nodule[name];
    if (!wrapped.__unwrap) $3d9904bc9d2c84f8$var$logger('no original to unwrap to -- has ' + String(name) + ' already been unwrapped?');
    else {
        wrapped.__unwrap();
        return;
    }
};
const $3d9904bc9d2c84f8$export$43e13a935e49ecde = (nodules, names)=>{
    if (!nodules) {
        $3d9904bc9d2c84f8$var$logger('must provide one or more modules to patch');
        $3d9904bc9d2c84f8$var$logger(new Error().stack);
        return;
    } else if (!Array.isArray(nodules)) nodules = [
        nodules
    ];
    if (!(names && Array.isArray(names))) {
        $3d9904bc9d2c84f8$var$logger('must provide one or more functions to unwrap on modules');
        return;
    }
    nodules.forEach((nodule)=>{
        names.forEach((name)=>{
            $3d9904bc9d2c84f8$export$debb760848ca95a(nodule, name);
        });
    });
};
function $3d9904bc9d2c84f8$export$2e2bcd8739ae039(options) {
    if (options && options.logger) {
        if (typeof options.logger !== 'function') $3d9904bc9d2c84f8$var$logger("new logger isn't a function, not replacing");
        else $3d9904bc9d2c84f8$var$logger = options.logger;
    }
}
$3d9904bc9d2c84f8$export$2e2bcd8739ae039.wrap = $3d9904bc9d2c84f8$export$4997ffc0176396a6;
$3d9904bc9d2c84f8$export$2e2bcd8739ae039.massWrap = $3d9904bc9d2c84f8$export$358d869541567f31;
$3d9904bc9d2c84f8$export$2e2bcd8739ae039.unwrap = $3d9904bc9d2c84f8$export$debb760848ca95a;
$3d9904bc9d2c84f8$export$2e2bcd8739ae039.massUnwrap = $3d9904bc9d2c84f8$export$43e13a935e49ecde;


class $2f7376613c351001$export$74c31cfd4e541b89 {
    _config = {};
    _tracer;
    _meter;
    _logger;
    _diag;
    instrumentationName;
    instrumentationVersion;
    constructor(instrumentationName, instrumentationVersion, config){
        this.instrumentationName = instrumentationName;
        this.instrumentationVersion = instrumentationVersion;
        this.setConfig(config);
        this._diag = (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).createComponentLogger({
            namespace: instrumentationName
        });
        this._tracer = (0, $496851d2cf78caa4$export$357889f174732d38).getTracer(instrumentationName, instrumentationVersion);
        this._meter = (0, $b8db6f384fae8886$export$b0c5c2fac8144e54).getMeter(instrumentationName, instrumentationVersion);
        this._logger = (0, $6d3371a0a865dabe$export$fa0831f497706bad).getLogger(instrumentationName, instrumentationVersion);
        this._updateMetricInstruments();
    }
    /* Api to wrap instrumented method */ _wrap = $3d9904bc9d2c84f8$export$4997ffc0176396a6;
    /* Api to unwrap instrumented methods */ _unwrap = $3d9904bc9d2c84f8$export$debb760848ca95a;
    /* Api to mass wrap instrumented method */ _massWrap = $3d9904bc9d2c84f8$export$358d869541567f31;
    /* Api to mass unwrap instrumented methods */ _massUnwrap = $3d9904bc9d2c84f8$export$43e13a935e49ecde;
    /* Returns meter */ get meter() {
        return this._meter;
    }
    /**
     * Sets MeterProvider to this plugin
     * @param meterProvider
     */ setMeterProvider(meterProvider) {
        this._meter = meterProvider.getMeter(this.instrumentationName, this.instrumentationVersion);
        this._updateMetricInstruments();
    }
    /* Returns logger */ get logger() {
        return this._logger;
    }
    /**
     * Sets LoggerProvider to this plugin
     * @param loggerProvider
     */ setLoggerProvider(loggerProvider) {
        this._logger = loggerProvider.getLogger(this.instrumentationName, this.instrumentationVersion);
    }
    /**
     * @experimental
     *
     * Get module definitions defined by {@link init}.
     * This can be used for experimental compile-time instrumentation.
     *
     * @returns an array of {@link InstrumentationModuleDefinition}
     */ getModuleDefinitions() {
        const initResult = this.init() ?? [];
        if (!Array.isArray(initResult)) return [
            initResult
        ];
        return initResult;
    }
    /**
     * Sets the new metric instruments with the current Meter.
     */ _updateMetricInstruments() {
        return;
    }
    /* Returns InstrumentationConfig */ getConfig() {
        return this._config;
    }
    /**
     * Sets InstrumentationConfig to this plugin
     * @param config
     */ setConfig(config) {
        // copy config first level properties to ensure they are immutable.
        // nested properties are not copied, thus are mutable from the outside.
        this._config = {
            enabled: true,
            ...config
        };
    }
    /**
     * Sets TraceProvider to this plugin
     * @param tracerProvider
     */ setTracerProvider(tracerProvider) {
        this._tracer = tracerProvider.getTracer(this.instrumentationName, this.instrumentationVersion);
    }
    /* Returns tracer */ get tracer() {
        return this._tracer;
    }
    /**
     * Execute span customization hook, if configured, and log any errors.
     * Any semantics of the trigger and info are defined by the specific instrumentation.
     * @param hookHandler The optional hook handler which the user has configured via instrumentation config
     * @param triggerName The name of the trigger for executing the hook for logging purposes
     * @param span The span to which the hook should be applied
     * @param info The info object to be passed to the hook, with useful data the hook may use
     */ _runSpanCustomizationHook(hookHandler, triggerName, span, info) {
        if (!hookHandler) return;
        try {
            hookHandler(span, info);
        } catch (e) {
            this._diag.error(`Error running span customization hook due to exception in handler`, {
                triggerName: triggerName
            }, e);
        }
    }
}


class $671e8529d3469f36$export$436b1c2bf7e9756b extends (0, $2f7376613c351001$export$74c31cfd4e541b89) {
    constructor(instrumentationName, instrumentationVersion, config){
        super(instrumentationName, instrumentationVersion, config);
        if (this._config.enabled) this.enable();
    }
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * function to execute patched function and being able to catch errors
 * @param execute - function to be executed
 * @param onFinish - callback to run when execute finishes
 */ function $b17aef886b8eab2d$export$fdff7e10f8ca069e(execute, onFinish, preventThrowingError) {
    let error;
    let result;
    try {
        result = execute();
    } catch (e) {
        error = e;
    } finally{
        onFinish(error, result);
        if (error && !preventThrowingError) // eslint-disable-next-line no-unsafe-finally
        throw error;
        // eslint-disable-next-line no-unsafe-finally
        return result;
    }
}
async function $b17aef886b8eab2d$export$75852fe3c08f1502(execute, onFinish, preventThrowingError) {
    let error;
    let result;
    try {
        result = await execute();
    } catch (e) {
        error = e;
    } finally{
        await onFinish(error, result);
        if (error && !preventThrowingError) // eslint-disable-next-line no-unsafe-finally
        throw error;
        // eslint-disable-next-line no-unsafe-finally
        return result;
    }
}
function $b17aef886b8eab2d$export$ec0fd572751979bc(func) {
    return typeof func === 'function' && typeof func.__original === 'function' && typeof func.__unwrap === 'function' && func.__wrapped === true;
}

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $358486a6f01822c1$export$38c181bcafcf2fa0;
(function(SemconvStability) {
    /** Emit only stable semantic conventions. */ SemconvStability[SemconvStability["STABLE"] = 1] = "STABLE";
    /** Emit only old semantic conventions. */ SemconvStability[SemconvStability["OLD"] = 2] = "OLD";
    /** Emit both stable and old semantic conventions. */ SemconvStability[SemconvStability["DUPLICATE"] = 3] = "DUPLICATE";
})($358486a6f01822c1$export$38c181bcafcf2fa0 || ($358486a6f01822c1$export$38c181bcafcf2fa0 = {}));
function $358486a6f01822c1$export$f9fa4e140bcc07bb(namespace, str) {
    let semconvStability = $358486a6f01822c1$export$38c181bcafcf2fa0.OLD;
    // The same parsing of `str` as `getStringListFromEnv` from the core pkg.
    const entries = str?.split(',').map((v)=>v.trim()).filter((s)=>s !== '');
    for (const entry of entries ?? []){
        if (entry.toLowerCase() === namespace + '/dup') {
            // DUPLICATE takes highest precedence.
            semconvStability = $358486a6f01822c1$export$38c181bcafcf2fa0.DUPLICATE;
            break;
        } else if (entry.toLowerCase() === namespace) semconvStability = $358486a6f01822c1$export$38c181bcafcf2fa0.STABLE;
    }
    return semconvStability;
}



/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $6655623dd4db2a26$export$668754fb61dd076c;
(function(AttributeNames) {
    AttributeNames["DOCUMENT_LOAD"] = "documentLoad";
    AttributeNames["DOCUMENT_FETCH"] = "documentFetch";
    AttributeNames["RESOURCE_FETCH"] = "resourceFetch";
})($6655623dd4db2a26$export$668754fb61dd076c || ($6655623dd4db2a26$export$668754fb61dd076c = {}));


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
const $376aaa84b847c71a$export$4a03ffab3315ee34 = '0.56.0';
const $376aaa84b847c71a$export$b8b9d90f9e5bd72b = '@opentelemetry/instrumentation-document-load';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * This file contains a copy of unstable semantic convention definitions
 * used by this package.
 * @see https://github.com/open-telemetry/opentelemetry-js/tree/main/semantic-conventions#unstable-semconv
 */ /**
 * Deprecated, use `http.response.header.content-length` instead.
 *
 * @example 3495
 *
 * @experimental This attribute is experimental and is subject to breaking changes in minor releases of `@opentelemetry/semantic-conventions`.
 *
 * @deprecated Replaced by `http.response.header.content-length`.
 */ const $72bb9ce1d0ec1a56$export$237bc893b534cd8c = 'http.response_content_length';
const $72bb9ce1d0ec1a56$export$13e2e9fdaf5f7c2d = 'http.url';
const $72bb9ce1d0ec1a56$export$a4ba95edc60c8ef3 = 'http.user_agent';


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $9c030dacc11594a0$export$3fd36d65bf762270;
(function(EventNames) {
    EventNames["FIRST_PAINT"] = "firstPaint";
    EventNames["FIRST_CONTENTFUL_PAINT"] = "firstContentfulPaint";
})($9c030dacc11594a0$export$3fd36d65bf762270 || ($9c030dacc11594a0$export$3fd36d65bf762270 = {}));


const $d182fe99c2490bb3$export$1edb6265ef1ecc26 = ()=>{
    const entries = {};
    const performanceNavigationTiming = (0, $6521ec88e8266cdd$export$b22daef4119238cd).getEntriesByType?.('navigation')[0];
    if (performanceNavigationTiming) {
        const keys = Object.values((0, $3e8831089012b6e0$export$74be52df2d6fd28c));
        keys.forEach((key)=>{
            if ((0, $0f094f3dcc7447ce$export$94df19ecb868bc1a)(performanceNavigationTiming, key)) {
                const value = performanceNavigationTiming[key];
                if (typeof value === 'number') entries[key] = value;
            }
        });
    } else {
        // // fallback to previous version
        const perf = (0, $6521ec88e8266cdd$export$b22daef4119238cd);
        const performanceTiming = perf.timing;
        if (performanceTiming) {
            const keys = Object.values((0, $3e8831089012b6e0$export$74be52df2d6fd28c));
            keys.forEach((key)=>{
                if ((0, $0f094f3dcc7447ce$export$94df19ecb868bc1a)(performanceTiming, key)) {
                    const value = performanceTiming[key];
                    if (typeof value === 'number') entries[key] = value;
                }
            });
        }
    }
    return entries;
};
const $d182fe99c2490bb3$var$performancePaintNames = {
    'first-paint': (0, $9c030dacc11594a0$export$3fd36d65bf762270).FIRST_PAINT,
    'first-contentful-paint': (0, $9c030dacc11594a0$export$3fd36d65bf762270).FIRST_CONTENTFUL_PAINT
};
const $d182fe99c2490bb3$export$dbffc7a51b89acf6 = (span)=>{
    const performancePaintTiming = (0, $6521ec88e8266cdd$export$b22daef4119238cd).getEntriesByType?.('paint');
    if (performancePaintTiming) performancePaintTiming.forEach(({ name: name, startTime: startTime })=>{
        if ((0, $0f094f3dcc7447ce$export$94df19ecb868bc1a)($d182fe99c2490bb3$var$performancePaintNames, name)) span.addEvent($d182fe99c2490bb3$var$performancePaintNames[name], startTime);
    });
};


class $f8d3747903d55f9c$export$381e8ef2e310d2c3 extends (0, $671e8529d3469f36$export$436b1c2bf7e9756b) {
    component = 'document-load';
    version = '1';
    moduleName = this.component;
    _semconvStability;
    constructor(config = {}){
        super((0, $376aaa84b847c71a$export$b8b9d90f9e5bd72b), (0, $376aaa84b847c71a$export$4a03ffab3315ee34), config);
        this._semconvStability = (0, $358486a6f01822c1$export$f9fa4e140bcc07bb)('http', config?.semconvStabilityOptIn);
    }
    init() {}
    /**
     * callback to be executed when page is loaded
     */ _onDocumentLoaded() {
        // Timeout is needed as load event doesn't have yet the performance metrics for loadEnd.
        // Support for event "loadend" is very limited and cannot be used
        window.setTimeout(()=>{
            this._collectPerformance();
        });
    }
    /**
     * Adds spans for all resources
     * @param rootSpan
     */ _addResourcesSpans(rootSpan) {
        const resources = (0, $6521ec88e8266cdd$export$b22daef4119238cd).getEntriesByType?.('resource');
        if (resources) resources.forEach((resource)=>{
            this._initResourceSpan(resource, rootSpan);
        });
    }
    /**
     * Collects information about performance and creates appropriate spans
     */ _collectPerformance() {
        const metaElement = Array.from(document.getElementsByTagName('meta')).find((e)=>e.getAttribute('name') === (0, $972b3cdb4eaa2e74$export$830e05fa2746348));
        const entries = (0, $d182fe99c2490bb3$export$1edb6265ef1ecc26)();
        const traceparent = metaElement && metaElement.content || '';
        (0, $0c57d9262090934c$export$a078c61943f9dbbe).with((0, $77955577000c938d$export$3e49040daa9dba20).extract((0, $411320e1da10ff3d$export$78df28f9b2f9a7dc), {
            traceparent: traceparent
        }), ()=>{
            const rootSpan = this._startSpan((0, $6655623dd4db2a26$export$668754fb61dd076c).DOCUMENT_LOAD, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START, entries);
            if (!rootSpan) return;
            (0, $0c57d9262090934c$export$a078c61943f9dbbe).with((0, $496851d2cf78caa4$export$357889f174732d38).setSpan((0, $0c57d9262090934c$export$a078c61943f9dbbe).active(), rootSpan), ()=>{
                const fetchSpan = this._startSpan((0, $6655623dd4db2a26$export$668754fb61dd076c).DOCUMENT_FETCH, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START, entries);
                if (fetchSpan) {
                    if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD) fetchSpan.setAttribute((0, $72bb9ce1d0ec1a56$export$13e2e9fdaf5f7c2d), location.href);
                    if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).STABLE) fetchSpan.setAttribute((0, $3fcd7ea0f1087866$export$ef7da4fb774e8a84), location.href);
                    (0, $0c57d9262090934c$export$a078c61943f9dbbe).with((0, $496851d2cf78caa4$export$357889f174732d38).setSpan((0, $0c57d9262090934c$export$a078c61943f9dbbe).active(), fetchSpan), ()=>{
                        const skipOldSemconvContentLengthAttrs = !(this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD);
                        (0, $0f094f3dcc7447ce$export$e2385716cf129455)(fetchSpan, entries, this.getConfig().ignoreNetworkEvents, undefined, skipOldSemconvContentLengthAttrs);
                        this._addCustomAttributesOnSpan(fetchSpan, this.getConfig().applyCustomAttributesOnSpan?.documentFetch);
                        this._endSpan(fetchSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_END, entries);
                    });
                }
            });
            if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD) {
                rootSpan.setAttribute((0, $72bb9ce1d0ec1a56$export$13e2e9fdaf5f7c2d), location.href);
                rootSpan.setAttribute((0, $72bb9ce1d0ec1a56$export$a4ba95edc60c8ef3), navigator.userAgent);
            }
            if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).STABLE) {
                rootSpan.setAttribute((0, $3fcd7ea0f1087866$export$ef7da4fb774e8a84), location.href);
                rootSpan.setAttribute((0, $3fcd7ea0f1087866$export$11d4f8ef7be26b3d), navigator.userAgent);
            }
            this._addResourcesSpans(rootSpan);
            if (!this.getConfig().ignoreNetworkEvents) {
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START, entries);
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).UNLOAD_EVENT_START, entries);
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).UNLOAD_EVENT_END, entries);
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).DOM_INTERACTIVE, entries);
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).DOM_CONTENT_LOADED_EVENT_START, entries);
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).DOM_CONTENT_LOADED_EVENT_END, entries);
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).DOM_COMPLETE, entries);
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).LOAD_EVENT_START, entries);
                (0, $0f094f3dcc7447ce$export$7e5e8f17966d37d1)(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).LOAD_EVENT_END, entries);
            }
            if (!this.getConfig().ignorePerformancePaintEvents) (0, $d182fe99c2490bb3$export$dbffc7a51b89acf6)(rootSpan);
            this._addCustomAttributesOnSpan(rootSpan, this.getConfig().applyCustomAttributesOnSpan?.documentLoad);
            this._endSpan(rootSpan, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).LOAD_EVENT_END, entries);
        });
    }
    /**
     * Helper function for ending span
     * @param span
     * @param performanceName name of performance entry for time end
     * @param entries
     */ _endSpan(span, performanceName, entries) {
        // span can be undefined when entries are missing the certain performance - the span will not be created
        if (span) {
            if ((0, $0f094f3dcc7447ce$export$94df19ecb868bc1a)(entries, performanceName)) span.end(entries[performanceName]);
            else // just end span
            span.end();
        }
    }
    /**
     * Creates and ends a span with network information about resource added as timed events
     * @param resource
     * @param parentSpan
     */ _initResourceSpan(resource, parentSpan) {
        const span = this._startSpan((0, $6655623dd4db2a26$export$668754fb61dd076c).RESOURCE_FETCH, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).FETCH_START, resource, parentSpan);
        if (span) {
            if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD) span.setAttribute((0, $72bb9ce1d0ec1a56$export$13e2e9fdaf5f7c2d), resource.name);
            if (this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).STABLE) span.setAttribute((0, $3fcd7ea0f1087866$export$ef7da4fb774e8a84), resource.name);
            const skipOldSemconvContentLengthAttrs = !(this._semconvStability & (0, $358486a6f01822c1$export$38c181bcafcf2fa0).OLD);
            (0, $0f094f3dcc7447ce$export$e2385716cf129455)(span, resource, this.getConfig().ignoreNetworkEvents, undefined, skipOldSemconvContentLengthAttrs);
            this._addCustomAttributesOnResourceSpan(span, resource, this.getConfig().applyCustomAttributesOnSpan?.resourceFetch);
            this._endSpan(span, (0, $3e8831089012b6e0$export$74be52df2d6fd28c).RESPONSE_END, resource);
        }
    }
    /**
     * Helper function for starting a span
     * @param spanName name of span
     * @param performanceName name of performance entry for time start
     * @param entries
     * @param parentSpan
     */ _startSpan(spanName, performanceName, entries, parentSpan) {
        if ((0, $0f094f3dcc7447ce$export$94df19ecb868bc1a)(entries, performanceName) && typeof entries[performanceName] === 'number') {
            const span = this.tracer.startSpan(spanName, {
                startTime: entries[performanceName]
            }, parentSpan ? (0, $496851d2cf78caa4$export$357889f174732d38).setSpan((0, $0c57d9262090934c$export$a078c61943f9dbbe).active(), parentSpan) : undefined);
            return span;
        }
        return undefined;
    }
    /**
     * executes callback {_onDocumentLoaded} when the page is loaded
     */ _waitForPageLoad() {
        if (window.document.readyState === 'complete') this._onDocumentLoaded();
        else {
            this._onDocumentLoaded = this._onDocumentLoaded.bind(this);
            window.addEventListener('load', this._onDocumentLoaded);
        }
    }
    /**
     * adds custom attributes to root span if configured
     */ _addCustomAttributesOnSpan(span, applyCustomAttributesOnSpan) {
        if (applyCustomAttributesOnSpan) (0, $b17aef886b8eab2d$export$fdff7e10f8ca069e)(()=>applyCustomAttributesOnSpan(span), (error)=>{
            if (!error) return;
            this._diag.error('addCustomAttributesOnSpan', error);
        }, true);
    }
    /**
     * adds custom attributes to span if configured
     */ _addCustomAttributesOnResourceSpan(span, resource, applyCustomAttributesOnSpan) {
        if (applyCustomAttributesOnSpan) (0, $b17aef886b8eab2d$export$fdff7e10f8ca069e)(()=>applyCustomAttributesOnSpan(span, resource), (error)=>{
            if (!error) return;
            this._diag.error('addCustomAttributesOnResourceSpan', error);
        }, true);
    }
    /**
     * implements enable function
     */ enable() {
        // remove previously attached load to avoid adding the same event twice
        // in case of multiple enable calling.
        window.removeEventListener('load', this._onDocumentLoaded);
        this._waitForPageLoad();
    }
    /**
     * implements disable function
     */ disable() {
        window.removeEventListener('load', this._onDocumentLoaded);
    }
}





/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /// <reference types="zone.js" />

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * check if an object has `addEventListener` and `removeEventListener` functions.
 * Generally only called with a `TargetWithEvents` but may be called with an `unknown` value.
 * @param obj - The object to check.
 */ function $b924243e44cd2d5c$export$8b321bf7829ce743(obj) {
    return typeof obj === 'object' && obj !== null && 'addEventListener' in obj && typeof obj.addEventListener === 'function' && 'removeEventListener' in obj && typeof obj.removeEventListener === 'function';
}


/* Key name to be used to save a context reference in Zone */ const $89c185efeb78c80b$var$ZONE_CONTEXT_KEY = 'OT_ZONE_CONTEXT';
class $89c185efeb78c80b$export$148434e42b84e81c {
    /**
     * whether the context manager is enabled or not
     */ _enabled = false;
    /**
     * Helps to create a unique name for the zones - part of zone name
     */ _zoneCounter = 0;
    /**
     * Returns the active context from certain zone name
     * @param activeZone
     */ _activeContextFromZone(activeZone) {
        return activeZone && activeZone.get($89c185efeb78c80b$var$ZONE_CONTEXT_KEY) || (0, $411320e1da10ff3d$export$78df28f9b2f9a7dc);
    }
    /**
     * @param context A context (span) to be executed within target function
     * @param target Function to be executed within the context
     */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    _bindFunction(context, target) {
        const manager = this;
        const contextWrapper = function(...args) {
            return manager.with(context, ()=>target.apply(this, args));
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length
        });
        return contextWrapper;
    }
    /**
     * @param context A context (span) to be bind to target
     * @param obj target object on which the listeners will be patched
     */ _bindListener(context, obj) {
        const target = obj;
        if (target.__ot_listeners !== undefined) return obj;
        target.__ot_listeners = {};
        if (typeof target.addEventListener === 'function') target.addEventListener = this._patchAddEventListener(target, target.addEventListener, context);
        if (typeof target.removeEventListener === 'function') target.removeEventListener = this._patchRemoveEventListener(target, target.removeEventListener);
        return obj;
    }
    /**
     * Creates a new unique zone name
     */ _createZoneName() {
        this._zoneCounter++;
        const random = Math.random();
        return `${this._zoneCounter}-${random}`;
    }
    /**
     * Creates a new zone
     * @param zoneName zone name
     * @param context A context (span) to be bind with Zone
     */ _createZone(zoneName, context) {
        return Zone.current.fork({
            name: zoneName,
            properties: {
                [$89c185efeb78c80b$var$ZONE_CONTEXT_KEY]: context
            }
        });
    }
    /**
     * Returns the active zone
     */ _getActiveZone() {
        return Zone.current;
    }
    /**
     * Patches addEventListener method
     * @param target any target that has "addEventListener" method
     * @param original reference to the patched method
     * @param [context] context to be bind to the listener
     */ _patchAddEventListener(target, original, context) {
        const contextManager = this;
        return function(event, listener, opts) {
            if (target.__ot_listeners === undefined) target.__ot_listeners = {};
            let listeners = target.__ot_listeners[event];
            if (listeners === undefined) {
                listeners = new WeakMap();
                target.__ot_listeners[event] = listeners;
            }
            const patchedListener = contextManager.bind(context, listener);
            // store a weak reference of the user listener to ours
            listeners.set(listener, patchedListener);
            return original.call(this, event, patchedListener, opts);
        };
    }
    /**
     * Patches removeEventListener method
     * @param target any target that has "removeEventListener" method
     * @param original reference to the patched method
     */ _patchRemoveEventListener(target, original) {
        return function(event, listener) {
            if (target.__ot_listeners === undefined || target.__ot_listeners[event] === undefined) return original.call(this, event, listener);
            const events = target.__ot_listeners[event];
            const patchedListener = events.get(listener);
            events.delete(listener);
            return original.call(this, event, patchedListener || listener);
        };
    }
    /**
     * Returns the active context
     */ active() {
        if (!this._enabled) return 0, $411320e1da10ff3d$export$78df28f9b2f9a7dc;
        const activeZone = this._getActiveZone();
        const active = this._activeContextFromZone(activeZone);
        if (active) return active;
        return 0, $411320e1da10ff3d$export$78df28f9b2f9a7dc;
    }
    /**
     * Binds a the certain context or the active one to the target function and then returns the target
     * @param context A context (span) to be bind to target
     * @param target a function or event emitter. When target or one of its callbacks is called,
     *  the provided context will be used as the active context for the duration of the call.
     */ bind(context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) context = this.active();
        if (typeof target === 'function') return this._bindFunction(context, target);
        else if ((0, $b924243e44cd2d5c$export$8b321bf7829ce743)(target)) this._bindListener(context, target);
        return target;
    }
    /**
     * Disable the context manager (clears all the contexts)
     */ disable() {
        this._enabled = false;
        return this;
    }
    /**
     * Enables the context manager and creates a default(root) context
     */ enable() {
        this._enabled = true;
        return this;
    }
    /**
     * Calls the callback function [fn] with the provided [context].
     *     If [context] is undefined then it will use the active context.
     *     The context will be set as active
     * @param context A context (span) to be called with provided callback
     * @param fn Callback function
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ with(context, fn, thisArg, ...args) {
        const zoneName = this._createZoneName();
        const newZone = this._createZone(zoneName, context);
        return newZone.run(fn, thisArg, args);
    }
}


'use strict';
/**
 * @license Angular
 * (c) 2010-2025 Google LLC. https://angular.dev/
 * License: MIT
 */ var $d9497ea901ae627a$var$__defProp = Object.defineProperty;
var $d9497ea901ae627a$var$__defProps = Object.defineProperties;
var $d9497ea901ae627a$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d9497ea901ae627a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d9497ea901ae627a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d9497ea901ae627a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d9497ea901ae627a$var$__defNormalProp = (obj, key, value)=>key in obj ? $d9497ea901ae627a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d9497ea901ae627a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d9497ea901ae627a$var$__hasOwnProp.call(b, prop)) $d9497ea901ae627a$var$__defNormalProp(a, prop, b[prop]);
    if ($d9497ea901ae627a$var$__getOwnPropSymbols) {
        for (var prop of $d9497ea901ae627a$var$__getOwnPropSymbols(b))if ($d9497ea901ae627a$var$__propIsEnum.call(b, prop)) $d9497ea901ae627a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d9497ea901ae627a$var$__spreadProps = (a, b)=>$d9497ea901ae627a$var$__defProps(a, $d9497ea901ae627a$var$__getOwnPropDescs(b));
var $d9497ea901ae627a$var$__publicField = (obj, key, value)=>{
    $d9497ea901ae627a$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// packages/zone.js/lib/zone-impl.js
var $d9497ea901ae627a$var$global = globalThis;
function $d9497ea901ae627a$var$__symbol__(name) {
    const symbolPrefix = $d9497ea901ae627a$var$global["__Zone_symbol_prefix"] || "__zone_symbol__";
    return symbolPrefix + name;
}
function $d9497ea901ae627a$var$initZone() {
    const performance = $d9497ea901ae627a$var$global["performance"];
    function mark(name) {
        performance && performance["mark"] && performance["mark"](name);
    }
    function performanceMeasure(name, label) {
        performance && performance["measure"] && performance["measure"](name, label);
    }
    mark("Zone");
    const _ZoneImpl = class _ZoneImpl {
        constructor(parent, zoneSpec){
            $d9497ea901ae627a$var$__publicField(this, "_parent");
            $d9497ea901ae627a$var$__publicField(this, "_name");
            $d9497ea901ae627a$var$__publicField(this, "_properties");
            $d9497ea901ae627a$var$__publicField(this, "_zoneDelegate");
            this._parent = parent;
            this._name = zoneSpec ? zoneSpec.name || "unnamed" : "<root>";
            this._properties = zoneSpec && zoneSpec.properties || {};
            this._zoneDelegate = new _ZoneDelegate(this, this._parent && this._parent._zoneDelegate, zoneSpec);
        }
        static assertZonePatched() {
            if ($d9497ea901ae627a$var$global["Promise"] !== patches["ZoneAwarePromise"]) throw new Error("Zone.js has detected that ZoneAwarePromise `(window|global).Promise` has been overwritten.\nMost likely cause is that a Promise polyfill has been loaded after Zone.js (Polyfilling Promise api is not necessary when zone.js is loaded. If you must load one, do so before loading zone.js.)");
        }
        static get root() {
            let zone = _ZoneImpl.current;
            while(zone.parent)zone = zone.parent;
            return zone;
        }
        static get current() {
            return _currentZoneFrame.zone;
        }
        static get currentTask() {
            return _currentTask;
        }
        static __load_patch(name, fn, ignoreDuplicate = false) {
            if (patches.hasOwnProperty(name)) {
                const checkDuplicate = $d9497ea901ae627a$var$global[$d9497ea901ae627a$var$__symbol__("forceDuplicateZoneCheck")] === true;
                if (!ignoreDuplicate && checkDuplicate) throw Error("Already loaded patch: " + name);
            } else if (!$d9497ea901ae627a$var$global["__Zone_disable_" + name]) {
                const perfName = "Zone:" + name;
                mark(perfName);
                patches[name] = fn($d9497ea901ae627a$var$global, _ZoneImpl, _api);
                performanceMeasure(perfName, perfName);
            }
        }
        get parent() {
            return this._parent;
        }
        get name() {
            return this._name;
        }
        get(key) {
            const zone = this.getZoneWith(key);
            if (zone) return zone._properties[key];
        }
        getZoneWith(key) {
            let current = this;
            while(current){
                if (current._properties.hasOwnProperty(key)) return current;
                current = current._parent;
            }
            return null;
        }
        fork(zoneSpec) {
            if (!zoneSpec) throw new Error("ZoneSpec required!");
            return this._zoneDelegate.fork(this, zoneSpec);
        }
        wrap(callback, source) {
            if (typeof callback !== "function") throw new Error("Expecting function got: " + callback);
            const _callback = this._zoneDelegate.intercept(this, callback, source);
            const zone = this;
            return function() {
                return zone.runGuarded(_callback, this, arguments, source);
            };
        }
        run(callback, applyThis, applyArgs, source) {
            _currentZoneFrame = {
                parent: _currentZoneFrame,
                zone: this
            };
            try {
                return this._zoneDelegate.invoke(this, callback, applyThis, applyArgs, source);
            } finally{
                _currentZoneFrame = _currentZoneFrame.parent;
            }
        }
        runGuarded(callback, applyThis = null, applyArgs, source) {
            _currentZoneFrame = {
                parent: _currentZoneFrame,
                zone: this
            };
            try {
                try {
                    return this._zoneDelegate.invoke(this, callback, applyThis, applyArgs, source);
                } catch (error) {
                    if (this._zoneDelegate.handleError(this, error)) throw error;
                }
            } finally{
                _currentZoneFrame = _currentZoneFrame.parent;
            }
        }
        runTask(task, applyThis, applyArgs) {
            if (task.zone != this) throw new Error("A task can only be run in the zone of creation! (Creation: " + (task.zone || NO_ZONE).name + "; Execution: " + this.name + ")");
            const zoneTask = task;
            const { type: type, data: { isPeriodic: isPeriodic = false, isRefreshable: isRefreshable = false } = {} } = task;
            if (task.state === notScheduled && (type === eventTask || type === macroTask)) return;
            const reEntryGuard = task.state != running;
            reEntryGuard && zoneTask._transitionTo(running, scheduled);
            const previousTask = _currentTask;
            _currentTask = zoneTask;
            _currentZoneFrame = {
                parent: _currentZoneFrame,
                zone: this
            };
            try {
                if (type == macroTask && task.data && !isPeriodic && !isRefreshable) task.cancelFn = void 0;
                try {
                    return this._zoneDelegate.invokeTask(this, zoneTask, applyThis, applyArgs);
                } catch (error) {
                    if (this._zoneDelegate.handleError(this, error)) throw error;
                }
            } finally{
                const state = task.state;
                if (state !== notScheduled && state !== unknown) {
                    if (type == eventTask || isPeriodic || isRefreshable && state === scheduling) reEntryGuard && zoneTask._transitionTo(scheduled, running, scheduling);
                    else {
                        const zoneDelegates = zoneTask._zoneDelegates;
                        this._updateTaskCount(zoneTask, -1);
                        reEntryGuard && zoneTask._transitionTo(notScheduled, running, notScheduled);
                        if (isRefreshable) zoneTask._zoneDelegates = zoneDelegates;
                    }
                }
                _currentZoneFrame = _currentZoneFrame.parent;
                _currentTask = previousTask;
            }
        }
        scheduleTask(task) {
            if (task.zone && task.zone !== this) {
                let newZone = this;
                while(newZone){
                    if (newZone === task.zone) throw Error(`can not reschedule task to ${this.name} which is descendants of the original zone ${task.zone.name}`);
                    newZone = newZone.parent;
                }
            }
            task._transitionTo(scheduling, notScheduled);
            const zoneDelegates = [];
            task._zoneDelegates = zoneDelegates;
            task._zone = this;
            try {
                task = this._zoneDelegate.scheduleTask(this, task);
            } catch (err) {
                task._transitionTo(unknown, scheduling, notScheduled);
                this._zoneDelegate.handleError(this, err);
                throw err;
            }
            if (task._zoneDelegates === zoneDelegates) this._updateTaskCount(task, 1);
            if (task.state == scheduling) task._transitionTo(scheduled, scheduling);
            return task;
        }
        scheduleMicroTask(source, callback, data, customSchedule) {
            return this.scheduleTask(new ZoneTask(microTask, source, callback, data, customSchedule, void 0));
        }
        scheduleMacroTask(source, callback, data, customSchedule, customCancel) {
            return this.scheduleTask(new ZoneTask(macroTask, source, callback, data, customSchedule, customCancel));
        }
        scheduleEventTask(source, callback, data, customSchedule, customCancel) {
            return this.scheduleTask(new ZoneTask(eventTask, source, callback, data, customSchedule, customCancel));
        }
        cancelTask(task) {
            if (task.zone != this) throw new Error("A task can only be cancelled in the zone of creation! (Creation: " + (task.zone || NO_ZONE).name + "; Execution: " + this.name + ")");
            if (task.state !== scheduled && task.state !== running) return;
            task._transitionTo(canceling, scheduled, running);
            try {
                this._zoneDelegate.cancelTask(this, task);
            } catch (err) {
                task._transitionTo(unknown, canceling);
                this._zoneDelegate.handleError(this, err);
                throw err;
            }
            this._updateTaskCount(task, -1);
            task._transitionTo(notScheduled, canceling);
            task.runCount = -1;
            return task;
        }
        _updateTaskCount(task, count) {
            const zoneDelegates = task._zoneDelegates;
            if (count == -1) task._zoneDelegates = null;
            for(let i = 0; i < zoneDelegates.length; i++)zoneDelegates[i]._updateTaskCount(task.type, count);
        }
    };
    $d9497ea901ae627a$var$__publicField(_ZoneImpl, "__symbol__", $d9497ea901ae627a$var$__symbol__);
    let ZoneImpl = _ZoneImpl;
    const DELEGATE_ZS = {
        name: "",
        onHasTask: (delegate, _, target, hasTaskState)=>delegate.hasTask(target, hasTaskState),
        onScheduleTask: (delegate, _, target, task)=>delegate.scheduleTask(target, task),
        onInvokeTask: (delegate, _, target, task, applyThis, applyArgs)=>delegate.invokeTask(target, task, applyThis, applyArgs),
        onCancelTask: (delegate, _, target, task)=>delegate.cancelTask(target, task)
    };
    class _ZoneDelegate {
        constructor(zone, parentDelegate, zoneSpec){
            $d9497ea901ae627a$var$__publicField(this, "_zone");
            $d9497ea901ae627a$var$__publicField(this, "_taskCounts", {
                "microTask": 0,
                "macroTask": 0,
                "eventTask": 0
            });
            $d9497ea901ae627a$var$__publicField(this, "_parentDelegate");
            $d9497ea901ae627a$var$__publicField(this, "_forkDlgt");
            $d9497ea901ae627a$var$__publicField(this, "_forkZS");
            $d9497ea901ae627a$var$__publicField(this, "_forkCurrZone");
            $d9497ea901ae627a$var$__publicField(this, "_interceptDlgt");
            $d9497ea901ae627a$var$__publicField(this, "_interceptZS");
            $d9497ea901ae627a$var$__publicField(this, "_interceptCurrZone");
            $d9497ea901ae627a$var$__publicField(this, "_invokeDlgt");
            $d9497ea901ae627a$var$__publicField(this, "_invokeZS");
            $d9497ea901ae627a$var$__publicField(this, "_invokeCurrZone");
            $d9497ea901ae627a$var$__publicField(this, "_handleErrorDlgt");
            $d9497ea901ae627a$var$__publicField(this, "_handleErrorZS");
            $d9497ea901ae627a$var$__publicField(this, "_handleErrorCurrZone");
            $d9497ea901ae627a$var$__publicField(this, "_scheduleTaskDlgt");
            $d9497ea901ae627a$var$__publicField(this, "_scheduleTaskZS");
            $d9497ea901ae627a$var$__publicField(this, "_scheduleTaskCurrZone");
            $d9497ea901ae627a$var$__publicField(this, "_invokeTaskDlgt");
            $d9497ea901ae627a$var$__publicField(this, "_invokeTaskZS");
            $d9497ea901ae627a$var$__publicField(this, "_invokeTaskCurrZone");
            $d9497ea901ae627a$var$__publicField(this, "_cancelTaskDlgt");
            $d9497ea901ae627a$var$__publicField(this, "_cancelTaskZS");
            $d9497ea901ae627a$var$__publicField(this, "_cancelTaskCurrZone");
            $d9497ea901ae627a$var$__publicField(this, "_hasTaskDlgt");
            $d9497ea901ae627a$var$__publicField(this, "_hasTaskDlgtOwner");
            $d9497ea901ae627a$var$__publicField(this, "_hasTaskZS");
            $d9497ea901ae627a$var$__publicField(this, "_hasTaskCurrZone");
            this._zone = zone;
            this._parentDelegate = parentDelegate;
            this._forkZS = zoneSpec && (zoneSpec && zoneSpec.onFork ? zoneSpec : parentDelegate._forkZS);
            this._forkDlgt = zoneSpec && (zoneSpec.onFork ? parentDelegate : parentDelegate._forkDlgt);
            this._forkCurrZone = zoneSpec && (zoneSpec.onFork ? this._zone : parentDelegate._forkCurrZone);
            this._interceptZS = zoneSpec && (zoneSpec.onIntercept ? zoneSpec : parentDelegate._interceptZS);
            this._interceptDlgt = zoneSpec && (zoneSpec.onIntercept ? parentDelegate : parentDelegate._interceptDlgt);
            this._interceptCurrZone = zoneSpec && (zoneSpec.onIntercept ? this._zone : parentDelegate._interceptCurrZone);
            this._invokeZS = zoneSpec && (zoneSpec.onInvoke ? zoneSpec : parentDelegate._invokeZS);
            this._invokeDlgt = zoneSpec && (zoneSpec.onInvoke ? parentDelegate : parentDelegate._invokeDlgt);
            this._invokeCurrZone = zoneSpec && (zoneSpec.onInvoke ? this._zone : parentDelegate._invokeCurrZone);
            this._handleErrorZS = zoneSpec && (zoneSpec.onHandleError ? zoneSpec : parentDelegate._handleErrorZS);
            this._handleErrorDlgt = zoneSpec && (zoneSpec.onHandleError ? parentDelegate : parentDelegate._handleErrorDlgt);
            this._handleErrorCurrZone = zoneSpec && (zoneSpec.onHandleError ? this._zone : parentDelegate._handleErrorCurrZone);
            this._scheduleTaskZS = zoneSpec && (zoneSpec.onScheduleTask ? zoneSpec : parentDelegate._scheduleTaskZS);
            this._scheduleTaskDlgt = zoneSpec && (zoneSpec.onScheduleTask ? parentDelegate : parentDelegate._scheduleTaskDlgt);
            this._scheduleTaskCurrZone = zoneSpec && (zoneSpec.onScheduleTask ? this._zone : parentDelegate._scheduleTaskCurrZone);
            this._invokeTaskZS = zoneSpec && (zoneSpec.onInvokeTask ? zoneSpec : parentDelegate._invokeTaskZS);
            this._invokeTaskDlgt = zoneSpec && (zoneSpec.onInvokeTask ? parentDelegate : parentDelegate._invokeTaskDlgt);
            this._invokeTaskCurrZone = zoneSpec && (zoneSpec.onInvokeTask ? this._zone : parentDelegate._invokeTaskCurrZone);
            this._cancelTaskZS = zoneSpec && (zoneSpec.onCancelTask ? zoneSpec : parentDelegate._cancelTaskZS);
            this._cancelTaskDlgt = zoneSpec && (zoneSpec.onCancelTask ? parentDelegate : parentDelegate._cancelTaskDlgt);
            this._cancelTaskCurrZone = zoneSpec && (zoneSpec.onCancelTask ? this._zone : parentDelegate._cancelTaskCurrZone);
            this._hasTaskZS = null;
            this._hasTaskDlgt = null;
            this._hasTaskDlgtOwner = null;
            this._hasTaskCurrZone = null;
            const zoneSpecHasTask = zoneSpec && zoneSpec.onHasTask;
            const parentHasTask = parentDelegate && parentDelegate._hasTaskZS;
            if (zoneSpecHasTask || parentHasTask) {
                this._hasTaskZS = zoneSpecHasTask ? zoneSpec : DELEGATE_ZS;
                this._hasTaskDlgt = parentDelegate;
                this._hasTaskDlgtOwner = this;
                this._hasTaskCurrZone = this._zone;
                if (!zoneSpec.onScheduleTask) {
                    this._scheduleTaskZS = DELEGATE_ZS;
                    this._scheduleTaskDlgt = parentDelegate;
                    this._scheduleTaskCurrZone = this._zone;
                }
                if (!zoneSpec.onInvokeTask) {
                    this._invokeTaskZS = DELEGATE_ZS;
                    this._invokeTaskDlgt = parentDelegate;
                    this._invokeTaskCurrZone = this._zone;
                }
                if (!zoneSpec.onCancelTask) {
                    this._cancelTaskZS = DELEGATE_ZS;
                    this._cancelTaskDlgt = parentDelegate;
                    this._cancelTaskCurrZone = this._zone;
                }
            }
        }
        get zone() {
            return this._zone;
        }
        fork(targetZone, zoneSpec) {
            return this._forkZS ? this._forkZS.onFork(this._forkDlgt, this.zone, targetZone, zoneSpec) : new ZoneImpl(targetZone, zoneSpec);
        }
        intercept(targetZone, callback, source) {
            return this._interceptZS ? this._interceptZS.onIntercept(this._interceptDlgt, this._interceptCurrZone, targetZone, callback, source) : callback;
        }
        invoke(targetZone, callback, applyThis, applyArgs, source) {
            return this._invokeZS ? this._invokeZS.onInvoke(this._invokeDlgt, this._invokeCurrZone, targetZone, callback, applyThis, applyArgs, source) : callback.apply(applyThis, applyArgs);
        }
        handleError(targetZone, error) {
            return this._handleErrorZS ? this._handleErrorZS.onHandleError(this._handleErrorDlgt, this._handleErrorCurrZone, targetZone, error) : true;
        }
        scheduleTask(targetZone, task) {
            let returnTask = task;
            if (this._scheduleTaskZS) {
                if (this._hasTaskZS) returnTask._zoneDelegates.push(this._hasTaskDlgtOwner);
                returnTask = this._scheduleTaskZS.onScheduleTask(this._scheduleTaskDlgt, this._scheduleTaskCurrZone, targetZone, task);
                if (!returnTask) returnTask = task;
            } else {
                if (task.scheduleFn) task.scheduleFn(task);
                else if (task.type == microTask) scheduleMicroTask(task);
                else throw new Error("Task is missing scheduleFn.");
            }
            return returnTask;
        }
        invokeTask(targetZone, task, applyThis, applyArgs) {
            return this._invokeTaskZS ? this._invokeTaskZS.onInvokeTask(this._invokeTaskDlgt, this._invokeTaskCurrZone, targetZone, task, applyThis, applyArgs) : task.callback.apply(applyThis, applyArgs);
        }
        cancelTask(targetZone, task) {
            let value;
            if (this._cancelTaskZS) value = this._cancelTaskZS.onCancelTask(this._cancelTaskDlgt, this._cancelTaskCurrZone, targetZone, task);
            else {
                if (!task.cancelFn) throw Error("Task is not cancelable");
                value = task.cancelFn(task);
            }
            return value;
        }
        hasTask(targetZone, isEmpty) {
            try {
                this._hasTaskZS && this._hasTaskZS.onHasTask(this._hasTaskDlgt, this._hasTaskCurrZone, targetZone, isEmpty);
            } catch (err) {
                this.handleError(targetZone, err);
            }
        }
        _updateTaskCount(type, count) {
            const counts = this._taskCounts;
            const prev = counts[type];
            const next = counts[type] = prev + count;
            if (next < 0) throw new Error("More tasks executed then were scheduled.");
            if (prev == 0 || next == 0) {
                const isEmpty = {
                    microTask: counts["microTask"] > 0,
                    macroTask: counts["macroTask"] > 0,
                    eventTask: counts["eventTask"] > 0,
                    change: type
                };
                this.hasTask(this._zone, isEmpty);
            }
        }
    }
    class ZoneTask {
        constructor(type, source, callback, options, scheduleFn, cancelFn){
            $d9497ea901ae627a$var$__publicField(this, "type");
            $d9497ea901ae627a$var$__publicField(this, "source");
            $d9497ea901ae627a$var$__publicField(this, "invoke");
            $d9497ea901ae627a$var$__publicField(this, "callback");
            $d9497ea901ae627a$var$__publicField(this, "data");
            $d9497ea901ae627a$var$__publicField(this, "scheduleFn");
            $d9497ea901ae627a$var$__publicField(this, "cancelFn");
            $d9497ea901ae627a$var$__publicField(this, "_zone", null);
            $d9497ea901ae627a$var$__publicField(this, "runCount", 0);
            $d9497ea901ae627a$var$__publicField(this, "_zoneDelegates", null);
            $d9497ea901ae627a$var$__publicField(this, "_state", "notScheduled");
            this.type = type;
            this.source = source;
            this.data = options;
            this.scheduleFn = scheduleFn;
            this.cancelFn = cancelFn;
            if (!callback) throw new Error("callback is not defined");
            this.callback = callback;
            const self2 = this;
            if (type === eventTask && options && options.useG) this.invoke = ZoneTask.invokeTask;
            else this.invoke = function() {
                return ZoneTask.invokeTask.call($d9497ea901ae627a$var$global, self2, this, arguments);
            };
        }
        static invokeTask(task, target, args) {
            if (!task) task = this;
            _numberOfNestedTaskFrames++;
            try {
                task.runCount++;
                return task.zone.runTask(task, target, args);
            } finally{
                if (_numberOfNestedTaskFrames == 1) drainMicroTaskQueue();
                _numberOfNestedTaskFrames--;
            }
        }
        get zone() {
            return this._zone;
        }
        get state() {
            return this._state;
        }
        cancelScheduleRequest() {
            this._transitionTo(notScheduled, scheduling);
        }
        _transitionTo(toState, fromState1, fromState2) {
            if (this._state === fromState1 || this._state === fromState2) {
                this._state = toState;
                if (toState == notScheduled) this._zoneDelegates = null;
            } else throw new Error(`${this.type} '${this.source}': can not transition to '${toState}', expecting state '${fromState1}'${fromState2 ? " or '" + fromState2 + "'" : ""}, was '${this._state}'.`);
        }
        toString() {
            if (this.data && typeof this.data.handleId !== "undefined") return this.data.handleId.toString();
            else return Object.prototype.toString.call(this);
        }
        // add toJSON method to prevent cyclic error when
        // call JSON.stringify(zoneTask)
        toJSON() {
            return {
                type: this.type,
                state: this.state,
                source: this.source,
                zone: this.zone.name,
                runCount: this.runCount
            };
        }
    }
    const symbolSetTimeout = $d9497ea901ae627a$var$__symbol__("setTimeout");
    const symbolPromise = $d9497ea901ae627a$var$__symbol__("Promise");
    const symbolThen = $d9497ea901ae627a$var$__symbol__("then");
    let _microTaskQueue = [];
    let _isDrainingMicrotaskQueue = false;
    let nativeMicroTaskQueuePromise;
    function nativeScheduleMicroTask(func) {
        if (!nativeMicroTaskQueuePromise) {
            if ($d9497ea901ae627a$var$global[symbolPromise]) nativeMicroTaskQueuePromise = $d9497ea901ae627a$var$global[symbolPromise].resolve(0);
        }
        if (nativeMicroTaskQueuePromise) {
            let nativeThen = nativeMicroTaskQueuePromise[symbolThen];
            if (!nativeThen) nativeThen = nativeMicroTaskQueuePromise["then"];
            nativeThen.call(nativeMicroTaskQueuePromise, func);
        } else $d9497ea901ae627a$var$global[symbolSetTimeout](func, 0);
    }
    function scheduleMicroTask(task) {
        if (_numberOfNestedTaskFrames === 0 && _microTaskQueue.length === 0) nativeScheduleMicroTask(drainMicroTaskQueue);
        task && _microTaskQueue.push(task);
    }
    function drainMicroTaskQueue() {
        if (!_isDrainingMicrotaskQueue) {
            _isDrainingMicrotaskQueue = true;
            while(_microTaskQueue.length){
                const queue = _microTaskQueue;
                _microTaskQueue = [];
                for(let i = 0; i < queue.length; i++){
                    const task = queue[i];
                    try {
                        task.zone.runTask(task, null, null);
                    } catch (error) {
                        _api.onUnhandledError(error);
                    }
                }
            }
            _api.microtaskDrainDone();
            _isDrainingMicrotaskQueue = false;
        }
    }
    const NO_ZONE = {
        name: "NO ZONE"
    };
    const notScheduled = "notScheduled", scheduling = "scheduling", scheduled = "scheduled", running = "running", canceling = "canceling", unknown = "unknown";
    const microTask = "microTask", macroTask = "macroTask", eventTask = "eventTask";
    const patches = {};
    const _api = {
        symbol: $d9497ea901ae627a$var$__symbol__,
        currentZoneFrame: ()=>_currentZoneFrame,
        onUnhandledError: noop,
        microtaskDrainDone: noop,
        scheduleMicroTask: scheduleMicroTask,
        showUncaughtError: ()=>!ZoneImpl[$d9497ea901ae627a$var$__symbol__("ignoreConsoleErrorUncaughtError")],
        patchEventTarget: ()=>[],
        patchOnProperties: noop,
        patchMethod: ()=>noop,
        bindArguments: ()=>[],
        patchThen: ()=>noop,
        patchMacroTask: ()=>noop,
        patchEventPrototype: ()=>noop,
        getGlobalObjects: ()=>void 0,
        ObjectDefineProperty: ()=>noop,
        ObjectGetOwnPropertyDescriptor: ()=>void 0,
        ObjectCreate: ()=>void 0,
        ArraySlice: ()=>[],
        patchClass: ()=>noop,
        wrapWithCurrentZone: ()=>noop,
        filterProperties: ()=>[],
        attachOriginToPatched: ()=>noop,
        _redefineProperty: ()=>noop,
        patchCallbacks: ()=>noop,
        nativeScheduleMicroTask: nativeScheduleMicroTask
    };
    let _currentZoneFrame = {
        parent: null,
        zone: new ZoneImpl(null, null)
    };
    let _currentTask = null;
    let _numberOfNestedTaskFrames = 0;
    function noop() {}
    performanceMeasure("Zone", "Zone");
    return ZoneImpl;
}
// packages/zone.js/lib/zone.js
function $d9497ea901ae627a$var$loadZone() {
    var _a;
    const global2 = globalThis;
    const checkDuplicate = global2[$d9497ea901ae627a$var$__symbol__("forceDuplicateZoneCheck")] === true;
    if (global2["Zone"] && (checkDuplicate || typeof global2["Zone"].__symbol__ !== "function")) throw new Error("Zone already loaded.");
    (_a = global2["Zone"]) != null ? _a : global2["Zone"] = $d9497ea901ae627a$var$initZone();
    return global2["Zone"];
}
// packages/zone.js/lib/common/utils.js
var $d9497ea901ae627a$var$ObjectGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $d9497ea901ae627a$var$ObjectDefineProperty = Object.defineProperty;
var $d9497ea901ae627a$var$ObjectGetPrototypeOf = Object.getPrototypeOf;
var $d9497ea901ae627a$var$ObjectCreate = Object.create;
var $d9497ea901ae627a$var$ArraySlice = Array.prototype.slice;
var $d9497ea901ae627a$var$ADD_EVENT_LISTENER_STR = "addEventListener";
var $d9497ea901ae627a$var$REMOVE_EVENT_LISTENER_STR = "removeEventListener";
var $d9497ea901ae627a$var$ZONE_SYMBOL_ADD_EVENT_LISTENER = $d9497ea901ae627a$var$__symbol__($d9497ea901ae627a$var$ADD_EVENT_LISTENER_STR);
var $d9497ea901ae627a$var$ZONE_SYMBOL_REMOVE_EVENT_LISTENER = $d9497ea901ae627a$var$__symbol__($d9497ea901ae627a$var$REMOVE_EVENT_LISTENER_STR);
var $d9497ea901ae627a$var$TRUE_STR = "true";
var $d9497ea901ae627a$var$FALSE_STR = "false";
var $d9497ea901ae627a$var$ZONE_SYMBOL_PREFIX = $d9497ea901ae627a$var$__symbol__("");
function $d9497ea901ae627a$var$wrapWithCurrentZone(callback, source) {
    return Zone.current.wrap(callback, source);
}
function $d9497ea901ae627a$var$scheduleMacroTaskWithCurrentZone(source, callback, data, customSchedule, customCancel) {
    return Zone.current.scheduleMacroTask(source, callback, data, customSchedule, customCancel);
}
var $d9497ea901ae627a$var$zoneSymbol = $d9497ea901ae627a$var$__symbol__;
var $d9497ea901ae627a$var$isWindowExists = typeof window !== "undefined";
var $d9497ea901ae627a$var$internalWindow = $d9497ea901ae627a$var$isWindowExists ? window : void 0;
var $d9497ea901ae627a$var$_global = $d9497ea901ae627a$var$isWindowExists && $d9497ea901ae627a$var$internalWindow || globalThis;
var $d9497ea901ae627a$var$REMOVE_ATTRIBUTE = "removeAttribute";
function $d9497ea901ae627a$var$bindArguments(args, source) {
    for(let i = args.length - 1; i >= 0; i--)if (typeof args[i] === "function") args[i] = $d9497ea901ae627a$var$wrapWithCurrentZone(args[i], source + "_" + i);
    return args;
}
function $d9497ea901ae627a$var$patchPrototype(prototype, fnNames) {
    const source = prototype.constructor["name"];
    for(let i = 0; i < fnNames.length; i++){
        const name = fnNames[i];
        const delegate = prototype[name];
        if (delegate) {
            const prototypeDesc = $d9497ea901ae627a$var$ObjectGetOwnPropertyDescriptor(prototype, name);
            if (!$d9497ea901ae627a$var$isPropertyWritable(prototypeDesc)) continue;
            prototype[name] = ((delegate2)=>{
                const patched = function() {
                    return delegate2.apply(this, $d9497ea901ae627a$var$bindArguments(arguments, source + "." + name));
                };
                $d9497ea901ae627a$var$attachOriginToPatched(patched, delegate2);
                return patched;
            })(delegate);
        }
    }
}
function $d9497ea901ae627a$var$isPropertyWritable(propertyDesc) {
    if (!propertyDesc) return true;
    if (propertyDesc.writable === false) return false;
    return !(typeof propertyDesc.get === "function" && typeof propertyDesc.set === "undefined");
}
var $d9497ea901ae627a$var$isWebWorker = typeof WorkerGlobalScope !== "undefined" && self instanceof WorkerGlobalScope;
var $d9497ea901ae627a$var$isNode = !("nw" in $d9497ea901ae627a$var$_global) && typeof $d9497ea901ae627a$var$_global.process !== "undefined" && $d9497ea901ae627a$var$_global.process.toString() === "[object process]";
var $d9497ea901ae627a$var$isBrowser = !$d9497ea901ae627a$var$isNode && !$d9497ea901ae627a$var$isWebWorker && !!($d9497ea901ae627a$var$isWindowExists && $d9497ea901ae627a$var$internalWindow["HTMLElement"]);
var $d9497ea901ae627a$var$isMix = typeof $d9497ea901ae627a$var$_global.process !== "undefined" && $d9497ea901ae627a$var$_global.process.toString() === "[object process]" && !$d9497ea901ae627a$var$isWebWorker && !!($d9497ea901ae627a$var$isWindowExists && $d9497ea901ae627a$var$internalWindow["HTMLElement"]);
var $d9497ea901ae627a$var$zoneSymbolEventNames = {};
var $d9497ea901ae627a$var$enableBeforeunloadSymbol = $d9497ea901ae627a$var$zoneSymbol("enable_beforeunload");
var $d9497ea901ae627a$var$wrapFn = function(event) {
    event = event || $d9497ea901ae627a$var$_global.event;
    if (!event) return;
    let eventNameSymbol = $d9497ea901ae627a$var$zoneSymbolEventNames[event.type];
    if (!eventNameSymbol) eventNameSymbol = $d9497ea901ae627a$var$zoneSymbolEventNames[event.type] = $d9497ea901ae627a$var$zoneSymbol("ON_PROPERTY" + event.type);
    const target = this || event.target || $d9497ea901ae627a$var$_global;
    const listener = target[eventNameSymbol];
    let result;
    if ($d9497ea901ae627a$var$isBrowser && target === $d9497ea901ae627a$var$internalWindow && event.type === "error") {
        const errorEvent = event;
        result = listener && listener.call(this, errorEvent.message, errorEvent.filename, errorEvent.lineno, errorEvent.colno, errorEvent.error);
        if (result === true) event.preventDefault();
    } else {
        result = listener && listener.apply(this, arguments);
        if (// https://github.com/angular/angular/issues/47579
        // https://www.w3.org/TR/2011/WD-html5-20110525/history.html#beforeunloadevent
        // This is the only specific case we should check for. The spec defines that the
        // `returnValue` attribute represents the message to show the user. When the event
        // is created, this attribute must be set to the empty string.
        event.type === "beforeunload" && // To prevent any breaking changes resulting from this change, given that
        // it was already causing a significant number of failures in G3, we have hidden
        // that behavior behind a global configuration flag. Consumers can enable this
        // flag explicitly if they want the `beforeunload` event to be handled as defined
        // in the specification.
        $d9497ea901ae627a$var$_global[$d9497ea901ae627a$var$enableBeforeunloadSymbol] && // The IDL event definition is `attribute DOMString returnValue`, so we check whether
        // `typeof result` is a string.
        typeof result === "string") event.returnValue = result;
        else if (result != void 0 && !result) event.preventDefault();
    }
    return result;
};
function $d9497ea901ae627a$var$patchProperty(obj, prop, prototype) {
    let desc = $d9497ea901ae627a$var$ObjectGetOwnPropertyDescriptor(obj, prop);
    if (!desc && prototype) {
        const prototypeDesc = $d9497ea901ae627a$var$ObjectGetOwnPropertyDescriptor(prototype, prop);
        if (prototypeDesc) desc = {
            enumerable: true,
            configurable: true
        };
    }
    if (!desc || !desc.configurable) return;
    const onPropPatchedSymbol = $d9497ea901ae627a$var$zoneSymbol("on" + prop + "patched");
    if (obj.hasOwnProperty(onPropPatchedSymbol) && obj[onPropPatchedSymbol]) return;
    delete desc.writable;
    delete desc.value;
    const originalDescGet = desc.get;
    const originalDescSet = desc.set;
    const eventName = prop.slice(2);
    let eventNameSymbol = $d9497ea901ae627a$var$zoneSymbolEventNames[eventName];
    if (!eventNameSymbol) eventNameSymbol = $d9497ea901ae627a$var$zoneSymbolEventNames[eventName] = $d9497ea901ae627a$var$zoneSymbol("ON_PROPERTY" + eventName);
    desc.set = function(newValue) {
        let target = this;
        if (!target && obj === $d9497ea901ae627a$var$_global) target = $d9497ea901ae627a$var$_global;
        if (!target) return;
        const previousValue = target[eventNameSymbol];
        if (typeof previousValue === "function") target.removeEventListener(eventName, $d9497ea901ae627a$var$wrapFn);
        originalDescSet == null || originalDescSet.call(target, null);
        target[eventNameSymbol] = newValue;
        if (typeof newValue === "function") target.addEventListener(eventName, $d9497ea901ae627a$var$wrapFn, false);
    };
    desc.get = function() {
        let target = this;
        if (!target && obj === $d9497ea901ae627a$var$_global) target = $d9497ea901ae627a$var$_global;
        if (!target) return null;
        const listener = target[eventNameSymbol];
        if (listener) return listener;
        else if (originalDescGet) {
            let value = originalDescGet.call(this);
            if (value) {
                desc.set.call(this, value);
                if (typeof target[$d9497ea901ae627a$var$REMOVE_ATTRIBUTE] === "function") target.removeAttribute(prop);
                return value;
            }
        }
        return null;
    };
    $d9497ea901ae627a$var$ObjectDefineProperty(obj, prop, desc);
    obj[onPropPatchedSymbol] = true;
}
function $d9497ea901ae627a$var$patchOnProperties(obj, properties, prototype) {
    if (properties) for(let i = 0; i < properties.length; i++)$d9497ea901ae627a$var$patchProperty(obj, "on" + properties[i], prototype);
    else {
        const onProperties = [];
        for(const prop in obj)if (prop.slice(0, 2) == "on") onProperties.push(prop);
        for(let j = 0; j < onProperties.length; j++)$d9497ea901ae627a$var$patchProperty(obj, onProperties[j], prototype);
    }
}
var $d9497ea901ae627a$var$originalInstanceKey = $d9497ea901ae627a$var$zoneSymbol("originalInstance");
function $d9497ea901ae627a$var$patchClass(className) {
    const OriginalClass = $d9497ea901ae627a$var$_global[className];
    if (!OriginalClass) return;
    $d9497ea901ae627a$var$_global[$d9497ea901ae627a$var$zoneSymbol(className)] = OriginalClass;
    $d9497ea901ae627a$var$_global[className] = function() {
        const a = $d9497ea901ae627a$var$bindArguments(arguments, className);
        switch(a.length){
            case 0:
                this[$d9497ea901ae627a$var$originalInstanceKey] = new OriginalClass();
                break;
            case 1:
                this[$d9497ea901ae627a$var$originalInstanceKey] = new OriginalClass(a[0]);
                break;
            case 2:
                this[$d9497ea901ae627a$var$originalInstanceKey] = new OriginalClass(a[0], a[1]);
                break;
            case 3:
                this[$d9497ea901ae627a$var$originalInstanceKey] = new OriginalClass(a[0], a[1], a[2]);
                break;
            case 4:
                this[$d9497ea901ae627a$var$originalInstanceKey] = new OriginalClass(a[0], a[1], a[2], a[3]);
                break;
            default:
                throw new Error("Arg list too long.");
        }
    };
    $d9497ea901ae627a$var$attachOriginToPatched($d9497ea901ae627a$var$_global[className], OriginalClass);
    const instance = new OriginalClass(function() {});
    let prop;
    for(prop in instance){
        if (className === "XMLHttpRequest" && prop === "responseBlob") continue;
        (function(prop2) {
            if (typeof instance[prop2] === "function") $d9497ea901ae627a$var$_global[className].prototype[prop2] = function() {
                return this[$d9497ea901ae627a$var$originalInstanceKey][prop2].apply(this[$d9497ea901ae627a$var$originalInstanceKey], arguments);
            };
            else $d9497ea901ae627a$var$ObjectDefineProperty($d9497ea901ae627a$var$_global[className].prototype, prop2, {
                set: function(fn) {
                    if (typeof fn === "function") {
                        this[$d9497ea901ae627a$var$originalInstanceKey][prop2] = $d9497ea901ae627a$var$wrapWithCurrentZone(fn, className + "." + prop2);
                        $d9497ea901ae627a$var$attachOriginToPatched(this[$d9497ea901ae627a$var$originalInstanceKey][prop2], fn);
                    } else this[$d9497ea901ae627a$var$originalInstanceKey][prop2] = fn;
                },
                get: function() {
                    return this[$d9497ea901ae627a$var$originalInstanceKey][prop2];
                }
            });
        })(prop);
    }
    for(prop in OriginalClass)if (prop !== "prototype" && OriginalClass.hasOwnProperty(prop)) $d9497ea901ae627a$var$_global[className][prop] = OriginalClass[prop];
}
function $d9497ea901ae627a$var$copySymbolProperties(src, dest) {
    if (typeof Object.getOwnPropertySymbols !== "function") return;
    const symbols = Object.getOwnPropertySymbols(src);
    symbols.forEach((symbol)=>{
        const desc = Object.getOwnPropertyDescriptor(src, symbol);
        Object.defineProperty(dest, symbol, {
            get: function() {
                return src[symbol];
            },
            set: function(value) {
                if (desc && (!desc.writable || typeof desc.set !== "function")) return;
                src[symbol] = value;
            },
            enumerable: desc ? desc.enumerable : true,
            configurable: desc ? desc.configurable : true
        });
    });
}
var $d9497ea901ae627a$var$shouldCopySymbolProperties = false;
function $d9497ea901ae627a$var$patchMethod(target, name, patchFn) {
    let proto = target;
    while(proto && !proto.hasOwnProperty(name))proto = $d9497ea901ae627a$var$ObjectGetPrototypeOf(proto);
    if (!proto && target[name]) proto = target;
    const delegateName = $d9497ea901ae627a$var$zoneSymbol(name);
    let delegate = null;
    if (proto && (!(delegate = proto[delegateName]) || !proto.hasOwnProperty(delegateName))) {
        delegate = proto[delegateName] = proto[name];
        const desc = proto && $d9497ea901ae627a$var$ObjectGetOwnPropertyDescriptor(proto, name);
        if ($d9497ea901ae627a$var$isPropertyWritable(desc)) {
            const patchDelegate = patchFn(delegate, delegateName, name);
            proto[name] = function() {
                return patchDelegate(this, arguments);
            };
            $d9497ea901ae627a$var$attachOriginToPatched(proto[name], delegate);
            if ($d9497ea901ae627a$var$shouldCopySymbolProperties) $d9497ea901ae627a$var$copySymbolProperties(delegate, proto[name]);
        }
    }
    return delegate;
}
function $d9497ea901ae627a$var$patchMacroTask(obj, funcName, metaCreator) {
    let setNative = null;
    function scheduleTask(task) {
        const data = task.data;
        data.args[data.cbIdx] = function() {
            task.invoke.apply(this, arguments);
        };
        setNative.apply(data.target, data.args);
        return task;
    }
    setNative = $d9497ea901ae627a$var$patchMethod(obj, funcName, (delegate)=>function(self2, args) {
            const meta = metaCreator(self2, args);
            if (meta.cbIdx >= 0 && typeof args[meta.cbIdx] === "function") return $d9497ea901ae627a$var$scheduleMacroTaskWithCurrentZone(meta.name, args[meta.cbIdx], meta, scheduleTask);
            else return delegate.apply(self2, args);
        });
}
function $d9497ea901ae627a$var$attachOriginToPatched(patched, original) {
    patched[$d9497ea901ae627a$var$zoneSymbol("OriginalDelegate")] = original;
}
function $d9497ea901ae627a$var$isFunction(value) {
    return typeof value === "function";
}
function $d9497ea901ae627a$var$isNumber(value) {
    return typeof value === "number";
}
// packages/zone.js/lib/common/events.js
var $d9497ea901ae627a$var$OPTIMIZED_ZONE_EVENT_TASK_DATA = {
    useG: true
};
var $d9497ea901ae627a$var$zoneSymbolEventNames2 = {};
var $d9497ea901ae627a$var$globalSources = {};
var $d9497ea901ae627a$var$EVENT_NAME_SYMBOL_REGX = new RegExp("^" + $d9497ea901ae627a$var$ZONE_SYMBOL_PREFIX + "(\\w+)(true|false)$");
var $d9497ea901ae627a$var$IMMEDIATE_PROPAGATION_SYMBOL = $d9497ea901ae627a$var$zoneSymbol("propagationStopped");
function $d9497ea901ae627a$var$prepareEventNames(eventName, eventNameToString) {
    const falseEventName = (eventNameToString ? eventNameToString(eventName) : eventName) + $d9497ea901ae627a$var$FALSE_STR;
    const trueEventName = (eventNameToString ? eventNameToString(eventName) : eventName) + $d9497ea901ae627a$var$TRUE_STR;
    const symbol = $d9497ea901ae627a$var$ZONE_SYMBOL_PREFIX + falseEventName;
    const symbolCapture = $d9497ea901ae627a$var$ZONE_SYMBOL_PREFIX + trueEventName;
    $d9497ea901ae627a$var$zoneSymbolEventNames2[eventName] = {};
    $d9497ea901ae627a$var$zoneSymbolEventNames2[eventName][$d9497ea901ae627a$var$FALSE_STR] = symbol;
    $d9497ea901ae627a$var$zoneSymbolEventNames2[eventName][$d9497ea901ae627a$var$TRUE_STR] = symbolCapture;
}
function $d9497ea901ae627a$var$patchEventTarget(_global2, api, apis, patchOptions) {
    const ADD_EVENT_LISTENER = patchOptions && patchOptions.add || $d9497ea901ae627a$var$ADD_EVENT_LISTENER_STR;
    const REMOVE_EVENT_LISTENER = patchOptions && patchOptions.rm || $d9497ea901ae627a$var$REMOVE_EVENT_LISTENER_STR;
    const LISTENERS_EVENT_LISTENER = patchOptions && patchOptions.listeners || "eventListeners";
    const REMOVE_ALL_LISTENERS_EVENT_LISTENER = patchOptions && patchOptions.rmAll || "removeAllListeners";
    const zoneSymbolAddEventListener = $d9497ea901ae627a$var$zoneSymbol(ADD_EVENT_LISTENER);
    const ADD_EVENT_LISTENER_SOURCE = "." + ADD_EVENT_LISTENER + ":";
    const PREPEND_EVENT_LISTENER = "prependListener";
    const PREPEND_EVENT_LISTENER_SOURCE = "." + PREPEND_EVENT_LISTENER + ":";
    const invokeTask = function(task, target, event) {
        if (task.isRemoved) return;
        const delegate = task.callback;
        if (typeof delegate === "object" && delegate.handleEvent) {
            task.callback = (event2)=>delegate.handleEvent(event2);
            task.originalDelegate = delegate;
        }
        let error;
        try {
            task.invoke(task, target, [
                event
            ]);
        } catch (err) {
            error = err;
        }
        const options = task.options;
        if (options && typeof options === "object" && options.once) {
            const delegate2 = task.originalDelegate ? task.originalDelegate : task.callback;
            target[REMOVE_EVENT_LISTENER].call(target, event.type, delegate2, options);
        }
        return error;
    };
    function globalCallback(context, event, isCapture) {
        event = event || _global2.event;
        if (!event) return;
        const target = context || event.target || _global2;
        const tasks = target[$d9497ea901ae627a$var$zoneSymbolEventNames2[event.type][isCapture ? $d9497ea901ae627a$var$TRUE_STR : $d9497ea901ae627a$var$FALSE_STR]];
        if (tasks) {
            const errors = [];
            if (tasks.length === 1) {
                const err = invokeTask(tasks[0], target, event);
                err && errors.push(err);
            } else {
                const copyTasks = tasks.slice();
                for(let i = 0; i < copyTasks.length; i++){
                    if (event && event[$d9497ea901ae627a$var$IMMEDIATE_PROPAGATION_SYMBOL] === true) break;
                    const err = invokeTask(copyTasks[i], target, event);
                    err && errors.push(err);
                }
            }
            if (errors.length === 1) throw errors[0];
            else for(let i = 0; i < errors.length; i++){
                const err = errors[i];
                api.nativeScheduleMicroTask(()=>{
                    throw err;
                });
            }
        }
    }
    const globalZoneAwareCallback = function(event) {
        return globalCallback(this, event, false);
    };
    const globalZoneAwareCaptureCallback = function(event) {
        return globalCallback(this, event, true);
    };
    function patchEventTargetMethods(obj, patchOptions2) {
        if (!obj) return false;
        let useGlobalCallback = true;
        if (patchOptions2 && patchOptions2.useG !== void 0) useGlobalCallback = patchOptions2.useG;
        const validateHandler = patchOptions2 && patchOptions2.vh;
        let checkDuplicate = true;
        if (patchOptions2 && patchOptions2.chkDup !== void 0) checkDuplicate = patchOptions2.chkDup;
        let returnTarget = false;
        if (patchOptions2 && patchOptions2.rt !== void 0) returnTarget = patchOptions2.rt;
        let proto = obj;
        while(proto && !proto.hasOwnProperty(ADD_EVENT_LISTENER))proto = $d9497ea901ae627a$var$ObjectGetPrototypeOf(proto);
        if (!proto && obj[ADD_EVENT_LISTENER]) proto = obj;
        if (!proto) return false;
        if (proto[zoneSymbolAddEventListener]) return false;
        const eventNameToString = patchOptions2 && patchOptions2.eventNameToString;
        const taskData = {};
        const nativeAddEventListener = proto[zoneSymbolAddEventListener] = proto[ADD_EVENT_LISTENER];
        const nativeRemoveEventListener = proto[$d9497ea901ae627a$var$zoneSymbol(REMOVE_EVENT_LISTENER)] = proto[REMOVE_EVENT_LISTENER];
        const nativeListeners = proto[$d9497ea901ae627a$var$zoneSymbol(LISTENERS_EVENT_LISTENER)] = proto[LISTENERS_EVENT_LISTENER];
        const nativeRemoveAllListeners = proto[$d9497ea901ae627a$var$zoneSymbol(REMOVE_ALL_LISTENERS_EVENT_LISTENER)] = proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER];
        let nativePrependEventListener;
        if (patchOptions2 && patchOptions2.prepend) nativePrependEventListener = proto[$d9497ea901ae627a$var$zoneSymbol(patchOptions2.prepend)] = proto[patchOptions2.prepend];
        function buildEventListenerOptions(options, passive) {
            if (!passive) return options;
            if (typeof options === "boolean") return {
                capture: options,
                passive: true
            };
            if (!options) return {
                passive: true
            };
            if (typeof options === "object" && options.passive !== false) return $d9497ea901ae627a$var$__spreadProps($d9497ea901ae627a$var$__spreadValues({}, options), {
                passive: true
            });
            return options;
        }
        const customScheduleGlobal = function(task) {
            if (taskData.isExisting) return;
            return nativeAddEventListener.call(taskData.target, taskData.eventName, taskData.capture ? globalZoneAwareCaptureCallback : globalZoneAwareCallback, taskData.options);
        };
        const customCancelGlobal = function(task) {
            if (!task.isRemoved) {
                const symbolEventNames = $d9497ea901ae627a$var$zoneSymbolEventNames2[task.eventName];
                let symbolEventName;
                if (symbolEventNames) symbolEventName = symbolEventNames[task.capture ? $d9497ea901ae627a$var$TRUE_STR : $d9497ea901ae627a$var$FALSE_STR];
                const existingTasks = symbolEventName && task.target[symbolEventName];
                if (existingTasks) for(let i = 0; i < existingTasks.length; i++){
                    const existingTask = existingTasks[i];
                    if (existingTask === task) {
                        existingTasks.splice(i, 1);
                        task.isRemoved = true;
                        if (task.removeAbortListener) {
                            task.removeAbortListener();
                            task.removeAbortListener = null;
                        }
                        if (existingTasks.length === 0) {
                            task.allRemoved = true;
                            task.target[symbolEventName] = null;
                        }
                        break;
                    }
                }
            }
            if (!task.allRemoved) return;
            return nativeRemoveEventListener.call(task.target, task.eventName, task.capture ? globalZoneAwareCaptureCallback : globalZoneAwareCallback, task.options);
        };
        const customScheduleNonGlobal = function(task) {
            return nativeAddEventListener.call(taskData.target, taskData.eventName, task.invoke, taskData.options);
        };
        const customSchedulePrepend = function(task) {
            return nativePrependEventListener.call(taskData.target, taskData.eventName, task.invoke, taskData.options);
        };
        const customCancelNonGlobal = function(task) {
            return nativeRemoveEventListener.call(task.target, task.eventName, task.invoke, task.options);
        };
        const customSchedule = useGlobalCallback ? customScheduleGlobal : customScheduleNonGlobal;
        const customCancel = useGlobalCallback ? customCancelGlobal : customCancelNonGlobal;
        const compareTaskCallbackVsDelegate = function(task, delegate) {
            const typeOfDelegate = typeof delegate;
            return typeOfDelegate === "function" && task.callback === delegate || typeOfDelegate === "object" && task.originalDelegate === delegate;
        };
        const compare = (patchOptions2 == null ? void 0 : patchOptions2.diff) || compareTaskCallbackVsDelegate;
        const unpatchedEvents = Zone[$d9497ea901ae627a$var$zoneSymbol("UNPATCHED_EVENTS")];
        const passiveEvents = _global2[$d9497ea901ae627a$var$zoneSymbol("PASSIVE_EVENTS")];
        function copyEventListenerOptions(options) {
            if (typeof options === "object" && options !== null) {
                const newOptions = $d9497ea901ae627a$var$__spreadValues({}, options);
                if (options.signal) newOptions.signal = options.signal;
                return newOptions;
            }
            return options;
        }
        const makeAddListener = function(nativeListener, addSource, customScheduleFn, customCancelFn, returnTarget2 = false, prepend = false) {
            return function() {
                const target = this || _global2;
                let eventName = arguments[0];
                if (patchOptions2 && patchOptions2.transferEventName) eventName = patchOptions2.transferEventName(eventName);
                let delegate = arguments[1];
                if (!delegate) return nativeListener.apply(this, arguments);
                if ($d9497ea901ae627a$var$isNode && eventName === "uncaughtException") return nativeListener.apply(this, arguments);
                let isEventListenerObject = false;
                if (typeof delegate !== "function") {
                    if (!delegate.handleEvent) return nativeListener.apply(this, arguments);
                    isEventListenerObject = true;
                }
                if (validateHandler && !validateHandler(nativeListener, delegate, target, arguments)) return;
                const passive = !!passiveEvents && passiveEvents.indexOf(eventName) !== -1;
                const options = copyEventListenerOptions(buildEventListenerOptions(arguments[2], passive));
                const signal = options == null ? void 0 : options.signal;
                if (signal == null ? void 0 : signal.aborted) return;
                if (unpatchedEvents) {
                    for(let i = 0; i < unpatchedEvents.length; i++)if (eventName === unpatchedEvents[i]) {
                        if (passive) return nativeListener.call(target, eventName, delegate, options);
                        else return nativeListener.apply(this, arguments);
                    }
                }
                const capture = !options ? false : typeof options === "boolean" ? true : options.capture;
                const once = options && typeof options === "object" ? options.once : false;
                const zone = Zone.current;
                let symbolEventNames = $d9497ea901ae627a$var$zoneSymbolEventNames2[eventName];
                if (!symbolEventNames) {
                    $d9497ea901ae627a$var$prepareEventNames(eventName, eventNameToString);
                    symbolEventNames = $d9497ea901ae627a$var$zoneSymbolEventNames2[eventName];
                }
                const symbolEventName = symbolEventNames[capture ? $d9497ea901ae627a$var$TRUE_STR : $d9497ea901ae627a$var$FALSE_STR];
                let existingTasks = target[symbolEventName];
                let isExisting = false;
                if (existingTasks) {
                    isExisting = true;
                    if (checkDuplicate) for(let i = 0; i < existingTasks.length; i++){
                        if (compare(existingTasks[i], delegate)) return;
                    }
                } else existingTasks = target[symbolEventName] = [];
                let source;
                const constructorName = target.constructor["name"];
                const targetSource = $d9497ea901ae627a$var$globalSources[constructorName];
                if (targetSource) source = targetSource[eventName];
                if (!source) source = constructorName + addSource + (eventNameToString ? eventNameToString(eventName) : eventName);
                taskData.options = options;
                if (once) taskData.options.once = false;
                taskData.target = target;
                taskData.capture = capture;
                taskData.eventName = eventName;
                taskData.isExisting = isExisting;
                const data = useGlobalCallback ? $d9497ea901ae627a$var$OPTIMIZED_ZONE_EVENT_TASK_DATA : void 0;
                if (data) data.taskData = taskData;
                if (signal) taskData.options.signal = void 0;
                const task = zone.scheduleEventTask(source, delegate, data, customScheduleFn, customCancelFn);
                if (signal) {
                    taskData.options.signal = signal;
                    const onAbort = ()=>task.zone.cancelTask(task);
                    nativeListener.call(signal, "abort", onAbort, {
                        once: true
                    });
                    task.removeAbortListener = ()=>signal.removeEventListener("abort", onAbort);
                }
                taskData.target = null;
                if (data) data.taskData = null;
                if (once) taskData.options.once = true;
                if (typeof task.options !== "boolean") task.options = options;
                task.target = target;
                task.capture = capture;
                task.eventName = eventName;
                if (isEventListenerObject) task.originalDelegate = delegate;
                if (!prepend) existingTasks.push(task);
                else existingTasks.unshift(task);
                if (returnTarget2) return target;
            };
        };
        proto[ADD_EVENT_LISTENER] = makeAddListener(nativeAddEventListener, ADD_EVENT_LISTENER_SOURCE, customSchedule, customCancel, returnTarget);
        if (nativePrependEventListener) proto[PREPEND_EVENT_LISTENER] = makeAddListener(nativePrependEventListener, PREPEND_EVENT_LISTENER_SOURCE, customSchedulePrepend, customCancel, returnTarget, true);
        proto[REMOVE_EVENT_LISTENER] = function() {
            const target = this || _global2;
            let eventName = arguments[0];
            if (patchOptions2 && patchOptions2.transferEventName) eventName = patchOptions2.transferEventName(eventName);
            const options = arguments[2];
            const capture = !options ? false : typeof options === "boolean" ? true : options.capture;
            const delegate = arguments[1];
            if (!delegate) return nativeRemoveEventListener.apply(this, arguments);
            if (validateHandler && !validateHandler(nativeRemoveEventListener, delegate, target, arguments)) return;
            const symbolEventNames = $d9497ea901ae627a$var$zoneSymbolEventNames2[eventName];
            let symbolEventName;
            if (symbolEventNames) symbolEventName = symbolEventNames[capture ? $d9497ea901ae627a$var$TRUE_STR : $d9497ea901ae627a$var$FALSE_STR];
            const existingTasks = symbolEventName && target[symbolEventName];
            if (existingTasks) for(let i = 0; i < existingTasks.length; i++){
                const existingTask = existingTasks[i];
                if (compare(existingTask, delegate)) {
                    existingTasks.splice(i, 1);
                    existingTask.isRemoved = true;
                    if (existingTasks.length === 0) {
                        existingTask.allRemoved = true;
                        target[symbolEventName] = null;
                        if (!capture && typeof eventName === "string") {
                            const onPropertySymbol = $d9497ea901ae627a$var$ZONE_SYMBOL_PREFIX + "ON_PROPERTY" + eventName;
                            target[onPropertySymbol] = null;
                        }
                    }
                    existingTask.zone.cancelTask(existingTask);
                    if (returnTarget) return target;
                    return;
                }
            }
            return nativeRemoveEventListener.apply(this, arguments);
        };
        proto[LISTENERS_EVENT_LISTENER] = function() {
            const target = this || _global2;
            let eventName = arguments[0];
            if (patchOptions2 && patchOptions2.transferEventName) eventName = patchOptions2.transferEventName(eventName);
            const listeners = [];
            const tasks = $d9497ea901ae627a$var$findEventTasks(target, eventNameToString ? eventNameToString(eventName) : eventName);
            for(let i = 0; i < tasks.length; i++){
                const task = tasks[i];
                let delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                listeners.push(delegate);
            }
            return listeners;
        };
        proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER] = function() {
            const target = this || _global2;
            let eventName = arguments[0];
            if (!eventName) {
                const keys = Object.keys(target);
                for(let i = 0; i < keys.length; i++){
                    const prop = keys[i];
                    const match = $d9497ea901ae627a$var$EVENT_NAME_SYMBOL_REGX.exec(prop);
                    let evtName = match && match[1];
                    if (evtName && evtName !== "removeListener") this[REMOVE_ALL_LISTENERS_EVENT_LISTENER].call(this, evtName);
                }
                this[REMOVE_ALL_LISTENERS_EVENT_LISTENER].call(this, "removeListener");
            } else {
                if (patchOptions2 && patchOptions2.transferEventName) eventName = patchOptions2.transferEventName(eventName);
                const symbolEventNames = $d9497ea901ae627a$var$zoneSymbolEventNames2[eventName];
                if (symbolEventNames) {
                    const symbolEventName = symbolEventNames[$d9497ea901ae627a$var$FALSE_STR];
                    const symbolCaptureEventName = symbolEventNames[$d9497ea901ae627a$var$TRUE_STR];
                    const tasks = target[symbolEventName];
                    const captureTasks = target[symbolCaptureEventName];
                    if (tasks) {
                        const removeTasks = tasks.slice();
                        for(let i = 0; i < removeTasks.length; i++){
                            const task = removeTasks[i];
                            let delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                            this[REMOVE_EVENT_LISTENER].call(this, eventName, delegate, task.options);
                        }
                    }
                    if (captureTasks) {
                        const removeTasks = captureTasks.slice();
                        for(let i = 0; i < removeTasks.length; i++){
                            const task = removeTasks[i];
                            let delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                            this[REMOVE_EVENT_LISTENER].call(this, eventName, delegate, task.options);
                        }
                    }
                }
            }
            if (returnTarget) return this;
        };
        $d9497ea901ae627a$var$attachOriginToPatched(proto[ADD_EVENT_LISTENER], nativeAddEventListener);
        $d9497ea901ae627a$var$attachOriginToPatched(proto[REMOVE_EVENT_LISTENER], nativeRemoveEventListener);
        if (nativeRemoveAllListeners) $d9497ea901ae627a$var$attachOriginToPatched(proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER], nativeRemoveAllListeners);
        if (nativeListeners) $d9497ea901ae627a$var$attachOriginToPatched(proto[LISTENERS_EVENT_LISTENER], nativeListeners);
        return true;
    }
    let results = [];
    for(let i = 0; i < apis.length; i++)results[i] = patchEventTargetMethods(apis[i], patchOptions);
    return results;
}
function $d9497ea901ae627a$var$findEventTasks(target, eventName) {
    if (!eventName) {
        const foundTasks = [];
        for(let prop in target){
            const match = $d9497ea901ae627a$var$EVENT_NAME_SYMBOL_REGX.exec(prop);
            let evtName = match && match[1];
            if (evtName && (!eventName || evtName === eventName)) {
                const tasks = target[prop];
                if (tasks) for(let i = 0; i < tasks.length; i++)foundTasks.push(tasks[i]);
            }
        }
        return foundTasks;
    }
    let symbolEventName = $d9497ea901ae627a$var$zoneSymbolEventNames2[eventName];
    if (!symbolEventName) {
        $d9497ea901ae627a$var$prepareEventNames(eventName);
        symbolEventName = $d9497ea901ae627a$var$zoneSymbolEventNames2[eventName];
    }
    const captureFalseTasks = target[symbolEventName[$d9497ea901ae627a$var$FALSE_STR]];
    const captureTrueTasks = target[symbolEventName[$d9497ea901ae627a$var$TRUE_STR]];
    if (!captureFalseTasks) return captureTrueTasks ? captureTrueTasks.slice() : [];
    else return captureTrueTasks ? captureFalseTasks.concat(captureTrueTasks) : captureFalseTasks.slice();
}
function $d9497ea901ae627a$var$patchEventPrototype(global2, api) {
    const Event = global2["Event"];
    if (Event && Event.prototype) api.patchMethod(Event.prototype, "stopImmediatePropagation", (delegate)=>function(self2, args) {
            self2[$d9497ea901ae627a$var$IMMEDIATE_PROPAGATION_SYMBOL] = true;
            delegate && delegate.apply(self2, args);
        });
}
// packages/zone.js/lib/common/queue-microtask.js
function $d9497ea901ae627a$var$patchQueueMicrotask(global2, api) {
    api.patchMethod(global2, "queueMicrotask", (delegate)=>{
        return function(self2, args) {
            Zone.current.scheduleMicroTask("queueMicrotask", args[0]);
        };
    });
}
// packages/zone.js/lib/common/timers.js
var $d9497ea901ae627a$var$taskSymbol = $d9497ea901ae627a$var$zoneSymbol("zoneTask");
function $d9497ea901ae627a$var$patchTimer(window2, setName, cancelName, nameSuffix) {
    let setNative = null;
    let clearNative = null;
    setName += nameSuffix;
    cancelName += nameSuffix;
    const tasksByHandleId = {};
    function scheduleTask(task) {
        const data = task.data;
        data.args[0] = function() {
            return task.invoke.apply(this, arguments);
        };
        const handleOrId = setNative.apply(window2, data.args);
        if ($d9497ea901ae627a$var$isNumber(handleOrId)) data.handleId = handleOrId;
        else {
            data.handle = handleOrId;
            data.isRefreshable = $d9497ea901ae627a$var$isFunction(handleOrId.refresh);
        }
        return task;
    }
    function clearTask(task) {
        const { handle: handle, handleId: handleId } = task.data;
        return clearNative.call(window2, handle != null ? handle : handleId);
    }
    setNative = $d9497ea901ae627a$var$patchMethod(window2, setName, (delegate)=>function(self2, args) {
            var _a;
            if ($d9497ea901ae627a$var$isFunction(args[0])) {
                const options = {
                    isRefreshable: false,
                    isPeriodic: nameSuffix === "Interval",
                    delay: nameSuffix === "Timeout" || nameSuffix === "Interval" ? args[1] || 0 : void 0,
                    args: args
                };
                const callback = args[0];
                args[0] = function timer() {
                    try {
                        return callback.apply(this, arguments);
                    } finally{
                        const { handle: handle2, handleId: handleId2, isPeriodic: isPeriodic2, isRefreshable: isRefreshable2 } = options;
                        if (!isPeriodic2 && !isRefreshable2) {
                            if (handleId2) delete tasksByHandleId[handleId2];
                            else if (handle2) handle2[$d9497ea901ae627a$var$taskSymbol] = null;
                        }
                    }
                };
                const task = $d9497ea901ae627a$var$scheduleMacroTaskWithCurrentZone(setName, args[0], options, scheduleTask, clearTask);
                if (!task) return task;
                const { handleId: handleId, handle: handle, isRefreshable: isRefreshable, isPeriodic: isPeriodic } = task.data;
                if (handleId) tasksByHandleId[handleId] = task;
                else if (handle) {
                    handle[$d9497ea901ae627a$var$taskSymbol] = task;
                    if (isRefreshable && !isPeriodic) {
                        const originalRefresh = handle.refresh;
                        handle.refresh = function() {
                            const { zone: zone, state: state } = task;
                            if (state === "notScheduled") {
                                task._state = "scheduled";
                                zone._updateTaskCount(task, 1);
                            } else if (state === "running") task._state = "scheduling";
                            return originalRefresh.call(this);
                        };
                    }
                }
                return (_a = handle != null ? handle : handleId) != null ? _a : task;
            } else return delegate.apply(window2, args);
        });
    clearNative = $d9497ea901ae627a$var$patchMethod(window2, cancelName, (delegate)=>function(self2, args) {
            const id = args[0];
            let task;
            if ($d9497ea901ae627a$var$isNumber(id)) {
                task = tasksByHandleId[id];
                delete tasksByHandleId[id];
            } else {
                task = id == null ? void 0 : id[$d9497ea901ae627a$var$taskSymbol];
                if (task) id[$d9497ea901ae627a$var$taskSymbol] = null;
                else task = id;
            }
            if (task == null ? void 0 : task.type) {
                if (task.cancelFn) task.zone.cancelTask(task);
            } else delegate.apply(window2, args);
        });
}
// packages/zone.js/lib/browser/custom-elements.js
function $d9497ea901ae627a$var$patchCustomElements(_global2, api) {
    const { isBrowser: isBrowser2, isMix: isMix2 } = api.getGlobalObjects();
    if (!isBrowser2 && !isMix2 || !_global2["customElements"] || !("customElements" in _global2)) return;
    const callbacks = [
        "connectedCallback",
        "disconnectedCallback",
        "adoptedCallback",
        "attributeChangedCallback",
        "formAssociatedCallback",
        "formDisabledCallback",
        "formResetCallback",
        "formStateRestoreCallback"
    ];
    api.patchCallbacks(api, _global2.customElements, "customElements", "define", callbacks);
}
// packages/zone.js/lib/browser/event-target.js
function $d9497ea901ae627a$var$eventTargetPatch(_global2, api) {
    if (Zone[api.symbol("patchEventTarget")]) return;
    const { eventNames: eventNames, zoneSymbolEventNames: zoneSymbolEventNames3, TRUE_STR: TRUE_STR2, FALSE_STR: FALSE_STR2, ZONE_SYMBOL_PREFIX: ZONE_SYMBOL_PREFIX2 } = api.getGlobalObjects();
    for(let i = 0; i < eventNames.length; i++){
        const eventName = eventNames[i];
        const falseEventName = eventName + FALSE_STR2;
        const trueEventName = eventName + TRUE_STR2;
        const symbol = ZONE_SYMBOL_PREFIX2 + falseEventName;
        const symbolCapture = ZONE_SYMBOL_PREFIX2 + trueEventName;
        zoneSymbolEventNames3[eventName] = {};
        zoneSymbolEventNames3[eventName][FALSE_STR2] = symbol;
        zoneSymbolEventNames3[eventName][TRUE_STR2] = symbolCapture;
    }
    const EVENT_TARGET = _global2["EventTarget"];
    if (!EVENT_TARGET || !EVENT_TARGET.prototype) return;
    api.patchEventTarget(_global2, api, [
        EVENT_TARGET && EVENT_TARGET.prototype
    ]);
    return true;
}
function $d9497ea901ae627a$var$patchEvent(global2, api) {
    api.patchEventPrototype(global2, api);
}
// packages/zone.js/lib/browser/property-descriptor.js
function $d9497ea901ae627a$var$filterProperties(target, onProperties, ignoreProperties) {
    if (!ignoreProperties || ignoreProperties.length === 0) return onProperties;
    const tip = ignoreProperties.filter((ip)=>ip.target === target);
    if (tip.length === 0) return onProperties;
    const targetIgnoreProperties = tip[0].ignoreProperties;
    return onProperties.filter((op)=>targetIgnoreProperties.indexOf(op) === -1);
}
function $d9497ea901ae627a$var$patchFilteredProperties(target, onProperties, ignoreProperties, prototype) {
    if (!target) return;
    const filteredProperties = $d9497ea901ae627a$var$filterProperties(target, onProperties, ignoreProperties);
    $d9497ea901ae627a$var$patchOnProperties(target, filteredProperties, prototype);
}
function $d9497ea901ae627a$var$getOnEventNames(target) {
    return Object.getOwnPropertyNames(target).filter((name)=>name.startsWith("on") && name.length > 2).map((name)=>name.substring(2));
}
function $d9497ea901ae627a$var$propertyDescriptorPatch(api, _global2) {
    if ($d9497ea901ae627a$var$isNode && !$d9497ea901ae627a$var$isMix) return;
    if (Zone[api.symbol("patchEvents")]) return;
    const ignoreProperties = _global2["__Zone_ignore_on_properties"];
    let patchTargets = [];
    if ($d9497ea901ae627a$var$isBrowser) {
        const internalWindow2 = window;
        patchTargets = patchTargets.concat([
            "Document",
            "SVGElement",
            "Element",
            "HTMLElement",
            "HTMLBodyElement",
            "HTMLMediaElement",
            "HTMLFrameSetElement",
            "HTMLFrameElement",
            "HTMLIFrameElement",
            "HTMLMarqueeElement",
            "Worker"
        ]);
        $d9497ea901ae627a$var$patchFilteredProperties(internalWindow2, $d9497ea901ae627a$var$getOnEventNames(internalWindow2), ignoreProperties, $d9497ea901ae627a$var$ObjectGetPrototypeOf(internalWindow2));
    }
    patchTargets = patchTargets.concat([
        "XMLHttpRequest",
        "XMLHttpRequestEventTarget",
        "IDBIndex",
        "IDBRequest",
        "IDBOpenDBRequest",
        "IDBDatabase",
        "IDBTransaction",
        "IDBCursor",
        "WebSocket"
    ]);
    for(let i = 0; i < patchTargets.length; i++){
        const target = _global2[patchTargets[i]];
        (target == null ? void 0 : target.prototype) && $d9497ea901ae627a$var$patchFilteredProperties(target.prototype, $d9497ea901ae627a$var$getOnEventNames(target.prototype), ignoreProperties);
    }
}
// packages/zone.js/lib/browser/browser.js
function $d9497ea901ae627a$var$patchBrowser(Zone3) {
    Zone3.__load_patch("timers", (global2)=>{
        const set = "set";
        const clear = "clear";
        $d9497ea901ae627a$var$patchTimer(global2, set, clear, "Timeout");
        $d9497ea901ae627a$var$patchTimer(global2, set, clear, "Interval");
        $d9497ea901ae627a$var$patchTimer(global2, set, clear, "Immediate");
    });
    Zone3.__load_patch("requestAnimationFrame", (global2)=>{
        $d9497ea901ae627a$var$patchTimer(global2, "request", "cancel", "AnimationFrame");
        $d9497ea901ae627a$var$patchTimer(global2, "mozRequest", "mozCancel", "AnimationFrame");
        $d9497ea901ae627a$var$patchTimer(global2, "webkitRequest", "webkitCancel", "AnimationFrame");
    });
    Zone3.__load_patch("blocking", (global2, Zone4)=>{
        const blockingMethods = [
            "alert",
            "prompt",
            "confirm"
        ];
        for(let i = 0; i < blockingMethods.length; i++){
            const name = blockingMethods[i];
            $d9497ea901ae627a$var$patchMethod(global2, name, (delegate, symbol, name2)=>{
                return function(s, args) {
                    return Zone4.current.run(delegate, global2, args, name2);
                };
            });
        }
    });
    Zone3.__load_patch("EventTarget", (global2, Zone4, api)=>{
        $d9497ea901ae627a$var$patchEvent(global2, api);
        $d9497ea901ae627a$var$eventTargetPatch(global2, api);
        const XMLHttpRequestEventTarget = global2["XMLHttpRequestEventTarget"];
        if (XMLHttpRequestEventTarget && XMLHttpRequestEventTarget.prototype) api.patchEventTarget(global2, api, [
            XMLHttpRequestEventTarget.prototype
        ]);
    });
    Zone3.__load_patch("MutationObserver", (global2, Zone4, api)=>{
        $d9497ea901ae627a$var$patchClass("MutationObserver");
        $d9497ea901ae627a$var$patchClass("WebKitMutationObserver");
    });
    Zone3.__load_patch("IntersectionObserver", (global2, Zone4, api)=>{
        $d9497ea901ae627a$var$patchClass("IntersectionObserver");
    });
    Zone3.__load_patch("FileReader", (global2, Zone4, api)=>{
        $d9497ea901ae627a$var$patchClass("FileReader");
    });
    Zone3.__load_patch("on_property", (global2, Zone4, api)=>{
        $d9497ea901ae627a$var$propertyDescriptorPatch(api, global2);
    });
    Zone3.__load_patch("customElements", (global2, Zone4, api)=>{
        $d9497ea901ae627a$var$patchCustomElements(global2, api);
    });
    Zone3.__load_patch("XHR", (global2, Zone4)=>{
        patchXHR(global2);
        const XHR_TASK = $d9497ea901ae627a$var$zoneSymbol("xhrTask");
        const XHR_SYNC = $d9497ea901ae627a$var$zoneSymbol("xhrSync");
        const XHR_LISTENER = $d9497ea901ae627a$var$zoneSymbol("xhrListener");
        const XHR_SCHEDULED = $d9497ea901ae627a$var$zoneSymbol("xhrScheduled");
        const XHR_URL = $d9497ea901ae627a$var$zoneSymbol("xhrURL");
        const XHR_ERROR_BEFORE_SCHEDULED = $d9497ea901ae627a$var$zoneSymbol("xhrErrorBeforeScheduled");
        function patchXHR(window2) {
            const XMLHttpRequest = window2["XMLHttpRequest"];
            if (!XMLHttpRequest) return;
            const XMLHttpRequestPrototype = XMLHttpRequest.prototype;
            function findPendingTask(target) {
                return target[XHR_TASK];
            }
            let oriAddListener = XMLHttpRequestPrototype[$d9497ea901ae627a$var$ZONE_SYMBOL_ADD_EVENT_LISTENER];
            let oriRemoveListener = XMLHttpRequestPrototype[$d9497ea901ae627a$var$ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
            if (!oriAddListener) {
                const XMLHttpRequestEventTarget = window2["XMLHttpRequestEventTarget"];
                if (XMLHttpRequestEventTarget) {
                    const XMLHttpRequestEventTargetPrototype = XMLHttpRequestEventTarget.prototype;
                    oriAddListener = XMLHttpRequestEventTargetPrototype[$d9497ea901ae627a$var$ZONE_SYMBOL_ADD_EVENT_LISTENER];
                    oriRemoveListener = XMLHttpRequestEventTargetPrototype[$d9497ea901ae627a$var$ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
                }
            }
            const READY_STATE_CHANGE = "readystatechange";
            const SCHEDULED = "scheduled";
            function scheduleTask(task) {
                const data = task.data;
                const target = data.target;
                target[XHR_SCHEDULED] = false;
                target[XHR_ERROR_BEFORE_SCHEDULED] = false;
                const listener = target[XHR_LISTENER];
                if (!oriAddListener) {
                    oriAddListener = target[$d9497ea901ae627a$var$ZONE_SYMBOL_ADD_EVENT_LISTENER];
                    oriRemoveListener = target[$d9497ea901ae627a$var$ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
                }
                if (listener) oriRemoveListener.call(target, READY_STATE_CHANGE, listener);
                const newListener = target[XHR_LISTENER] = ()=>{
                    if (target.readyState === target.DONE) {
                        if (!data.aborted && target[XHR_SCHEDULED] && task.state === SCHEDULED) {
                            const loadTasks = target[Zone4.__symbol__("loadfalse")];
                            if (target.status !== 0 && loadTasks && loadTasks.length > 0) {
                                const oriInvoke = task.invoke;
                                task.invoke = function() {
                                    const loadTasks2 = target[Zone4.__symbol__("loadfalse")];
                                    for(let i = 0; i < loadTasks2.length; i++)if (loadTasks2[i] === task) loadTasks2.splice(i, 1);
                                    if (!data.aborted && task.state === SCHEDULED) oriInvoke.call(task);
                                };
                                loadTasks.push(task);
                            } else task.invoke();
                        } else if (!data.aborted && target[XHR_SCHEDULED] === false) target[XHR_ERROR_BEFORE_SCHEDULED] = true;
                    }
                };
                oriAddListener.call(target, READY_STATE_CHANGE, newListener);
                const storedTask = target[XHR_TASK];
                if (!storedTask) target[XHR_TASK] = task;
                sendNative.apply(target, data.args);
                target[XHR_SCHEDULED] = true;
                return task;
            }
            function placeholderCallback() {}
            function clearTask(task) {
                const data = task.data;
                data.aborted = true;
                return abortNative.apply(data.target, data.args);
            }
            const openNative = $d9497ea901ae627a$var$patchMethod(XMLHttpRequestPrototype, "open", ()=>function(self2, args) {
                    self2[XHR_SYNC] = args[2] == false;
                    self2[XHR_URL] = args[1];
                    return openNative.apply(self2, args);
                });
            const XMLHTTPREQUEST_SOURCE = "XMLHttpRequest.send";
            const fetchTaskAborting = $d9497ea901ae627a$var$zoneSymbol("fetchTaskAborting");
            const fetchTaskScheduling = $d9497ea901ae627a$var$zoneSymbol("fetchTaskScheduling");
            const sendNative = $d9497ea901ae627a$var$patchMethod(XMLHttpRequestPrototype, "send", ()=>function(self2, args) {
                    if (Zone4.current[fetchTaskScheduling] === true) return sendNative.apply(self2, args);
                    if (self2[XHR_SYNC]) return sendNative.apply(self2, args);
                    else {
                        const options = {
                            target: self2,
                            url: self2[XHR_URL],
                            isPeriodic: false,
                            args: args,
                            aborted: false
                        };
                        const task = $d9497ea901ae627a$var$scheduleMacroTaskWithCurrentZone(XMLHTTPREQUEST_SOURCE, placeholderCallback, options, scheduleTask, clearTask);
                        if (self2 && self2[XHR_ERROR_BEFORE_SCHEDULED] === true && !options.aborted && task.state === SCHEDULED) task.invoke();
                    }
                });
            const abortNative = $d9497ea901ae627a$var$patchMethod(XMLHttpRequestPrototype, "abort", ()=>function(self2, args) {
                    const task = findPendingTask(self2);
                    if (task && typeof task.type == "string") {
                        if (task.cancelFn == null || task.data && task.data.aborted) return;
                        task.zone.cancelTask(task);
                    } else if (Zone4.current[fetchTaskAborting] === true) return abortNative.apply(self2, args);
                });
        }
    });
    Zone3.__load_patch("geolocation", (global2)=>{
        if (global2["navigator"] && global2["navigator"].geolocation) $d9497ea901ae627a$var$patchPrototype(global2["navigator"].geolocation, [
            "getCurrentPosition",
            "watchPosition"
        ]);
    });
    Zone3.__load_patch("PromiseRejectionEvent", (global2, Zone4)=>{
        function findPromiseRejectionHandler(evtName) {
            return function(e) {
                const eventTasks = $d9497ea901ae627a$var$findEventTasks(global2, evtName);
                eventTasks.forEach((eventTask)=>{
                    const PromiseRejectionEvent = global2["PromiseRejectionEvent"];
                    if (PromiseRejectionEvent) {
                        const evt = new PromiseRejectionEvent(evtName, {
                            promise: e.promise,
                            reason: e.rejection
                        });
                        eventTask.invoke(evt);
                    }
                });
            };
        }
        if (global2["PromiseRejectionEvent"]) {
            Zone4[$d9497ea901ae627a$var$zoneSymbol("unhandledPromiseRejectionHandler")] = findPromiseRejectionHandler("unhandledrejection");
            Zone4[$d9497ea901ae627a$var$zoneSymbol("rejectionHandledHandler")] = findPromiseRejectionHandler("rejectionhandled");
        }
    });
    Zone3.__load_patch("queueMicrotask", (global2, Zone4, api)=>{
        $d9497ea901ae627a$var$patchQueueMicrotask(global2, api);
    });
}
// packages/zone.js/lib/common/promise.js
function $d9497ea901ae627a$var$patchPromise(Zone3) {
    Zone3.__load_patch("ZoneAwarePromise", (global2, Zone4, api)=>{
        const ObjectGetOwnPropertyDescriptor2 = Object.getOwnPropertyDescriptor;
        const ObjectDefineProperty2 = Object.defineProperty;
        function readableObjectToString(obj) {
            if (obj && obj.toString === Object.prototype.toString) {
                const className = obj.constructor && obj.constructor.name;
                return (className ? className : "") + ": " + JSON.stringify(obj);
            }
            return obj ? obj.toString() : Object.prototype.toString.call(obj);
        }
        const __symbol__2 = api.symbol;
        const _uncaughtPromiseErrors = [];
        const isDisableWrappingUncaughtPromiseRejection = global2[__symbol__2("DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION")] !== false;
        const symbolPromise = __symbol__2("Promise");
        const symbolThen = __symbol__2("then");
        const creationTrace = "__creationTrace__";
        api.onUnhandledError = (e)=>{
            if (api.showUncaughtError()) {
                const rejection = e && e.rejection;
                if (rejection) console.error("Unhandled Promise rejection:", rejection instanceof Error ? rejection.message : rejection, "; Zone:", e.zone.name, "; Task:", e.task && e.task.source, "; Value:", rejection, rejection instanceof Error ? rejection.stack : void 0);
                else console.error(e);
            }
        };
        api.microtaskDrainDone = ()=>{
            while(_uncaughtPromiseErrors.length){
                const uncaughtPromiseError = _uncaughtPromiseErrors.shift();
                try {
                    uncaughtPromiseError.zone.runGuarded(()=>{
                        if (uncaughtPromiseError.throwOriginal) throw uncaughtPromiseError.rejection;
                        throw uncaughtPromiseError;
                    });
                } catch (error) {
                    handleUnhandledRejection(error);
                }
            }
        };
        const UNHANDLED_PROMISE_REJECTION_HANDLER_SYMBOL = __symbol__2("unhandledPromiseRejectionHandler");
        function handleUnhandledRejection(e) {
            api.onUnhandledError(e);
            try {
                const handler = Zone4[UNHANDLED_PROMISE_REJECTION_HANDLER_SYMBOL];
                if (typeof handler === "function") handler.call(this, e);
            } catch (err) {}
        }
        function isThenable(value) {
            return value && typeof value.then === "function";
        }
        function forwardResolution(value) {
            return value;
        }
        function forwardRejection(rejection) {
            return ZoneAwarePromise.reject(rejection);
        }
        const symbolState = __symbol__2("state");
        const symbolValue = __symbol__2("value");
        const symbolFinally = __symbol__2("finally");
        const symbolParentPromiseValue = __symbol__2("parentPromiseValue");
        const symbolParentPromiseState = __symbol__2("parentPromiseState");
        const source = "Promise.then";
        const UNRESOLVED = null;
        const RESOLVED = true;
        const REJECTED = false;
        const REJECTED_NO_CATCH = 0;
        function makeResolver(promise, state) {
            return (v)=>{
                try {
                    resolvePromise(promise, state, v);
                } catch (err) {
                    resolvePromise(promise, false, err);
                }
            };
        }
        const once = function() {
            let wasCalled = false;
            return function wrapper(wrappedFunction) {
                return function() {
                    if (wasCalled) return;
                    wasCalled = true;
                    wrappedFunction.apply(null, arguments);
                };
            };
        };
        const TYPE_ERROR = "Promise resolved with itself";
        const CURRENT_TASK_TRACE_SYMBOL = __symbol__2("currentTaskTrace");
        function resolvePromise(promise, state, value) {
            const onceWrapper = once();
            if (promise === value) throw new TypeError(TYPE_ERROR);
            if (promise[symbolState] === UNRESOLVED) {
                let then = null;
                try {
                    if (typeof value === "object" || typeof value === "function") then = value && value.then;
                } catch (err) {
                    onceWrapper(()=>{
                        resolvePromise(promise, false, err);
                    })();
                    return promise;
                }
                if (state !== REJECTED && value instanceof ZoneAwarePromise && value.hasOwnProperty(symbolState) && value.hasOwnProperty(symbolValue) && value[symbolState] !== UNRESOLVED) {
                    clearRejectedNoCatch(value);
                    resolvePromise(promise, value[symbolState], value[symbolValue]);
                } else if (state !== REJECTED && typeof then === "function") try {
                    then.call(value, onceWrapper(makeResolver(promise, state)), onceWrapper(makeResolver(promise, false)));
                } catch (err) {
                    onceWrapper(()=>{
                        resolvePromise(promise, false, err);
                    })();
                }
                else {
                    promise[symbolState] = state;
                    const queue = promise[symbolValue];
                    promise[symbolValue] = value;
                    if (promise[symbolFinally] === symbolFinally) {
                        if (state === RESOLVED) {
                            promise[symbolState] = promise[symbolParentPromiseState];
                            promise[symbolValue] = promise[symbolParentPromiseValue];
                        }
                    }
                    if (state === REJECTED && value instanceof Error) {
                        const trace = Zone4.currentTask && Zone4.currentTask.data && Zone4.currentTask.data[creationTrace];
                        if (trace) ObjectDefineProperty2(value, CURRENT_TASK_TRACE_SYMBOL, {
                            configurable: true,
                            enumerable: false,
                            writable: true,
                            value: trace
                        });
                    }
                    for(let i = 0; i < queue.length;)scheduleResolveOrReject(promise, queue[i++], queue[i++], queue[i++], queue[i++]);
                    if (queue.length == 0 && state == REJECTED) {
                        promise[symbolState] = REJECTED_NO_CATCH;
                        let uncaughtPromiseError = value;
                        try {
                            throw new Error("Uncaught (in promise): " + readableObjectToString(value) + (value && value.stack ? "\n" + value.stack : ""));
                        } catch (err) {
                            uncaughtPromiseError = err;
                        }
                        if (isDisableWrappingUncaughtPromiseRejection) uncaughtPromiseError.throwOriginal = true;
                        uncaughtPromiseError.rejection = value;
                        uncaughtPromiseError.promise = promise;
                        uncaughtPromiseError.zone = Zone4.current;
                        uncaughtPromiseError.task = Zone4.currentTask;
                        _uncaughtPromiseErrors.push(uncaughtPromiseError);
                        api.scheduleMicroTask();
                    }
                }
            }
            return promise;
        }
        const REJECTION_HANDLED_HANDLER = __symbol__2("rejectionHandledHandler");
        function clearRejectedNoCatch(promise) {
            if (promise[symbolState] === REJECTED_NO_CATCH) {
                try {
                    const handler = Zone4[REJECTION_HANDLED_HANDLER];
                    if (handler && typeof handler === "function") handler.call(this, {
                        rejection: promise[symbolValue],
                        promise: promise
                    });
                } catch (err) {}
                promise[symbolState] = REJECTED;
                for(let i = 0; i < _uncaughtPromiseErrors.length; i++)if (promise === _uncaughtPromiseErrors[i].promise) _uncaughtPromiseErrors.splice(i, 1);
            }
        }
        function scheduleResolveOrReject(promise, zone, chainPromise, onFulfilled, onRejected) {
            clearRejectedNoCatch(promise);
            const promiseState = promise[symbolState];
            const delegate = promiseState ? typeof onFulfilled === "function" ? onFulfilled : forwardResolution : typeof onRejected === "function" ? onRejected : forwardRejection;
            zone.scheduleMicroTask(source, ()=>{
                try {
                    const parentPromiseValue = promise[symbolValue];
                    const isFinallyPromise = !!chainPromise && symbolFinally === chainPromise[symbolFinally];
                    if (isFinallyPromise) {
                        chainPromise[symbolParentPromiseValue] = parentPromiseValue;
                        chainPromise[symbolParentPromiseState] = promiseState;
                    }
                    const value = zone.run(delegate, void 0, isFinallyPromise && delegate !== forwardRejection && delegate !== forwardResolution ? [] : [
                        parentPromiseValue
                    ]);
                    resolvePromise(chainPromise, true, value);
                } catch (error) {
                    resolvePromise(chainPromise, false, error);
                }
            }, chainPromise);
        }
        const ZONE_AWARE_PROMISE_TO_STRING = "function ZoneAwarePromise() { [native code] }";
        const noop = function() {};
        const AggregateError = global2.AggregateError;
        class ZoneAwarePromise {
            static toString() {
                return ZONE_AWARE_PROMISE_TO_STRING;
            }
            static resolve(value) {
                if (value instanceof ZoneAwarePromise) return value;
                return resolvePromise(new this(null), RESOLVED, value);
            }
            static reject(error) {
                return resolvePromise(new this(null), REJECTED, error);
            }
            static withResolvers() {
                const result = {};
                result.promise = new ZoneAwarePromise((res, rej)=>{
                    result.resolve = res;
                    result.reject = rej;
                });
                return result;
            }
            static any(values) {
                if (!values || typeof values[Symbol.iterator] !== "function") return Promise.reject(new AggregateError([], "All promises were rejected"));
                const promises = [];
                let count = 0;
                try {
                    for (let v of values){
                        count++;
                        promises.push(ZoneAwarePromise.resolve(v));
                    }
                } catch (err) {
                    return Promise.reject(new AggregateError([], "All promises were rejected"));
                }
                if (count === 0) return Promise.reject(new AggregateError([], "All promises were rejected"));
                let finished = false;
                const errors = [];
                return new ZoneAwarePromise((resolve, reject)=>{
                    for(let i = 0; i < promises.length; i++)promises[i].then((v)=>{
                        if (finished) return;
                        finished = true;
                        resolve(v);
                    }, (err)=>{
                        errors.push(err);
                        count--;
                        if (count === 0) {
                            finished = true;
                            reject(new AggregateError(errors, "All promises were rejected"));
                        }
                    });
                });
            }
            static race(values) {
                let resolve;
                let reject;
                let promise = new this((res, rej)=>{
                    resolve = res;
                    reject = rej;
                });
                function onResolve(value) {
                    resolve(value);
                }
                function onReject(error) {
                    reject(error);
                }
                for (let value of values){
                    if (!isThenable(value)) value = this.resolve(value);
                    value.then(onResolve, onReject);
                }
                return promise;
            }
            static all(values) {
                return ZoneAwarePromise.allWithCallback(values);
            }
            static allSettled(values) {
                const P = this && this.prototype instanceof ZoneAwarePromise ? this : ZoneAwarePromise;
                return P.allWithCallback(values, {
                    thenCallback: (value)=>({
                            status: "fulfilled",
                            value: value
                        }),
                    errorCallback: (err)=>({
                            status: "rejected",
                            reason: err
                        })
                });
            }
            static allWithCallback(values, callback) {
                let resolve;
                let reject;
                let promise = new this((res, rej)=>{
                    resolve = res;
                    reject = rej;
                });
                let unresolvedCount = 2;
                let valueIndex = 0;
                const resolvedValues = [];
                for (let value of values){
                    if (!isThenable(value)) value = this.resolve(value);
                    const curValueIndex = valueIndex;
                    try {
                        value.then((value2)=>{
                            resolvedValues[curValueIndex] = callback ? callback.thenCallback(value2) : value2;
                            unresolvedCount--;
                            if (unresolvedCount === 0) resolve(resolvedValues);
                        }, (err)=>{
                            if (!callback) reject(err);
                            else {
                                resolvedValues[curValueIndex] = callback.errorCallback(err);
                                unresolvedCount--;
                                if (unresolvedCount === 0) resolve(resolvedValues);
                            }
                        });
                    } catch (thenErr) {
                        reject(thenErr);
                    }
                    unresolvedCount++;
                    valueIndex++;
                }
                unresolvedCount -= 2;
                if (unresolvedCount === 0) resolve(resolvedValues);
                return promise;
            }
            constructor(executor){
                const promise = this;
                if (!(promise instanceof ZoneAwarePromise)) throw new Error("Must be an instanceof Promise.");
                promise[symbolState] = UNRESOLVED;
                promise[symbolValue] = [];
                try {
                    const onceWrapper = once();
                    executor && executor(onceWrapper(makeResolver(promise, RESOLVED)), onceWrapper(makeResolver(promise, REJECTED)));
                } catch (error) {
                    resolvePromise(promise, false, error);
                }
            }
            get [Symbol.toStringTag]() {
                return "Promise";
            }
            get [Symbol.species]() {
                return ZoneAwarePromise;
            }
            then(onFulfilled, onRejected) {
                var _a;
                let C = (_a = this.constructor) == null ? void 0 : _a[Symbol.species];
                if (!C || typeof C !== "function") C = this.constructor || ZoneAwarePromise;
                const chainPromise = new C(noop);
                const zone = Zone4.current;
                if (this[symbolState] == UNRESOLVED) this[symbolValue].push(zone, chainPromise, onFulfilled, onRejected);
                else scheduleResolveOrReject(this, zone, chainPromise, onFulfilled, onRejected);
                return chainPromise;
            }
            catch(onRejected) {
                return this.then(null, onRejected);
            }
            finally(onFinally) {
                var _a;
                let C = (_a = this.constructor) == null ? void 0 : _a[Symbol.species];
                if (!C || typeof C !== "function") C = ZoneAwarePromise;
                const chainPromise = new C(noop);
                chainPromise[symbolFinally] = symbolFinally;
                const zone = Zone4.current;
                if (this[symbolState] == UNRESOLVED) this[symbolValue].push(zone, chainPromise, onFinally, onFinally);
                else scheduleResolveOrReject(this, zone, chainPromise, onFinally, onFinally);
                return chainPromise;
            }
        }
        ZoneAwarePromise["resolve"] = ZoneAwarePromise.resolve;
        ZoneAwarePromise["reject"] = ZoneAwarePromise.reject;
        ZoneAwarePromise["race"] = ZoneAwarePromise.race;
        ZoneAwarePromise["all"] = ZoneAwarePromise.all;
        const NativePromise = global2[symbolPromise] = global2["Promise"];
        global2["Promise"] = ZoneAwarePromise;
        const symbolThenPatched = __symbol__2("thenPatched");
        function patchThen(Ctor) {
            const proto = Ctor.prototype;
            const prop = ObjectGetOwnPropertyDescriptor2(proto, "then");
            if (prop && (prop.writable === false || !prop.configurable)) return;
            const originalThen = proto.then;
            proto[symbolThen] = originalThen;
            Ctor.prototype.then = function(onResolve, onReject) {
                const wrapped = new ZoneAwarePromise((resolve, reject)=>{
                    originalThen.call(this, resolve, reject);
                });
                return wrapped.then(onResolve, onReject);
            };
            Ctor[symbolThenPatched] = true;
        }
        api.patchThen = patchThen;
        function zoneify(fn) {
            return function(self2, args) {
                let resultPromise = fn.apply(self2, args);
                if (resultPromise instanceof ZoneAwarePromise) return resultPromise;
                let ctor = resultPromise.constructor;
                if (!ctor[symbolThenPatched]) patchThen(ctor);
                return resultPromise;
            };
        }
        if (NativePromise) {
            patchThen(NativePromise);
            $d9497ea901ae627a$var$patchMethod(global2, "fetch", (delegate)=>zoneify(delegate));
        }
        Promise[Zone4.__symbol__("uncaughtPromiseErrors")] = _uncaughtPromiseErrors;
        return ZoneAwarePromise;
    });
}
// packages/zone.js/lib/common/to-string.js
function $d9497ea901ae627a$var$patchToString(Zone3) {
    Zone3.__load_patch("toString", (global2)=>{
        const originalFunctionToString = Function.prototype.toString;
        const ORIGINAL_DELEGATE_SYMBOL = $d9497ea901ae627a$var$zoneSymbol("OriginalDelegate");
        const PROMISE_SYMBOL = $d9497ea901ae627a$var$zoneSymbol("Promise");
        const ERROR_SYMBOL = $d9497ea901ae627a$var$zoneSymbol("Error");
        const newFunctionToString = function toString() {
            if (typeof this === "function") {
                const originalDelegate = this[ORIGINAL_DELEGATE_SYMBOL];
                if (originalDelegate) {
                    if (typeof originalDelegate === "function") return originalFunctionToString.call(originalDelegate);
                    else return Object.prototype.toString.call(originalDelegate);
                }
                if (this === Promise) {
                    const nativePromise = global2[PROMISE_SYMBOL];
                    if (nativePromise) return originalFunctionToString.call(nativePromise);
                }
                if (this === Error) {
                    const nativeError = global2[ERROR_SYMBOL];
                    if (nativeError) return originalFunctionToString.call(nativeError);
                }
            }
            return originalFunctionToString.call(this);
        };
        newFunctionToString[ORIGINAL_DELEGATE_SYMBOL] = originalFunctionToString;
        Function.prototype.toString = newFunctionToString;
        const originalObjectToString = Object.prototype.toString;
        const PROMISE_OBJECT_TO_STRING = "[object Promise]";
        Object.prototype.toString = function() {
            if (typeof Promise === "function" && this instanceof Promise) return PROMISE_OBJECT_TO_STRING;
            return originalObjectToString.call(this);
        };
    });
}
// packages/zone.js/lib/browser/browser-util.js
function $d9497ea901ae627a$var$patchCallbacks(api, target, targetName, method, callbacks) {
    const symbol = Zone.__symbol__(method);
    if (target[symbol]) return;
    const nativeDelegate = target[symbol] = target[method];
    target[method] = function(name, opts, options) {
        if (opts && opts.prototype) callbacks.forEach(function(callback) {
            const source = `${targetName}.${method}::` + callback;
            const prototype = opts.prototype;
            try {
                if (prototype.hasOwnProperty(callback)) {
                    const descriptor = api.ObjectGetOwnPropertyDescriptor(prototype, callback);
                    if (descriptor && descriptor.value) {
                        descriptor.value = api.wrapWithCurrentZone(descriptor.value, source);
                        api._redefineProperty(opts.prototype, callback, descriptor);
                    } else if (prototype[callback]) prototype[callback] = api.wrapWithCurrentZone(prototype[callback], source);
                } else if (prototype[callback]) prototype[callback] = api.wrapWithCurrentZone(prototype[callback], source);
            } catch (e) {}
        });
        return nativeDelegate.call(target, name, opts, options);
    };
    api.attachOriginToPatched(target[method], nativeDelegate);
}
// packages/zone.js/lib/browser/api-util.js
function $d9497ea901ae627a$var$patchUtil(Zone3) {
    Zone3.__load_patch("util", (global2, Zone4, api)=>{
        const eventNames = $d9497ea901ae627a$var$getOnEventNames(global2);
        api.patchOnProperties = $d9497ea901ae627a$var$patchOnProperties;
        api.patchMethod = $d9497ea901ae627a$var$patchMethod;
        api.bindArguments = $d9497ea901ae627a$var$bindArguments;
        api.patchMacroTask = $d9497ea901ae627a$var$patchMacroTask;
        const SYMBOL_BLACK_LISTED_EVENTS = Zone4.__symbol__("BLACK_LISTED_EVENTS");
        const SYMBOL_UNPATCHED_EVENTS = Zone4.__symbol__("UNPATCHED_EVENTS");
        if (global2[SYMBOL_UNPATCHED_EVENTS]) global2[SYMBOL_BLACK_LISTED_EVENTS] = global2[SYMBOL_UNPATCHED_EVENTS];
        if (global2[SYMBOL_BLACK_LISTED_EVENTS]) Zone4[SYMBOL_BLACK_LISTED_EVENTS] = Zone4[SYMBOL_UNPATCHED_EVENTS] = global2[SYMBOL_BLACK_LISTED_EVENTS];
        api.patchEventPrototype = $d9497ea901ae627a$var$patchEventPrototype;
        api.patchEventTarget = $d9497ea901ae627a$var$patchEventTarget;
        api.ObjectDefineProperty = $d9497ea901ae627a$var$ObjectDefineProperty;
        api.ObjectGetOwnPropertyDescriptor = $d9497ea901ae627a$var$ObjectGetOwnPropertyDescriptor;
        api.ObjectCreate = $d9497ea901ae627a$var$ObjectCreate;
        api.ArraySlice = $d9497ea901ae627a$var$ArraySlice;
        api.patchClass = $d9497ea901ae627a$var$patchClass;
        api.wrapWithCurrentZone = $d9497ea901ae627a$var$wrapWithCurrentZone;
        api.filterProperties = $d9497ea901ae627a$var$filterProperties;
        api.attachOriginToPatched = $d9497ea901ae627a$var$attachOriginToPatched;
        api._redefineProperty = Object.defineProperty;
        api.patchCallbacks = $d9497ea901ae627a$var$patchCallbacks;
        api.getGlobalObjects = ()=>({
                globalSources: $d9497ea901ae627a$var$globalSources,
                zoneSymbolEventNames: $d9497ea901ae627a$var$zoneSymbolEventNames2,
                eventNames: eventNames,
                isBrowser: $d9497ea901ae627a$var$isBrowser,
                isMix: $d9497ea901ae627a$var$isMix,
                isNode: $d9497ea901ae627a$var$isNode,
                TRUE_STR: $d9497ea901ae627a$var$TRUE_STR,
                FALSE_STR: $d9497ea901ae627a$var$FALSE_STR,
                ZONE_SYMBOL_PREFIX: $d9497ea901ae627a$var$ZONE_SYMBOL_PREFIX,
                ADD_EVENT_LISTENER_STR: $d9497ea901ae627a$var$ADD_EVENT_LISTENER_STR,
                REMOVE_EVENT_LISTENER_STR: $d9497ea901ae627a$var$REMOVE_EVENT_LISTENER_STR
            });
    });
}
// packages/zone.js/lib/browser/rollup-common.js
function $d9497ea901ae627a$var$patchCommon(Zone3) {
    $d9497ea901ae627a$var$patchPromise(Zone3);
    $d9497ea901ae627a$var$patchToString(Zone3);
    $d9497ea901ae627a$var$patchUtil(Zone3);
}
// packages/zone.js/lib/browser/rollup-main.js
var $d9497ea901ae627a$var$Zone2 = $d9497ea901ae627a$var$loadZone();
$d9497ea901ae627a$var$patchCommon($d9497ea901ae627a$var$Zone2);
$d9497ea901ae627a$var$patchBrowser($d9497ea901ae627a$var$Zone2);




/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Enable instrumentations
 * @param instrumentations
 * @param tracerProvider
 * @param meterProvider
 */ function $c186d9cbf55f295f$export$56a6415128a54b1(instrumentations, tracerProvider, meterProvider, loggerProvider) {
    for(let i = 0, j = instrumentations.length; i < j; i++){
        const instrumentation = instrumentations[i];
        if (tracerProvider) instrumentation.setTracerProvider(tracerProvider);
        if (meterProvider) instrumentation.setMeterProvider(meterProvider);
        if (loggerProvider && instrumentation.setLoggerProvider) instrumentation.setLoggerProvider(loggerProvider);
        // instrumentations have been already enabled during creation
        // so enable only if user prevented that by setting enabled to false
        // this is to prevent double enabling but when calling register all
        // instrumentations should be now enabled
        if (!instrumentation.getConfig().enabled) instrumentation.enable();
    }
}
function $c186d9cbf55f295f$export$c7d87b302116dc69(instrumentations) {
    instrumentations.forEach((instrumentation)=>instrumentation.disable());
}


function $412e403263150e72$export$fc0a1ca5231d826a(options) {
    const tracerProvider = options.tracerProvider || (0, $496851d2cf78caa4$export$357889f174732d38).getTracerProvider();
    const meterProvider = options.meterProvider || (0, $b8db6f384fae8886$export$b0c5c2fac8144e54).getMeterProvider();
    const loggerProvider = options.loggerProvider || (0, $6d3371a0a865dabe$export$fa0831f497706bad).getLoggerProvider();
    const instrumentations = options.instrumentations?.flat() ?? [];
    (0, $c186d9cbf55f295f$export$56a6415128a54b1)(instrumentations, tracerProvider, meterProvider, loggerProvider);
    return ()=>{
        (0, $c186d9cbf55f295f$export$c7d87b302116dc69)(instrumentations);
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $ef6af0e9bef7148a$export$a756c21bf453f1b5 {
    _delegate;
    constructor(delegate){
        this._delegate = delegate;
    }
    /**
     * Export items.
     * @param items
     * @param resultCallback
     */ export(items, resultCallback) {
        this._delegate.export(items, resultCallback);
    }
    forceFlush() {
        return this._delegate.forceFlush();
    }
    shutdown() {
        return this._delegate.shutdown();
    }
}


function $9090c1a17d23b5ac$export$edd172c6c83c39cc(resource) {
    const result = {
        attributes: $9090c1a17d23b5ac$export$b6255b619acd6709(resource.attributes),
        droppedAttributesCount: 0
    };
    const schemaUrl = resource.schemaUrl;
    if (schemaUrl && schemaUrl !== '') result.schemaUrl = schemaUrl;
    return result;
}
function $9090c1a17d23b5ac$export$5a2377b8e90dd1bf(scope) {
    return {
        name: scope.name,
        version: scope.version
    };
}
function $9090c1a17d23b5ac$export$b6255b619acd6709(attributes) {
    return Object.keys(attributes).map((key)=>$9090c1a17d23b5ac$export$155f69accf533147(key, attributes[key]));
}
function $9090c1a17d23b5ac$export$155f69accf533147(key, value) {
    return {
        key: key,
        value: $9090c1a17d23b5ac$export$9544ab3c60b2d8ce(value)
    };
}
function $9090c1a17d23b5ac$export$9544ab3c60b2d8ce(value) {
    const t = typeof value;
    if (t === 'string') return {
        stringValue: value
    };
    if (t === 'number') {
        if (!Number.isInteger(value)) return {
            doubleValue: value
        };
        return {
            intValue: value
        };
    }
    if (t === 'boolean') return {
        boolValue: value
    };
    if (value instanceof Uint8Array) return {
        bytesValue: value
    };
    if (Array.isArray(value)) return {
        arrayValue: {
            values: value.map($9090c1a17d23b5ac$export$9544ab3c60b2d8ce)
        }
    };
    if (t === 'object' && value != null) return {
        kvlistValue: {
            values: Object.entries(value).map(([k, v])=>$9090c1a17d23b5ac$export$155f69accf533147(k, v))
        }
    };
    return {};
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $026bcd5069522885$var$intValue(charCode) {
    // 0-9
    if (charCode >= 48 && charCode <= 57) return charCode - 48;
    // a-f
    if (charCode >= 97 && charCode <= 102) return charCode - 87;
    // A-F
    return charCode - 55;
}
function $026bcd5069522885$export$f7e0d8803cecbdc0(hexStr) {
    const buf = new Uint8Array(hexStr.length / 2);
    let offset = 0;
    for(let i = 0; i < hexStr.length; i += 2){
        const hi = $026bcd5069522885$var$intValue(hexStr.charCodeAt(i));
        const lo = $026bcd5069522885$var$intValue(hexStr.charCodeAt(i + 1));
        buf[offset++] = hi << 4 | lo;
    }
    return buf;
}


function $3dd40681f773d237$export$93fd2c60d7ab39e5(hrTime) {
    const NANOSECONDS = BigInt(1000000000);
    return BigInt(Math.trunc(hrTime[0])) * NANOSECONDS + BigInt(Math.trunc(hrTime[1]));
}
function $3dd40681f773d237$export$25fa08d6f84e69de(value) {
    const low = Number(BigInt.asUintN(32, value));
    const high = Number(BigInt.asUintN(32, value >> BigInt(32)));
    return {
        low: low,
        high: high
    };
}
function $3dd40681f773d237$export$9aa1c44d160043e3(hrTime) {
    const nanos = $3dd40681f773d237$export$93fd2c60d7ab39e5(hrTime);
    return $3dd40681f773d237$export$25fa08d6f84e69de(nanos);
}
function $3dd40681f773d237$export$91e61e5f118af2ed(hrTime) {
    const nanos = $3dd40681f773d237$export$93fd2c60d7ab39e5(hrTime);
    return nanos.toString();
}
const $3dd40681f773d237$var$encodeTimestamp = typeof BigInt !== 'undefined' ? $3dd40681f773d237$export$91e61e5f118af2ed : (0, $02ed3a94ae5b2eb2$export$2d91441ae30ebcfc);
function $3dd40681f773d237$var$identity(value) {
    return value;
}
function $3dd40681f773d237$var$optionalHexToBinary(str) {
    if (str === undefined) return undefined;
    return (0, $026bcd5069522885$export$f7e0d8803cecbdc0)(str);
}
const $3dd40681f773d237$var$DEFAULT_ENCODER = {
    encodeHrTime: $3dd40681f773d237$export$9aa1c44d160043e3,
    encodeSpanContext: (0, $026bcd5069522885$export$f7e0d8803cecbdc0),
    encodeOptionalSpanContext: $3dd40681f773d237$var$optionalHexToBinary
};
function $3dd40681f773d237$export$2d50162b78680823(options) {
    if (options === undefined) return $3dd40681f773d237$var$DEFAULT_ENCODER;
    const useLongBits = options.useLongBits ?? true;
    const useHex = options.useHex ?? false;
    return {
        encodeHrTime: useLongBits ? $3dd40681f773d237$export$9aa1c44d160043e3 : $3dd40681f773d237$var$encodeTimestamp,
        encodeSpanContext: useHex ? $3dd40681f773d237$var$identity : (0, $026bcd5069522885$export$f7e0d8803cecbdc0),
        encodeOptionalSpanContext: useHex ? $3dd40681f773d237$var$identity : $3dd40681f773d237$var$optionalHexToBinary
    };
}


// Span flags constants matching the OTLP specification
const $bafc9bb3ebf00c5f$var$SPAN_FLAGS_CONTEXT_HAS_IS_REMOTE_MASK = 0x100;
const $bafc9bb3ebf00c5f$var$SPAN_FLAGS_CONTEXT_IS_REMOTE_MASK = 0x200;
/**
 * Builds the 32-bit span flags value combining the low 8-bit W3C TraceFlags
 * with the HAS_IS_REMOTE and IS_REMOTE bits according to the OTLP spec.
 */ function $bafc9bb3ebf00c5f$var$buildSpanFlagsFrom(traceFlags, isRemote) {
    // low 8 bits are W3C TraceFlags (e.g., sampled)
    let flags = traceFlags & 0xff | $bafc9bb3ebf00c5f$var$SPAN_FLAGS_CONTEXT_HAS_IS_REMOTE_MASK;
    if (isRemote) flags |= $bafc9bb3ebf00c5f$var$SPAN_FLAGS_CONTEXT_IS_REMOTE_MASK;
    return flags;
}
function $bafc9bb3ebf00c5f$export$8c81c8011901e012(span, encoder) {
    const ctx = span.spanContext();
    const status = span.status;
    const parentSpanId = span.parentSpanContext?.spanId ? encoder.encodeSpanContext(span.parentSpanContext?.spanId) : undefined;
    return {
        traceId: encoder.encodeSpanContext(ctx.traceId),
        spanId: encoder.encodeSpanContext(ctx.spanId),
        parentSpanId: parentSpanId,
        traceState: ctx.traceState?.serialize(),
        name: span.name,
        // Span kind is offset by 1 because the API does not define a value for unset
        kind: span.kind == null ? 0 : span.kind + 1,
        startTimeUnixNano: encoder.encodeHrTime(span.startTime),
        endTimeUnixNano: encoder.encodeHrTime(span.endTime),
        attributes: (0, $9090c1a17d23b5ac$export$b6255b619acd6709)(span.attributes),
        droppedAttributesCount: span.droppedAttributesCount,
        events: span.events.map((event)=>$bafc9bb3ebf00c5f$export$c0221297e49388cc(event, encoder)),
        droppedEventsCount: span.droppedEventsCount,
        status: {
            // API and proto enums share the same values
            code: status.code,
            message: status.message
        },
        links: span.links.map((link)=>$bafc9bb3ebf00c5f$export$d40a678c50e6f4f2(link, encoder)),
        droppedLinksCount: span.droppedLinksCount,
        flags: $bafc9bb3ebf00c5f$var$buildSpanFlagsFrom(ctx.traceFlags, span.parentSpanContext?.isRemote)
    };
}
function $bafc9bb3ebf00c5f$export$d40a678c50e6f4f2(link, encoder) {
    return {
        attributes: link.attributes ? (0, $9090c1a17d23b5ac$export$b6255b619acd6709)(link.attributes) : [],
        spanId: encoder.encodeSpanContext(link.context.spanId),
        traceId: encoder.encodeSpanContext(link.context.traceId),
        traceState: link.context.traceState?.serialize(),
        droppedAttributesCount: link.droppedAttributesCount || 0,
        flags: $bafc9bb3ebf00c5f$var$buildSpanFlagsFrom(link.context.traceFlags, link.context.isRemote)
    };
}
function $bafc9bb3ebf00c5f$export$c0221297e49388cc(timedEvent, encoder) {
    return {
        attributes: timedEvent.attributes ? (0, $9090c1a17d23b5ac$export$b6255b619acd6709)(timedEvent.attributes) : [],
        name: timedEvent.name,
        timeUnixNano: encoder.encodeHrTime(timedEvent.time),
        droppedAttributesCount: timedEvent.droppedAttributesCount || 0
    };
}
function $bafc9bb3ebf00c5f$export$4bd5e67fadfa9fe0(spans, options) {
    const encoder = (0, $3dd40681f773d237$export$2d50162b78680823)(options);
    return {
        resourceSpans: $bafc9bb3ebf00c5f$var$spanRecordsToResourceSpans(spans, encoder)
    };
}
function $bafc9bb3ebf00c5f$var$createResourceMap(readableSpans) {
    const resourceMap = new Map();
    for (const record of readableSpans){
        let ilsMap = resourceMap.get(record.resource);
        if (!ilsMap) {
            ilsMap = new Map();
            resourceMap.set(record.resource, ilsMap);
        }
        // TODO this is duplicated in basic tracer. Consolidate on a common helper in core
        const instrumentationScopeKey = `${record.instrumentationScope.name}@${record.instrumentationScope.version || ''}:${record.instrumentationScope.schemaUrl || ''}`;
        let records = ilsMap.get(instrumentationScopeKey);
        if (!records) {
            records = [];
            ilsMap.set(instrumentationScopeKey, records);
        }
        records.push(record);
    }
    return resourceMap;
}
function $bafc9bb3ebf00c5f$var$spanRecordsToResourceSpans(readableSpans, encoder) {
    const resourceMap = $bafc9bb3ebf00c5f$var$createResourceMap(readableSpans);
    const out = [];
    const entryIterator = resourceMap.entries();
    let entry = entryIterator.next();
    while(!entry.done){
        const [resource, ilmMap] = entry.value;
        const scopeResourceSpans = [];
        const ilmIterator = ilmMap.values();
        let ilmEntry = ilmIterator.next();
        while(!ilmEntry.done){
            const scopeSpans = ilmEntry.value;
            if (scopeSpans.length > 0) {
                const spans = scopeSpans.map((readableSpan)=>$bafc9bb3ebf00c5f$export$8c81c8011901e012(readableSpan, encoder));
                scopeResourceSpans.push({
                    scope: (0, $9090c1a17d23b5ac$export$5a2377b8e90dd1bf)(scopeSpans[0].instrumentationScope),
                    spans: spans,
                    schemaUrl: scopeSpans[0].instrumentationScope.schemaUrl
                });
            }
            ilmEntry = ilmIterator.next();
        }
        const processedResource = (0, $9090c1a17d23b5ac$export$edd172c6c83c39cc)(resource);
        const transformedSpans = {
            resource: processedResource,
            scopeSpans: scopeResourceSpans,
            schemaUrl: processedResource.schemaUrl
        };
        out.push(transformedSpans);
        entry = entryIterator.next();
    }
    return out;
}


const $604be5f4b909e111$export$dfba2b8376f2d3f5 = {
    serializeRequest: (arg)=>{
        const request = (0, $bafc9bb3ebf00c5f$export$4bd5e67fadfa9fe0)(arg, {
            useHex: true,
            useLongBits: false
        });
        const encoder = new TextEncoder();
        return encoder.encode(JSON.stringify(request));
    },
    deserializeResponse: (arg)=>{
        if (arg.length === 0) return {};
        const decoder = new TextDecoder();
        return JSON.parse(decoder.decode(arg));
    }
};


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
const $13990a785eb19d49$var$MAX_ATTEMPTS = 5;
const $13990a785eb19d49$var$INITIAL_BACKOFF = 1000;
const $13990a785eb19d49$var$MAX_BACKOFF = 5000;
const $13990a785eb19d49$var$BACKOFF_MULTIPLIER = 1.5;
const $13990a785eb19d49$var$JITTER = 0.2;
/**
 * Get a pseudo-random jitter that falls in the range of [-JITTER, +JITTER]
 */ function $13990a785eb19d49$var$getJitter() {
    return Math.random() * (2 * $13990a785eb19d49$var$JITTER) - $13990a785eb19d49$var$JITTER;
}
class $13990a785eb19d49$var$RetryingTransport {
    _transport;
    constructor(transport){
        this._transport = transport;
    }
    retry(data, timeoutMillis, inMillis) {
        return new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this._transport.send(data, timeoutMillis).then(resolve, reject);
            }, inMillis);
        });
    }
    async send(data, timeoutMillis) {
        let attempts = $13990a785eb19d49$var$MAX_ATTEMPTS;
        let nextBackoff = $13990a785eb19d49$var$INITIAL_BACKOFF;
        const deadline = Date.now() + timeoutMillis;
        let result = await this._transport.send(data, timeoutMillis);
        while(result.status === 'retryable' && attempts > 0){
            attempts--;
            // use maximum of computed backoff and 0 to avoid negative timeouts
            const backoff = Math.max(Math.min(nextBackoff * (1 + $13990a785eb19d49$var$getJitter()), $13990a785eb19d49$var$MAX_BACKOFF), 0);
            nextBackoff = nextBackoff * $13990a785eb19d49$var$BACKOFF_MULTIPLIER;
            const retryInMillis = result.retryInMillis ?? backoff;
            // return when expected retry time is after the export deadline.
            const remainingTimeoutMillis = deadline - Date.now();
            if (retryInMillis > remainingTimeoutMillis) {
                (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).info(`Export retry time ${Math.round(retryInMillis)}ms exceeds remaining timeout ${Math.round(remainingTimeoutMillis)}ms, not retrying further.`);
                return result;
            }
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).verbose(`Scheduling export retry in ${Math.round(retryInMillis)}ms`);
            result = await this.retry(data, remainingTimeoutMillis, retryInMillis);
        }
        if (result.status === 'success') (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).verbose(`Export succeeded after ${$13990a785eb19d49$var$MAX_ATTEMPTS - attempts} retry attempts.`);
        else if (result.status === 'retryable') (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).info(`Export failed after maximum retry attempts (${$13990a785eb19d49$var$MAX_ATTEMPTS}).`);
        else (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).info(`Export failed with non-retryable error: ${result.error}`);
        return result;
    }
    shutdown() {
        return this._transport.shutdown();
    }
}
function $13990a785eb19d49$export$2a8528aedd03b24e(options) {
    return new $13990a785eb19d49$var$RetryingTransport(options.transport);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
class $5cf098f56601da02$var$SendBeaconTransport {
    _params;
    constructor(params){
        this._params = params;
    }
    async send(data) {
        const blobType = (await this._params.headers())['Content-Type'];
        return new Promise((resolve)=>{
            if (navigator.sendBeacon(this._params.url, new Blob([
                data
            ], {
                type: blobType
            }))) {
                // no way to signal retry, treat everything as success
                (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).debug('SendBeacon success');
                resolve({
                    status: 'success'
                });
            } else resolve({
                status: 'failure',
                error: new Error('SendBeacon failed')
            });
        });
    }
    shutdown() {
    // Intentionally left empty, nothing to do.
    }
}
function $5cf098f56601da02$export$ef075750bfec2f31(parameters) {
    return new $5cf098f56601da02$var$SendBeaconTransport(parameters);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $685a2db24d35f739$var$BoundedQueueExportPromiseHandler {
    _concurrencyLimit;
    _sendingPromises = [];
    /**
     * @param concurrencyLimit maximum promises allowed in a queue at the same time.
     */ constructor(concurrencyLimit){
        this._concurrencyLimit = concurrencyLimit;
    }
    pushPromise(promise) {
        if (this.hasReachedLimit()) throw new Error('Concurrency Limit reached');
        this._sendingPromises.push(promise);
        const popPromise = ()=>{
            const index = this._sendingPromises.indexOf(promise);
            this._sendingPromises.splice(index, 1);
        };
        promise.then(popPromise, popPromise);
    }
    hasReachedLimit() {
        return this._sendingPromises.length >= this._concurrencyLimit;
    }
    async awaitAll() {
        await Promise.all(this._sendingPromises);
    }
}
function $685a2db24d35f739$export$1de3d1a6b8cb6545(options) {
    return new $685a2db24d35f739$var$BoundedQueueExportPromiseHandler(options.concurrencyLimit);
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for handling error
 */ class $7aabbb86f45ea095$export$26c718c16cda30c6 extends Error {
    code;
    name = 'OTLPExporterError';
    data;
    constructor(message, code, data){
        super(message);
        this.data = data;
        this.code = code;
    }
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $09b0270c3bf87ff5$var$isPartialSuccessResponse(response) {
    return Object.prototype.hasOwnProperty.call(response, 'partialSuccess');
}
function $09b0270c3bf87ff5$export$b6a88465884baecf() {
    return {
        handleResponse (response) {
            // Partial success MUST never be an empty object according the specification
            // see https://opentelemetry.io/docs/specs/otlp/#partial-success
            if (response == null || !$09b0270c3bf87ff5$var$isPartialSuccessResponse(response) || response.partialSuccess == null || Object.keys(response.partialSuccess).length === 0) return;
            (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn('Received Partial Success response:', JSON.stringify(response.partialSuccess));
        }
    };
}



class $bc097abe1f02f34c$var$OTLPExportDelegate {
    _diagLogger;
    _transport;
    _serializer;
    _responseHandler;
    _promiseQueue;
    _timeout;
    constructor(transport, serializer, responseHandler, promiseQueue, timeout){
        this._transport = transport;
        this._serializer = serializer;
        this._responseHandler = responseHandler;
        this._promiseQueue = promiseQueue;
        this._timeout = timeout;
        this._diagLogger = (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).createComponentLogger({
            namespace: 'OTLPExportDelegate'
        });
    }
    export(internalRepresentation, resultCallback) {
        this._diagLogger.debug('items to be sent', internalRepresentation);
        // don't do any work if too many exports are in progress.
        if (this._promiseQueue.hasReachedLimit()) {
            resultCallback({
                code: (0, $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1).FAILED,
                error: new Error('Concurrent export limit reached')
            });
            return;
        }
        const serializedRequest = this._serializer.serializeRequest(internalRepresentation);
        if (serializedRequest == null) {
            resultCallback({
                code: (0, $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1).FAILED,
                error: new Error('Nothing to send')
            });
            return;
        }
        this._promiseQueue.pushPromise(this._transport.send(serializedRequest, this._timeout).then((response)=>{
            if (response.status === 'success') {
                if (response.data != null) try {
                    this._responseHandler.handleResponse(this._serializer.deserializeResponse(response.data));
                } catch (e) {
                    this._diagLogger.warn('Export succeeded but could not deserialize response - is the response specification compliant?', e, response.data);
                }
                // No matter the response, we can consider the export still successful.
                resultCallback({
                    code: (0, $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1).SUCCESS
                });
                return;
            } else if (response.status === 'failure' && response.error) {
                resultCallback({
                    code: (0, $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1).FAILED,
                    error: response.error
                });
                return;
            } else if (response.status === 'retryable') resultCallback({
                code: (0, $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1).FAILED,
                error: response.error ?? new (0, $7aabbb86f45ea095$export$26c718c16cda30c6)('Export failed with retryable status')
            });
            else resultCallback({
                code: (0, $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1).FAILED,
                error: new (0, $7aabbb86f45ea095$export$26c718c16cda30c6)('Export failed with unknown error')
            });
        }, (reason)=>resultCallback({
                code: (0, $f3cb0785acfa889d$export$ee0fe4df4ef0f3a1).FAILED,
                error: reason
            })));
    }
    forceFlush() {
        return this._promiseQueue.awaitAll();
    }
    async shutdown() {
        this._diagLogger.debug('shutdown started');
        await this.forceFlush();
        this._transport.shutdown();
    }
}
function $bc097abe1f02f34c$export$40ae898156a6d951(components, settings) {
    return new $bc097abe1f02f34c$var$OTLPExportDelegate(components.transport, components.serializer, (0, $09b0270c3bf87ff5$export$b6a88465884baecf)(), components.promiseHandler, settings.timeout);
}


function $be797e04b4adb295$export$8874016870239da4(options, serializer, transport) {
    return (0, $bc097abe1f02f34c$export$40ae898156a6d951)({
        transport: transport,
        serializer: serializer,
        promiseHandler: (0, $685a2db24d35f739$export$1de3d1a6b8cb6545)(options)
    }, {
        timeout: options.timeoutMillis
    });
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $958bc8fb5bc50350$export$c678556b287f7838(statusCode) {
    return statusCode === 429 || statusCode === 502 || statusCode === 503 || statusCode === 504;
}
function $958bc8fb5bc50350$export$4e009558974ad065(retryAfter) {
    if (retryAfter == null) return undefined;
    const seconds = Number.parseInt(retryAfter, 10);
    if (Number.isInteger(seconds)) return seconds > 0 ? seconds * 1000 : -1;
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After#directives
    const delay = new Date(retryAfter).getTime() - Date.now();
    if (delay >= 0) return delay;
    return 0;
}


class $5407df0f70753998$var$FetchTransport {
    _parameters;
    constructor(parameters){
        this._parameters = parameters;
    }
    async send(data, timeoutMillis) {
        const abortController = new AbortController();
        const timeout = setTimeout(()=>abortController.abort(), timeoutMillis);
        try {
            const isBrowserEnvironment = !!globalThis.location;
            const url = new URL(this._parameters.url);
            const response = await fetch(url.href, {
                method: 'POST',
                headers: await this._parameters.headers(),
                body: data,
                signal: abortController.signal,
                keepalive: isBrowserEnvironment,
                mode: isBrowserEnvironment ? globalThis.location?.origin === url.origin ? 'same-origin' : 'cors' : 'no-cors'
            });
            if (response.status >= 200 && response.status <= 299) {
                (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).debug('response success');
                return {
                    status: 'success'
                };
            } else if ((0, $958bc8fb5bc50350$export$c678556b287f7838)(response.status)) {
                const retryAfter = response.headers.get('Retry-After');
                const retryInMillis = (0, $958bc8fb5bc50350$export$4e009558974ad065)(retryAfter);
                return {
                    status: 'retryable',
                    retryInMillis: retryInMillis
                };
            }
            return {
                status: 'failure',
                error: new Error('Fetch request failed with non-retryable status')
            };
        } catch (error) {
            if ($5407df0f70753998$var$isFetchNetworkErrorRetryable(error)) return {
                status: 'retryable',
                error: new Error('Fetch request encountered a network error', {
                    cause: error
                })
            };
            return {
                status: 'failure',
                error: new Error('Fetch request errored', {
                    cause: error
                })
            };
        } finally{
            clearTimeout(timeout);
        }
    }
    shutdown() {
    // Intentionally left empty, nothing to do.
    }
}
function $5407df0f70753998$export$9e4ae37cd458911c(parameters) {
    return new $5407df0f70753998$var$FetchTransport(parameters);
}
function $5407df0f70753998$var$isFetchNetworkErrorRetryable(error) {
    return error instanceof TypeError && !error.cause;
}


function $d4018dbe2131893d$export$6ca8051e58a2f94e(options, serializer) {
    return (0, $be797e04b4adb295$export$8874016870239da4)(options, serializer, (0, $13990a785eb19d49$export$2a8528aedd03b24e)({
        transport: (0, $5407df0f70753998$export$9e4ae37cd458911c)(options)
    }));
}
function $d4018dbe2131893d$export$5b68ba408d750db3(options, serializer) {
    return (0, $be797e04b4adb295$export$8874016870239da4)(options, serializer, (0, $13990a785eb19d49$export$2a8528aedd03b24e)({
        transport: (0, $5cf098f56601da02$export$ef075750bfec2f31)({
            url: options.url,
            headers: options.headers
        })
    }));
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $265b4634ac42e699$export$c7dc25f7ba3fe11a(timeoutMillis) {
    if (Number.isFinite(timeoutMillis) && timeoutMillis > 0) return timeoutMillis;
    throw new Error(`Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '${timeoutMillis}')`);
}
function $265b4634ac42e699$export$c37a46ab59261386(headers) {
    if (headers == null) return undefined;
    return async ()=>headers;
}
function $265b4634ac42e699$export$f0204f09cd0066b(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration) {
    return {
        timeoutMillis: $265b4634ac42e699$export$c7dc25f7ba3fe11a(userProvidedConfiguration.timeoutMillis ?? fallbackConfiguration.timeoutMillis ?? defaultConfiguration.timeoutMillis),
        concurrencyLimit: userProvidedConfiguration.concurrencyLimit ?? fallbackConfiguration.concurrencyLimit ?? defaultConfiguration.concurrencyLimit,
        compression: userProvidedConfiguration.compression ?? fallbackConfiguration.compression ?? defaultConfiguration.compression
    };
}
function $265b4634ac42e699$export$cd8c80b353c895f4() {
    return {
        timeoutMillis: 10000,
        concurrencyLimit: 30,
        compression: 'none'
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $fa634b3865a51535$export$4144cc9174bc6a0(partialHeaders) {
    const headers = {};
    Object.entries(partialHeaders ?? {}).forEach(([key, value])=>{
        if (typeof value !== 'undefined') headers[key] = String(value);
        else (0, $0006a4b399ea8ee4$export$c042e7c2f59bc046).warn(`Header "${key}" has invalid value (${value}) and will be ignored`);
    });
    return headers;
}


function $2e3f5d053382e22e$var$mergeHeaders(userProvidedHeaders, fallbackHeaders, defaultHeaders) {
    return async ()=>{
        const requiredHeaders = {
            ...await defaultHeaders()
        };
        const headers = {};
        // add fallback ones first
        if (fallbackHeaders != null) Object.assign(headers, await fallbackHeaders());
        // override with user-provided ones
        if (userProvidedHeaders != null) Object.assign(headers, (0, $fa634b3865a51535$export$4144cc9174bc6a0)(await userProvidedHeaders()));
        // override required ones.
        return Object.assign(headers, requiredHeaders);
    };
}
function $2e3f5d053382e22e$var$validateUserProvidedUrl(url) {
    if (url == null) return undefined;
    try {
        // NOTE: In non-browser environments, `globalThis.location` will be `undefined`.
        const base = globalThis.location?.href;
        return new URL(url, base).href;
    } catch  {
        throw new Error(`Configuration: Could not parse user-provided export URL: '${url}'`);
    }
}
function $2e3f5d053382e22e$export$dae543ef16d16f76(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration) {
    return {
        ...(0, $265b4634ac42e699$export$f0204f09cd0066b)(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration),
        headers: $2e3f5d053382e22e$var$mergeHeaders(userProvidedConfiguration.headers, fallbackConfiguration.headers, defaultConfiguration.headers),
        url: $2e3f5d053382e22e$var$validateUserProvidedUrl(userProvidedConfiguration.url) ?? fallbackConfiguration.url ?? defaultConfiguration.url
    };
}
function $2e3f5d053382e22e$export$ed5dc921e0200ace(requiredHeaders, signalResourcePath) {
    return {
        ...(0, $265b4634ac42e699$export$cd8c80b353c895f4)(),
        headers: async ()=>requiredHeaders,
        url: 'http://localhost:4318/' + signalResourcePath
    };
}


/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $a9803136ef406769$export$204793d8eaaae015(config) {
    if (typeof config.headers === 'function') return config.headers;
    return (0, $265b4634ac42e699$export$c37a46ab59261386)(config.headers);
}


function $0bd74c2c64e72fa1$export$816c85190fdd0ca8(config, signalResourcePath, requiredHeaders) {
    return (0, $2e3f5d053382e22e$export$dae543ef16d16f76)({
        url: config.url,
        timeoutMillis: config.timeoutMillis,
        headers: (0, $a9803136ef406769$export$204793d8eaaae015)(config),
        concurrencyLimit: config.concurrencyLimit
    }, {}, (0, $2e3f5d053382e22e$export$ed5dc921e0200ace)(requiredHeaders, signalResourcePath));
}


function $797afe353fd8f389$export$f0b482136e1f7b30(config, serializer, signalResourcePath, requiredHeaders) {
    const createOtlpExportDelegate = $797afe353fd8f389$export$20dd511f645ec088(config.headers);
    const options = (0, $0bd74c2c64e72fa1$export$816c85190fdd0ca8)(config, signalResourcePath, requiredHeaders);
    return createOtlpExportDelegate(options, serializer);
}
function $797afe353fd8f389$export$20dd511f645ec088(configHeaders) {
    if (!configHeaders && typeof navigator.sendBeacon === 'function') return 0, $d4018dbe2131893d$export$5b68ba408d750db3;
    return 0, $d4018dbe2131893d$export$6ca8051e58a2f94e;
}


class $50e24aa04678c249$export$f73dc942b4b27de3 extends (0, $ef6af0e9bef7148a$export$a756c21bf453f1b5) {
    constructor(config = {}){
        super((0, $797afe353fd8f389$export$f0b482136e1f7b30)(config, (0, $604be5f4b909e111$export$dfba2b8376f2d3f5), 'v1/traces', {
            'Content-Type': 'application/json'
        }));
    }
}



const $22a616a3f3bc000e$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $22a616a3f3bc000e$export$2e2bcd8739ae039 = {
    randomUUID: $22a616a3f3bc000e$var$randomUUID
};


let $9fcb5dcab6a2d3da$var$getRandomValues;
const $9fcb5dcab6a2d3da$var$rnds8 = new Uint8Array(16);
function $9fcb5dcab6a2d3da$export$2e2bcd8739ae039() {
    if (!$9fcb5dcab6a2d3da$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $9fcb5dcab6a2d3da$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $9fcb5dcab6a2d3da$var$getRandomValues($9fcb5dcab6a2d3da$var$rnds8);
}


var $3671f3031881591e$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $52d713fa7bd02880$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $3671f3031881591e$export$2e2bcd8739ae039).test(uuid);
}
var $52d713fa7bd02880$export$2e2bcd8739ae039 = $52d713fa7bd02880$var$validate;


const $65f395b47d38ebfb$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$65f395b47d38ebfb$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $65f395b47d38ebfb$export$8fb373d660548968(arr, offset = 0) {
    return ($65f395b47d38ebfb$var$byteToHex[arr[offset + 0]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 1]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 2]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 3]] + '-' + $65f395b47d38ebfb$var$byteToHex[arr[offset + 4]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 5]] + '-' + $65f395b47d38ebfb$var$byteToHex[arr[offset + 6]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 7]] + '-' + $65f395b47d38ebfb$var$byteToHex[arr[offset + 8]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 9]] + '-' + $65f395b47d38ebfb$var$byteToHex[arr[offset + 10]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 11]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 12]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 13]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 14]] + $65f395b47d38ebfb$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $65f395b47d38ebfb$var$stringify(arr, offset = 0) {
    const uuid = $65f395b47d38ebfb$export$8fb373d660548968(arr, offset);
    if (!(0, $52d713fa7bd02880$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $65f395b47d38ebfb$export$2e2bcd8739ae039 = $65f395b47d38ebfb$var$stringify;


function $3db8eca5d6d2d662$var$_v4(options, buf, offset) {
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $9fcb5dcab6a2d3da$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $65f395b47d38ebfb$export$8fb373d660548968)(rnds);
}
function $3db8eca5d6d2d662$var$v4(options, buf, offset) {
    if ((0, $22a616a3f3bc000e$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $22a616a3f3bc000e$export$2e2bcd8739ae039).randomUUID();
    return $3db8eca5d6d2d662$var$_v4(options, buf, offset);
}
var $3db8eca5d6d2d662$export$2e2bcd8739ae039 = $3db8eca5d6d2d662$var$v4;


const $14ba2733203cd541$var$otlpExporter = new (0, $50e24aa04678c249$export$f73dc942b4b27de3)({
    url: "https://monitoring.parat-api.rodekors.dk:4318/v1/traces",
    headers: {
        "Content-Type": "application/json"
    },
    httpAgentOptions: {
        keepAlive: true
    },
    timeoutMillis: 50000
});
const $14ba2733203cd541$var$provider = new (0, $63a533b9ee75e32f$export$a785009afeee3453)({
    resource: (0, $34b7feab81bdb448$export$bb0fe4e7060febbf)({
        "service.name": "RK Parat Universal Link",
        "deployment.environment": "Prod",
        "session.id": (0, $3db8eca5d6d2d662$export$2e2bcd8739ae039)()
    }),
    spanProcessors: [
        new (0, $6387aa3fe0aa015a$export$237547059fd543f9)($14ba2733203cd541$var$otlpExporter, {
            maxQueueSize: 1000,
            scheduledDelayMillis: 2000
        })
    ]
});
$14ba2733203cd541$var$provider.register({
    // Changing default contextManager to use ZoneContextManager - supports asynchronous operations - optional
    contextManager: new (0, $89c185efeb78c80b$export$148434e42b84e81c)()
});
// Registering instrumentations
(0, $412e403263150e72$export$fc0a1ca5231d826a)({
    instrumentations: [
        new (0, $f8d3747903d55f9c$export$381e8ef2e310d2c3)()
    ]
});


//# sourceMappingURL=otl.b578f66b.js.map
